import { Response } from '@angular/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { IrFieldsService } from '../../shared/services/ir-fields.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { EesDesService } from '../../shared/services/ees-des.service';
@Component({
  selector: 'app-generic-beforediv-list', templateUrl: './generic-beforediv-list.component.html', styleUrls: ['./generic-beforediv-list.component.scss'],
  providers:[CompanySetupService,WebServiceService]

})
export class GenericBeforedivListComponent implements OnInit {
  @Input() divDetails: any;
  @Output()
  sendAction = new EventEmitter()
  commonVariableList: any = { "divList": [],meta_list:[] };
  company_setup: any = {};
  head_title:any='' 
  user_message:any=''
  stillLoading:boolean=false;
  irn_to_grn: any;
  irn_inv_date: any;
  irn_inv_no: any;
  irn_remarks: any;
  constructor(public eesdesService:EesDesService,private toasterService: ToasterService, private webService: WebServiceService, public irFields: IrFieldsService, public comanySetup:CompanySetupService) {
  }
  page_url:any=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  headClass:any='dangr'
  userInfo:any='dangr'
  country_data:any={}
  monthList:any = [];
  searchMonth:any = "";
  setup:any={}

  showAvailableBudget:boolean=true;
  showAmounts:boolean=true;

  ngOnInit() {
    let t:any={};
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    //console.log(t);
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }
    if (this.divDetails.data) {
      this.setup=this.divDetails.setup?this.divDetails.setup:{}
      this.setup.is_setup=this.divDetails.is_setup?this.divDetails.is_setup:false;
      this.apiCall();
    }
  }
  apiCall() {
    this.commonVariableList.divList = [];
    this.commonVariableList.meta_list=[];
    this.head_title='';
    if(this.setup.is_setup)
    {
      this.setSetupData(this.setup);
    }
    else
    {
    this.GetCompanySetUpData();
    }
  }
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '')
    {
      return false;
    }
    let req = {
    }
    this.company_setup = {}
    this.stillLoading=true;
    this.company_setup.invoice_item_columnList =[];
    this.company_setup.po_adhoc_advance_payment = [];
    this.company_setup.quotation_management_master_column_list = [];
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status)
        {
          this.setSetupData(data.response);
        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }
this.stillLoading=false;
      }, error => {
        this.stillLoading=false;

        this.toasterService.pop("error", "Error", "Something Went Wrong");

      }
    )
  }
  linkType : any = "";
  po_type_list : any = [];
  setSetupData(data)
  {
    // this.company_setup = {}
    this.company_setup.subject = {'text':'','is_visible_in_po':false,'custom_name':''}
    this.company_setup.po_note = {'text':'','is_visible_in_po':false,'custom_name':''}
    this.company_setup.reference = {'text':'','is_visible_in_po':false,'custom_name':''}
    this.stillLoading=true;
    this.company_setup.invoice_item_columnList =[];
    this.company_setup.po_adhoc_advance_payment = [];
      this.company_setup = data ? data : {}
      this.company_setup.pan_na_msg=this.company_setup.pan_na_msg?this.company_setup.pan_na_msg:''
      this.company_setup.is_popup_visible_debit_note_approval_time=this.company_setup.is_popup_visible_debit_note_approval_time?this.company_setup.is_popup_visible_debit_note_approval_time:'0'
      this.company_setup.in_invoice_message_when_debit_note_is_there=this.company_setup.in_invoice_message_when_debit_note_is_there?this.company_setup.in_invoice_message_when_debit_note_is_there:'Debit Note is being raised due to quantity/ price difference. Please communicate with your vendor'
      this.company_setup.in_invoice_hold_payment_visible=this.company_setup.in_invoice_hold_payment_visible?this.company_setup.in_invoice_hold_payment_visible:'0'
      this.company_setup.is_hold_gst_checkbox_visible=this.company_setup.is_hold_gst_checkbox_visible?this.company_setup.is_hold_gst_checkbox_visible:'0'
      this.company_setup.po_expiry_date_visible = this.company_setup.po_expiry_date_visible ? this.company_setup.po_expiry_date_visible : "0";
      this.company_setup.custom_name_for_po_expiry_date = this.company_setup.custom_name_for_po_expiry_date ? this.company_setup.custom_name_for_po_expiry_date : "0";
      this.company_setup.po_expiry_date_mandatory = this.company_setup.po_expiry_date_mandatory ? this.company_setup.po_expiry_date_mandatory : "0";
      this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "yyyy-mm-dd"


      this.company_setup.pass_inv_entry_on=this.company_setup.pass_inv_entry_on?this.company_setup.pass_inv_entry_on:'approval_date'
      this.company_setup.is_accural_entry_date_visible=this.company_setup.is_accural_entry_date_visible?this.company_setup.is_accural_entry_date_visible:'0'
      this.company_setup.is_einvoice_irn_visible=this.company_setup.is_einvoice_irn_visible?this.company_setup.is_einvoice_irn_visible:'0'

      this.company_setup.inv_msg_fo_vendor_out_ind= this.company_setup.inv_msg_fo_vendor_out_ind? this.company_setup.inv_msg_fo_vendor_out_ind:'The Vendor is Non-Resident. Please check with your tax expert on TDS Applicability and TDS Section and update the TDS section and Rate accordingly';
      this.company_setup.is_tds_edit_msg_visible_for_approver=this.company_setup.is_tds_edit_msg_visible_for_approver?this.company_setup.is_tds_edit_msg_visible_for_approver:'0'
      this.company_setup.tds_edit_msg_visible_for_approver=this.company_setup.tds_edit_msg_visible_for_approver?this.company_setup.tds_edit_msg_visible_for_approver:'TDS Value for this invoice has been manually edited';
      this.company_setup.is_bill_loc_hidden_in_inv=this.company_setup.is_bill_loc_hidden_in_inv?this.company_setup.is_bill_loc_hidden_in_inv:'0'
      this.company_setup.po_adhoc_advance_payment = this.company_setup.po_adhoc_advance_payment?this.company_setup.po_adhoc_advance_payment:[]
      this.company_setup.generice_ui_paragraph_color_code= this.company_setup.generice_ui_paragraph_color_code? this.company_setup.generice_ui_paragraph_color_code:'#53a75c';
      this.company_setup.generice_ui_heading_color_code= this.company_setup.generice_ui_heading_color_code? this.company_setup.generice_ui_heading_color_code:'#333';
      this.company_setup.enable_allocable_cost_direct_po = this.company_setup.enable_allocable_cost_direct_po ? this.company_setup.enable_allocable_cost_direct_po : '0';
      this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
      if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != ''  && this.company_setup.product_catalog_id != '0') {
        this.company_setup.product_catalog_id = '1'
      }
      // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
      this.company_setup.irn_add_button_custom_name=this.company_setup.irn_add_button_custom_name?this.company_setup.irn_add_button_custom_name:'Add IRN'
      this.company_setup.irn_date_custom_name=this.company_setup.irn_date_custom_name?this.company_setup.irn_date_custom_name:'IRN Date'
      this.company_setup.irn_no_custom_name=this.company_setup.irn_no_custom_name?this.company_setup.irn_no_custom_name:'IRN No'

      this.company_setup.grn_add_button_custom_name=this.company_setup.grn_add_button_custom_name?this.company_setup.grn_add_button_custom_name:'Add GRN'
      this.company_setup.grn_date_custom_name=this.company_setup.grn_date_custom_name?this.company_setup.grn_date_custom_name:'GRN Date'
      this.company_setup.grn_no_custom_name=this.company_setup.grn_no_custom_name?this.company_setup.grn_no_custom_name:'GRN No'


      this.company_setup.add_invoice_requested_by_custom_name = this.company_setup.add_invoice_requested_by_custom_name ? this.company_setup.add_invoice_requested_by_custom_name : 'GRN Approver Name'
      this.company_setup.in_invoice_grn_no_custom_name = this.company_setup.in_invoice_grn_no_custom_name ? this.company_setup.in_invoice_grn_no_custom_name : 'GRN/QA No'
      this.company_setup.in_invoice_irn_no_custom_name = this.company_setup.in_invoice_irn_no_custom_name ? this.company_setup.in_invoice_irn_no_custom_name : 'IRN No'
      this.company_setup.is_irn_number_visible_for_invoice = this.company_setup.is_irn_number_visible_for_invoice == '1' ? this.company_setup.is_irn_number_visible_for_invoice : '0'
      this.company_setup.is_eway_bill_visible_for_invoice = this.company_setup.is_eway_bill_visible_for_invoice == '1' ? this.company_setup.is_eway_bill_visible_for_invoice : '0'

      this.company_setup.irn_boe_no_visible = this.company_setup.irn_boe_no_visible ? this.company_setup.irn_boe_no_visible : '0'
      this.company_setup.irn_boe_date_visible = this.company_setup.irn_boe_date_visible ? this.company_setup.irn_boe_date_visible : '0'
      this.company_setup.irn_annexure_no_visible = this.company_setup.irn_annexure_no_visible ? this.company_setup.irn_annexure_no_visible : '0'
      this.company_setup.is_irn_remarks_visible = this.company_setup.is_irn_remarks_visible ? this.company_setup.is_irn_remarks_visible : '0';
      this.company_setup.is_grn_remarks_visible = this.company_setup.is_grn_remarks_visible ? this.company_setup.is_grn_remarks_visible : '0';
      this.company_setup.is_irn_challan_visible = this.company_setup.is_irn_challan_visible ? this.company_setup.is_irn_challan_visible : '0';
      this.company_setup.is_irn_invoiceno_visible = this.company_setup.is_irn_invoiceno_visible ? this.company_setup.is_irn_invoiceno_visible : '0';

      //sales Order

      this.company_setup.sales_auto_closer_date_visible = this.company_setup.sales_auto_closer_date_visible ? this.company_setup.sales_auto_closer_date_visible : '0';
      this.company_setup.sales_name_of_the_person_visible = this.company_setup.sales_name_of_the_person_visible ? this.company_setup.sales_name_of_the_person_visible : '0';
      this.company_setup.sales_person_phone_number_visible = this.company_setup.sales_person_phone_number_visible ? this.company_setup.sales_person_phone_number_visible : '0';
      this.company_setup.sales_person_mail_visible = this.company_setup.sales_person_mail_visible ? this.company_setup.sales_person_mail_visible : '0';
      this.company_setup.sales_credit_period_is_editable = this.company_setup.sales_credit_period_is_editable ? this.company_setup.sales_credit_period_is_editable : '0';
      this.company_setup.sales_total_credit_limit_is_editable = this.company_setup.sales_total_credit_limit_is_editable ? this.company_setup.sales_total_credit_limit_is_editable : '0';
      this.company_setup.sales_product_required_by_date = this.company_setup.sales_product_required_by_date ? this.company_setup.sales_product_required_by_date : '0';
      this.company_setup.sales_required_by_date = this.company_setup.sales_required_by_date ? this.company_setup.sales_required_by_date : '1';
      this.company_setup.invoice_receipt_date_name = this.company_setup.invoice_receipt_date_name ? this.company_setup.invoice_receipt_date_name : 'Invoice Receipt Date';
      this.company_setup.is_je_date_visible_in_add_dc= this.company_setup.is_je_date_visible_in_add_dc? this.company_setup.is_je_date_visible_in_add_dc:'0';
      this.company_setup.enable_vendor_credit_note_no_dc_page = this.company_setup.enable_vendor_credit_note_no_dc_page ? this.company_setup.enable_vendor_credit_note_no_dc_page : '0'
      // grn
      this.company_setup.grn_requested_by_visible = this.company_setup.grn_requested_by_visible ? this.company_setup.grn_requested_by_visible : '0';
      this.company_setup.currency_icon = this.company_setup.currency_icon ? this.company_setup.currency_icon : '';

      // pr
      this.company_setup.show_lob_dropdown = this.company_setup.show_lob_dropdown ? this.company_setup.show_lob_dropdown : '0';
      this.company_setup.show_loc_dropdown = this.company_setup.show_loc_dropdown ? this.company_setup.show_loc_dropdown : '0';
      this.company_setup.show_dept_dropdown = this.company_setup.show_dept_dropdown ? this.company_setup.show_dept_dropdown : '0';
      this.company_setup.hide_numaric_number_in_lob_loc_dep = this.company_setup.hide_numaric_number_in_lob_loc_dep ? this.company_setup.hide_numaric_number_in_lob_loc_dep : '0';

      // irn

      this.company_setup.irn_requested_by_visible = this.company_setup.irn_requested_by_visible ? this.company_setup.irn_requested_by_visible : '0';
      this.company_setup.is_project_visible_in_irn = this.company_setup.is_project_visible_in_irn ? this.company_setup.is_project_visible_in_irn : '0';
      this.company_setup.is_project_visible_in_grn = this.company_setup.is_project_visible_in_grn ? this.company_setup.is_project_visible_in_grn : '0';
      this.company_setup.is_project_visible_in_invoice = this.company_setup.is_project_visible_in_invoice ? this.company_setup.is_project_visible_in_invoice : '0';
      this.company_setup.grn_done_visible_in_invoice = this.company_setup.grn_done_visible_in_invoice ? this.company_setup.grn_done_visible_in_invoice : '0';

      this.company_setup.RIT_is_project_visible_in_invoice = this.company_setup.RIT_is_project_visible_in_invoice ? this.company_setup.RIT_is_project_visible_in_invoice : "0"
      this.company_setup.RIT_is_task_visible_in_invoice = this.company_setup.RIT_is_task_visible_in_invoice ? this.company_setup.RIT_is_task_visible_in_invoice : "0"

      this.company_setup.is_accrual_visible_in_po= this.company_setup.is_accrual_visible_in_po? this.company_setup.is_accrual_visible_in_po:'0';
      this.company_setup.is_accrual_date_visible_in_po= this.company_setup.is_accrual_date_visible_in_po? this.company_setup.is_accrual_date_visible_in_po:'0';
      this.company_setup.is_task_visible_in_invoice = this.company_setup.is_task_visible_in_invoice ? this.company_setup.is_task_visible_in_invoice : '0';
      this.company_setup.is_correct_gst_invoice_received_visible_in_irn = this.company_setup.is_correct_gst_invoice_received_visible_in_irn ? this.company_setup.is_correct_gst_invoice_received_visible_in_irn:'0'
      this.company_setup.in_ir_expected_production_start_date_visible = this.company_setup.in_ir_expected_production_start_date_visible ? this.company_setup.in_ir_expected_production_start_date_visible : '0'
      this.company_setup.in_ir_expected_production_end_date_visible = this.company_setup.in_ir_expected_production_end_date_visible ? this.company_setup.in_ir_expected_production_end_date_visible : '0'
      this.company_setup.is_invoice_qty_visible_in_grn = this.company_setup.is_invoice_qty_visible_in_grn ? this.company_setup.is_invoice_qty_visible_in_grn:'0'
      this.company_setup.is_invoice_unit_price_visible_in_grn = this.company_setup.is_invoice_unit_price_visible_in_grn ? this.company_setup.is_invoice_unit_price_visible_in_grn:'0'
      this.company_setup.is_invoice_upload_file_visible_in_grn = this.company_setup.is_invoice_upload_file_visible_in_grn ? this.company_setup.is_invoice_upload_file_visible_in_grn:'0'
      this.company_setup.is_correct_gst_invoice_received_visible_in_grn = this.company_setup.is_correct_gst_invoice_received_visible_in_grn ? this.company_setup.is_correct_gst_invoice_received_visible_in_grn:'0'
      this.company_setup.in_ir_dimention_visible = this.company_setup.in_ir_dimention_visible ? this.company_setup.in_ir_dimention_visible : '0'
      this.company_setup.is_task_visible_in_irn=this.company_setup.is_task_visible_in_irn ?this.company_setup.is_task_visible_in_irn:'0';
      this.company_setup.is_irn_number_visible_for_invoice = this.company_setup.is_irn_number_visible_for_invoice == '1' ? '1' : '0';
      this.company_setup.is_eway_bill_visible_for_invoice = this.company_setup.is_eway_bill_visible_for_invoice == '1' ? '1' : '0';
      this.company_setup.is_task_visible_in_grn=this.company_setup.is_task_visible_in_grn?this.company_setup.is_task_visible_in_grn:'0';
      this.company_setup.is_invoice_qty_editable_in_grn = this.company_setup.is_invoice_qty_editable_in_grn ? this.company_setup.is_invoice_qty_editable_in_grn:'0'
      this.company_setup.is_invoice_unit_price_editable_in_grn = this.company_setup.is_invoice_unit_price_editable_in_grn ? this.company_setup.is_invoice_unit_price_editable_in_grn:'0'
      this.company_setup.is_invoice_upload_file_editable_in_grn = this.company_setup.is_invoice_upload_file_editable_in_grn ? this.company_setup.is_invoice_upload_file_editable_in_grn:'0'
      this.company_setup.is_correct_gst_invoice_received_editable_in_grn = this.company_setup.is_correct_gst_invoice_received_editable_in_grn ? this.company_setup.is_correct_gst_invoice_received_editable_in_grn:'0'

      this.company_setup.is_task_visible_in_po = this.company_setup.is_task_visible_in_po ? this.company_setup.is_task_visible_in_po:'0'
      this.company_setup.service_start_end_date_visible_in_inv = this.company_setup.service_start_end_date_visible_in_inv ? this.company_setup.service_start_end_date_visible_in_inv:'0'
      this.company_setup.rename_project = this.company_setup.rename_project ? this.company_setup.rename_project : ''

      this.company_setup.is_customer_allocation_visible = false;
      this.company_setup.is_department_allocation_visible = false;

      this.company_setup.invoice_item_columnList = this.company_setup.invoice_item_columnList ? this.company_setup.invoice_item_columnList : []
      if (this.company_setup.invoice_item_columnList.length > 0) {
        this.company_setup.is_department_allocation_visible = this.company_setup.invoice_item_columnList.some((v) => { return v.id == 'department_allocation' && v.isVisible })
        this.company_setup.is_customer_allocation_visible = this.company_setup.invoice_item_columnList.some((v) => { return v.id == 'customer_allocation' && v.isVisible })
        this.company_setup.invoice_allocate_to_employee_visible = this.company_setup.invoice_item_columnList.some((v) => { return v.id == 'invoice_allocate_to_employee' && v.isVisible })

      }
      this.company_setup.in_invoice_month_drop_down_visible=this.company_setup.in_invoice_month_drop_down_visible?this.company_setup.in_invoice_month_drop_down_visible:'0'
      this.company_setup.in_invoice_custom_name_of_month_drop_down=this.company_setup.in_invoice_custom_name_of_month_drop_down?this.company_setup.in_invoice_custom_name_of_month_drop_down:'';
      this.company_setup.in_direct_invoice_one_time_boq_visible=this.company_setup.in_direct_invoice_one_time_boq_visible?this.company_setup.in_direct_invoice_one_time_boq_visible:'0';
      this.company_setup.in_pr_dimension_visible = this.company_setup.in_pr_dimension_visible ? this.company_setup.in_pr_dimension_visible : '0';
      this.company_setup.po_additional_fields_column_list = this.company_setup.po_additional_fields_column_list ? this.company_setup.po_additional_fields_column_list : [];

      this.company_setup.in_update_invoice_ven_inv_date_editable=this.company_setup.in_update_invoice_ven_inv_date_editable?this.company_setup.in_update_invoice_ven_inv_date_editable:'0';
      this.company_setup.in_update_invoice_month_editable=this.company_setup.in_update_invoice_month_editable?this.company_setup.in_update_invoice_month_editable:'0';
      this.company_setup.in_update_invoice_service_start_and_end_date_editable=this.company_setup.in_update_invoice_service_start_and_end_date_editable?this.company_setup.in_update_invoice_service_start_and_end_date_editable:'0';
      this.company_setup.in_update_invoice_due_date_editable=this.company_setup.in_update_invoice_due_date_editable?this.company_setup.in_update_invoice_due_date_editable:'0';
      this.company_setup.in_update_invoice_project_editable=this.company_setup.in_update_invoice_project_editable?this.company_setup.in_update_invoice_project_editable:'0';
      this.company_setup.in_update_invoice_vendor_inv_number_editable=this.company_setup.in_update_invoice_vendor_inv_number_editable?this.company_setup.in_update_invoice_vendor_inv_number_editable:'0';
      this.company_setup.invoice_is_payment_made_editable=this.company_setup.invoice_is_payment_made_editable?this.company_setup.invoice_is_payment_made_editable:'0';
      this.company_setup.is_contract_based_po_visible_in_po = this.company_setup.is_contract_based_po_visible_in_po ? this.company_setup.is_contract_based_po_visible_in_po : "";
      this.company_setup.custom_name_for_contract_based_po = this.company_setup.custom_name_for_contract_based_po ? this.company_setup.custom_name_for_contract_based_po : "contract based po";
      this.company_setup.is_ven_inv_number_visible_in_invoice_payment=this.company_setup.is_ven_inv_number_visible_in_invoice_payment?this.company_setup.is_ven_inv_number_visible_in_invoice_payment:'0';
      this.company_setup.in_adhoc_advance_payment_pages_project_is_visible=this.company_setup.in_adhoc_advance_payment_pages_project_is_visible?this.company_setup.in_adhoc_advance_payment_pages_project_is_visible:'0';
      this.company_setup.in_adhoc_advance_payment_pages_proforma_invoice_no_is_visible=this.company_setup.in_adhoc_advance_payment_pages_proforma_invoice_no_is_visible?this.company_setup.in_adhoc_advance_payment_pages_proforma_invoice_no_is_visible:'0';

      this.company_setup.task_budget_visible_in_po = this.company_setup.task_budget_visible_in_po ? this.company_setup.task_budget_visible_in_po : "0";
      this.company_setup.task_consumed_budget_visible_in_po = this.company_setup.task_consumed_budget_visible_in_po ? this.company_setup.task_consumed_budget_visible_in_po : "0";
      this.company_setup.task_balance_budget_visible_in_po = this.company_setup.task_balance_budget_visible_in_po ? this.company_setup.task_balance_budget_visible_in_po : "0";  
      this.company_setup.select_pr_list = this.company_setup.select_pr_list ? this.company_setup.select_pr_list : [];
      this.company_setup.task_budget_visible_in_invoice = this.company_setup.task_budget_visible_in_invoice ? this.company_setup.task_budget_visible_in_invoice : '0';
      this.company_setup.task_consumed_budget_visible_in_invoice = this.company_setup.task_consumed_budget_visible_in_invoice ? this.company_setup.task_consumed_budget_visible_in_invoice : '0';
      this.company_setup.task_balance_budget_visible_in_invoice = this.company_setup.task_balance_budget_visible_in_invoice ? this.company_setup.task_balance_budget_visible_in_invoice : '0';
      this.company_setup.in_invoice_period_is_visible = this.company_setup.in_invoice_period_is_visible ? this.company_setup.in_invoice_period_is_visible : "0";
      this.company_setup.in_invoice_custom_name_for_period = this.company_setup.in_invoice_custom_name_for_period ? this.company_setup.in_invoice_custom_name_for_period : "Period";
      this.company_setup.in_invoice_miscellaneous_is_visible = this.company_setup.in_invoice_miscellaneous_is_visible ? this.company_setup.in_invoice_miscellaneous_is_visible : "0";
      this.company_setup.in_invoice_transportation_is_visible = this.company_setup.in_invoice_transportation_is_visible ? this.company_setup.in_invoice_transportation_is_visible : "0";
      this.company_setup.in_invoice_revenue_lob_is_visible = this.company_setup.in_invoice_revenue_lob_is_visible ? this.company_setup.in_invoice_revenue_lob_is_visible : "0";
      this.company_setup.in_invoice_mode_of_transport_is_visible = this.company_setup.in_invoice_mode_of_transport_is_visible ? this.company_setup.in_invoice_mode_of_transport_is_visible : "0";
      this.company_setup.in_invoice_cif_value_is_visible = this.company_setup.in_invoice_cif_value_is_visible ? this.company_setup.in_invoice_cif_value_is_visible : "0";
      this.company_setup.in_invoice_custom_duty_is_visible = this.company_setup.in_invoice_custom_duty_is_visible ? this.company_setup.in_invoice_custom_duty_is_visible : "0";
      this.company_setup.in_invoice_shipping_bill_and_bill_of_export_no_is_visible = this.company_setup.in_invoice_shipping_bill_and_bill_of_export_no_is_visible ? this.company_setup.in_invoice_shipping_bill_and_bill_of_export_no_is_visible : "0";
      this.company_setup.in_invoice_note_is_visible = this.company_setup.in_invoice_note_is_visible ? this.company_setup.in_invoice_note_is_visible : "0";
      this.company_setup.in_invoice_erp_id_is_visible = this.company_setup.in_invoice_erp_id_is_visible ? this.company_setup.in_invoice_erp_id_is_visible : "0";
      this.company_setup.quotation_management_master_column_list=this.company_setup.quotation_management_master_column_list?this.company_setup.quotation_management_master_column_list:[]
      this.company_setup.value_increase_limited_to=this.company_setup.value_increase_limited_to?this.company_setup.value_increase_limited_to : "0"

      this.company_setup.allow_vendor_loc_change_update_inv = this.company_setup.allow_vendor_loc_change_update_inv ? this.company_setup.allow_vendor_loc_change_update_inv : '0'

      this.company_setup.invoice_erp_date_is_visible = this.company_setup.invoice_erp_date_is_visible ? this.company_setup.invoice_erp_date_is_visible : '0';
      this.company_setup.custom_name_for_inv_erp_id = this.company_setup.custom_name_for_inv_erp_id ? this.company_setup.custom_name_for_inv_erp_id : 'ERP ID';
      this.company_setup.custom_name_for_inv_erp_date = this.company_setup.custom_name_for_inv_erp_date ? this.company_setup.custom_name_for_inv_erp_date : 'ERP Date';
      this.company_setup.invoice_erp_code_is_visible = this.company_setup.invoice_erp_code_is_visible ? this.company_setup.invoice_erp_code_is_visible : '0';
      this.company_setup.invoice_erp_status_is_visible = this.company_setup.invoice_erp_status_is_visible ? this.company_setup.invoice_erp_status_is_visible : '0';
      this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";
      this.company_setup.pr_customer_custom_name = this.company_setup.pr_customer_custom_name ? this.company_setup.pr_customer_custom_name : 'Customer';
      this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table : '0';
      this.company_setup.rename_project = this.company_setup.rename_project ? this.company_setup.rename_project : '';          
      this.company_setup.rename_task = this.company_setup.rename_task ? this.company_setup.rename_task : '';

      this.company_setup.communication_mail_id_visible_raise_po_direct_po = this.company_setup.communication_mail_id_visible_raise_po_direct_po ? this.company_setup.communication_mail_id_visible_raise_po_direct_po : '';
      this.company_setup.is_different_document_currency = this.company_setup.is_different_document_currency ? this.company_setup.is_different_document_currency : 'Is DDC';
      this.company_setup.automatic_add_advance_payment_in_po = this.company_setup.automatic_add_advance_payment_in_po ? this.company_setup.automatic_add_advance_payment_in_po : '0';
      this.company_setup.modified_irn_to_grn = this.company_setup.modified_irn_to_grn ? this.company_setup.modified_irn_to_grn : '0';
      this.irn_to_grn = (this.company_setup.modified_irn_to_grn == 1) ? "GRN" : "IRN";
      this.irn_inv_date = (this.company_setup.modified_irn_to_grn == 1) ? "GRN Invoice Date" : " IRN Invoice Date";
      this.irn_inv_no = (this.company_setup.modified_irn_to_grn == 1) ? "GRN Invoice NO" : " IRN Invoice NO";
      this.irn_remarks = (this.company_setup.modified_irn_to_grn == 1) ? "GRN Remarks" : " IRN Remarks";
      this.company_setup.is_project_visible_in_pr = this.company_setup.is_project_visible_in_pr ? this.company_setup.is_project_visible_in_pr : '0';
      this.company_setup.is_task_visible_in_pr = this.company_setup.is_task_visible_in_pr ? this.company_setup.is_task_visible_in_pr : '0';
      this.company_setup.enable_po_type_order_in_po = this.company_setup.enable_po_type_order_in_po ? this.company_setup.enable_po_type_order_in_po : '0';
      this.company_setup.po_additional_column_list = this.company_setup.po_additional_column_list ? this.company_setup.po_additional_column_list : [];
      this.company_setup.subject = (this.company_setup.po_additional_column_list && this.company_setup.po_additional_column_list.length > 0) ? this.company_setup.po_additional_column_list.filter(v => v.key == 'subject')[0] : {'text':'','is_visible_in_po':false,'custom_name':''};
      this.company_setup.reference =(this.company_setup.po_additional_column_list && this.company_setup.po_additional_column_list.length > 0)  ? this.company_setup.po_additional_column_list.filter(v => v.key == 'reference')[0] : {'text':'','is_visible_in_po':false,'custom_name':''};
      this.company_setup.po_note = (this.company_setup.po_additional_column_list && this.company_setup.po_additional_column_list.length > 0)  ? this.company_setup.po_additional_column_list.filter(v => v.key == 'po_note')[0] : {'text':'','is_visible_in_po':false,'custom_name':''};
      this.company_setup.po_type_order_dropdown_list = this.company_setup.po_type_order_dropdown_list ? this.company_setup.po_type_order_dropdown_list : [];
      this.company_setup.erp_date_visible_mandatory_for_last_approval = this.company_setup.erp_date_visible_mandatory_for_last_approval ? this.company_setup.erp_date_visible_mandatory_for_last_approval : '0'
      this.company_setup.erp_id_visible_mandatory_for_last_approval = this.company_setup.erp_id_visible_mandatory_for_last_approval ? this.company_setup.erp_id_visible_mandatory_for_last_approval : '0'
      this.po_type_list =  this.company_setup.po_type_order_dropdown_list.filter(item => item.is_visible);
      this.company_setup.custom_name_for_lob = this.company_setup.custom_name_for_lob ? this.company_setup.custom_name_for_lob : "LOB";
      this.company_setup.custom_name_for_loc = this.company_setup.custom_name_for_loc ? this.company_setup.custom_name_for_loc : "Location";
      this.company_setup.custom_name_for_dept = this.company_setup.custom_name_for_dept ? this.company_setup.custom_name_for_dept : "Department";
      this.company_setup.show_voucher_type_in_inv = this.company_setup.show_voucher_type_in_inv ? this.company_setup.show_voucher_type_in_inv : "0";
      this.company_setup.is_show_vendor_at_pr_level = this.company_setup.is_show_vendor_at_pr_level ? this.company_setup.is_show_vendor_at_pr_level : '0';
      this.company_setup.is_vendor_editable_in_pr_approver = this.company_setup.is_vendor_editable_in_pr_approver ? this.company_setup.is_vendor_editable_in_pr_approver : '0';
      this.company_setup.show_blanket_po_option_in_direct_po = this.company_setup.show_blanket_po_option_in_direct_po ? this.company_setup.show_blanket_po_option_in_direct_po : '0';
      this.company_setup.vendor_invoice_column_list=this.company_setup.vendor_invoice_column_list?this.company_setup.vendor_invoice_column_list:[];
      this.company_setup.is_purchase_document_types_visible = this.company_setup.is_purchase_document_types_visible ? this.company_setup.is_purchase_document_types_visible : '0';
      this.company_setup.is_purchase_organizations_visible = this.company_setup.is_purchase_organizations_visible ? this.company_setup.is_purchase_organizations_visible : '0';
      this.company_setup.is_purchase_groups_visible = this.company_setup.is_purchase_groups_visible ? this.company_setup.is_purchase_groups_visible : '0';
      this.company_setup.is_purchase_document_types_visible_in_po = this.company_setup.is_purchase_document_types_visible_in_po ? this.company_setup.is_purchase_document_types_visible_in_po : '0';
      this.company_setup.is_purchase_organizations_visible_in_po = this.company_setup.is_purchase_organizations_visible_in_po ? this.company_setup.is_purchase_organizations_visible_in_po : '0';
      this.company_setup.is_purchase_groups_visible_in_po = this.company_setup.is_purchase_groups_visible_in_po ? this.company_setup.is_purchase_groups_visible_in_po : '0';

          let poAdditionaltemp: any = [];
           poAdditionaltemp = this.company_setup.po_additional_fields_column_list.filter((v) => { return v.id == 'po_additional_fields_settings' })
           if (poAdditionaltemp.length != undefined && poAdditionaltemp.length>0) {
             this.company_setup.po_additional_fields_column_list = [];
             this.company_setup.po_additional_fields_column_list = poAdditionaltemp[0].columns ? poAdditionaltemp[0].columns : [];
           }
           this.company_setup.invoice_extra_columns = this.company_setup.invoice_extra_columns ? this.company_setup.invoice_extra_columns : [];
           let invoiceExtratemp: any = [];
           invoiceExtratemp = this.company_setup.invoice_extra_columns.filter((v) => { return v.id == 'grn_invoice' });
           if (invoiceExtratemp.length != undefined && invoiceExtratemp.length > 0) {
             this.company_setup.invoice_extra_columns = [];
             this.company_setup.invoice_extra_columns = invoiceExtratemp[0].columns ? invoiceExtratemp[0].columns : [];
           }
           this.company_setup.sales_invoice_column_list = this.company_setup.sales_invoice_column_list ? this.company_setup.sales_invoice_column_list : [];
          let tempSalesInvoice: any = [];
          tempSalesInvoice = this.company_setup.sales_invoice_column_list.filter((v) => { return v.id == 'sales_invoice_level' })
          if (tempSalesInvoice.length != undefined && tempSalesInvoice.length>0) {
            this.company_setup.sales_invoice_column_list = [];
            this.company_setup.sales_invoice_column_list = tempSalesInvoice[0].columns ? tempSalesInvoice[0].columns : [];
          }
           /**
           * Company Setup for RFQ
           */
           let temp: any = [];
           temp = this.company_setup.quotation_management_master_column_list.filter((v) => { return v.id == 'rfq_master' })
           if (temp.length != undefined && temp.length > 0) {
             this.company_setup.quotation_management_master_column_list = [];
             this.company_setup.quotation_management_master_column_list = temp[0].columns ? temp[0].columns : [];
           }
this.stillLoading=false;
      this.linkType = this.divDetails.id;
      switch (this.divDetails.id) {
        case 'invoice_android_report': this.showAndroidInvoice(this.divDetails.data); break;
        case 'recurring_invoicereport': this.showRecurringInvoice(this.divDetails.data); break;

        case 'invoicereport': this.showInvoice(this.divDetails.data); break;
        case 'dcnotereport': this.showDCNote(this.divDetails.data); break;

      case 'grnreport': this.showGrn(this.divDetails.data); break;
      case 'gatepassreport': this.showGatePass(this.divDetails.data); break;
      case 'irnreport': this.showIrn(this.divDetails.data); break;
      case 'irn_additional_fields_only': this.showIrn(this.divDetails.data); break;
      case 'poreport': this.showPo(this.divDetails.data); break;
        case 'mpreport': this.showMp(this.divDetails.data); break;
        case 'logisticsreport': this.showLogistics(this.divDetails.data); break;

        case 'sireport': this.showSi(this.divDetails.data); break;
        case 'prreport': this.showPr(this.divDetails.data); break;
        case 'irreport': this.showIr(this.divDetails.data); break;
        case 'ir_history_report': this.showIRHistory(this.divDetails.data); break;

        case 'mprreport': this.showMpr(this.divDetails.data); break;

        case 'stnreport': this.showStn(this.divDetails.data); break;
        case 'proformainvoicereport': this.showProformaInvoice(this.divDetails.data); break;
        case 'salesinvoicereport': this.showSalesInvoice(this.divDetails.data); break;
        case 'invoicepaymentreport': this.showInvoicePayment(this.divDetails.data); break;
        case 'adhocpaymentreport': this.showAdhocPayment(this.divDetails.data); break;
        case 'invoicepartpaymentreport': this.showInvoicePartPayment(this.divDetails.data); break;
        case 'invoiceretentionpaymentreport': this.showInvoiceRetentionPayment(this.divDetails.data); break;
        case 'popaymentreport': this.showPoPayment(this.divDetails.data); break;
        case 'salesOrderData': this.showSalesOrderData(this.divDetails.data); break;
        case 'my_advance_report': this.showMyadvanceData(this.divDetails.data); break;
        case 'employee_advance_payment_report': this.showEmployeeAdvancePaymentData(this.divDetails.data); break;
        case 'rfqNumberReport': this.showRfqData(this.divDetails.data); break;
        case 'rfqResponseReport': this.showRfqData(this.divDetails.data); break;
        case 'creditnotereport': this.showVendorCreditNote(this.divDetails.data); break;
        default:
        // this.toasterService.pop('error', "Error", "Wrong Data For Before Div");
      }
this.stillLoading=false;
  }
  showPoPayment(response) {

    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
    response.bank_name = (response.bank_name || '') + (response.bank_accountno ? ` (${response.bank_accountno})` : '');

    if(response.date_of_payment != "" && response.date_of_payment != null && response.date_of_payment != undefined){
      response.date_of_payment = this.webService.formatDateAccordingToSetup(response.date_of_payment,this.company_setup.in_invoice_date_format)
    }
    if(response.actual_date != "" && response.actual_date != null && response.actual_date != undefined){
      response.actual_date = this.webService.formatDateAccordingToSetup(response.actual_date,this.company_setup.in_invoice_date_format)
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Payment Date',
        "value": response.date_of_payment,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Actual Payment Date',
        "value": response.actual_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Bank Name',
        "value": response.bank_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Bank Branch',
        "value": response.bank_branch,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }

    );

  }
  showInvoicePayment(response) {
    // Handle old_json_data for diff display
    this.diff_json_data = this.divDetails.diff_json_data ? this.divDetails.diff_json_data : {};
    this.show_difference = this.divDetails.show_difference && this.divDetails.show_difference=='1' ? true : false;
    let old_json_data = this.divDetails.old_json_data ? this.divDetails.old_json_data : {};
    
    // For invoice approval screen, ensure old_json_data is properly set
    if (this.divDetails.is_invoice_approval_screen && this.divDetails.invoice_data_reqsted && old_json_data) {
      // Map invoice_no to vendor_invoice_no if needed (for divList compatibility)
      if (old_json_data['invoice_no'] && !old_json_data['vendor_invoice_no']) {
        old_json_data['vendor_invoice_no'] = old_json_data['invoice_no'];
      }
      if (old_json_data['vendor_invoice_no'] && !old_json_data['invoice_no']) {
        old_json_data['invoice_no'] = old_json_data['vendor_invoice_no'];
      }
    }
    
    // Assign old_json_data to this.old_json_data for use in template
    this.old_json_data = old_json_data;
    
    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
    response.bank_name = (response.bank_name || '') + (response.bank_accountno ? ` (${response.bank_accountno})` : '');

    response.is_hold_gst=response.is_hold_gst?response.is_hold_gst:'0'
    if(response.date_of_payment != "" && response.date_of_payment != null && response.date_of_payment != undefined){
      response.date_of_payment = this.webService.formatDateAccordingToSetup(response.date_of_payment,this.company_setup.in_invoice_date_format)
    }
    if(response.actual_date != "" && response.actual_date != null && response.actual_date != undefined){
      response.actual_date = this.webService.formatDateAccordingToSetup(response.actual_date,this.company_setup.in_invoice_date_format)
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Payment Date',
        "value": response.date_of_payment?response.date_of_payment:'',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Payment Type',
        "value": response.type=='partial_payment'?'Part Payment':'Invoice Payment',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Actual Payment Date',
        "value": response.actual_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(response.actual_date!=''&& response.actual_date!=undefined&&response.actual_date!=null)?true:false, "input_type": 'text'
      },
       {
         "display": 'Bank Name',
         "value": response.bank_name?response.bank_name:'',
         "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.page_url != 'invoice-payment-approval'?true:false, "input_type": 'text'
       },
      {
        "display": 'Bank Branch',
        "value": response.bank_branch?response.bank_branch:'',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Vendor Invoice No ',
        "value": response.invoice_no?response.invoice_no:'',
        "id": "vendor_invoice_no",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_ven_inv_number_visible_in_invoice_payment=='1', "input_type": 'text'
      },
      {
        "display": 'Hold GST',
        "value": response.is_hold_gst=='1'?true:false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_hold_gst_checkbox_visible=='1', "input_type": 'checkbox'
      }


    );
    // //console.log('inv pay')
    //   //console.log( this.commonVariableList.divList);
  }
  showAdhocPayment(response) {
    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
   response.bank_name = response.bank_name || response.bank_accountno ? 
  `${response.bank_name || ''}${response.bank_accountno ? ' (' + response.bank_accountno + ')' : ''}` : '';
    // response.project_details = response.project_name + "(" + response.project_code + ")"
    response.project_name = response.project_name ? response.project_name : "";
    response.project_code = response.project_code ? response.project_code : "";
    const isDirectAdvancePayment: boolean = !response.po_id && !response.po_no;
    if(response.due_date != "" && response.due_date != null && response.due_date != undefined){
      response.due_date = this.webService.formatDateAccordingToSetup(response.due_date,this.company_setup.in_invoice_date_format)
    }
    if(response.project_name != "" && response.project_code != ""){
      response.project_details = `${response.project_name} (${response.project_code})`
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Payment No',
        "value": response.dp_no?response.dp_no:'',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Cost Center',
        "value": response.cost_center_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'PO',
        "value": response.po_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":true, "input_type": 'po-click'
      },
      {
        "display": 'Vendor',
        "value": response.vendor_address?response.vendor_address:(response.vendor_address_details?response.vendor_address_details:''),
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Vendor Bank Account',
        "value": response.vendor_account,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Bank Account',
        "value": response.bank_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display":[this.adhoc_getColumnName('description','Description')],
        "value": response.payment_description,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.adhoc_is_column_visible('description',false), "input_type": 'text'
      },
      {
        "display": 'Previous Advance Payment Amount',
        "value": response.previous_advance_amount,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Unadjusted Advance Amount',
        "value": response.unadjusted_advance_amount,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Total PO Amount',
        "value": response.total_po_amount,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": [this.adhoc_getColumnName('total_po_amount_exclusive_gst','Total PO Amount Exclusive GST')],
        "value": response.total_po_amount_exclusive_gst,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.adhoc_is_column_visible('total_po_amount_exclusive_gst',false), "input_type": 'text'
      },
      {
        "display": 'Total Invoice Amount',
        "value": response.total_invoice_amount,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Advance Payment Amount',
        "value": response.advance_payment_amount,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display":[this.adhoc_getColumnName('tds_amount','TDS Amount')],
        "value": response.tds_amount,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.adhoc_is_column_visible('tds_amount',true),  "input_type": 'text'
      }
      ,
      {
        "display": 'Net Advance Amount',
        "value": response.net_advance_amount,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": [this.adhoc_getColumnName('remarks','Remarks')],
        "value": response.remarks,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.adhoc_is_column_visible('remarks',false), "input_type": 'text'
      },
      // {
      //   "display": 'Non Applicable TDS Amount',
      //   "value": response.non_applicable_tds_amount,
      //   "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      // }
      {
        "display": 'Account Code',
        "value": response.bank_account_code,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.account_code_in_advance_payment=='1')?true:false, "input_type": 'text'
      },
      {
        "display": 'project',
        "value": response.project_details,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.in_adhoc_advance_payment_pages_project_is_visible=='1')?true:false, "input_type": 'text'
      },
      {
        "display": 'Profroma invoice number',
        "value": response.profroma_invoice_number,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.in_adhoc_advance_payment_pages_proforma_invoice_no_is_visible=='1')?true:false, "input_type": 'text'
      },
      {
        "display": 'Due Date',
        "value": response.due_date ? response.due_date : '',
        "div_size": 'col-sm-2 div1',
        "is_html":false,"is_editable": false,"is_disabled": true,
        "is_view": isDirectAdvancePayment ? (this.company_setup.is_due_date_visible_in_direct_advance == '1') : (this.company_setup.is_due_date_visible_in_po_advance == '1'),
        "input_type": 'text'
      }

    );

  }
  showInvoicePartPayment(response) {
    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
    // response.bank_name = response.bank_name + "(" + response.bank_accountno + ")"
    response.bank_name = response.bank_name ? response.bank_name : "";
    response.bank_accountno = response.bank_accountno ? response.bank_accountno : "";
    response.bank_name = response.bank_name != "" ? `${response.bank_name} (${response.bank_accountno})`: '';
    response.loc=response.cost_center_name?(response.cost_center_name+"( "+response.cost_center_code+" )"):""
    if(response.date_of_payment != "" && response.date_of_payment != null && response.date_of_payment != undefined){
      response.date_of_payment = this.webService.formatDateAccordingToSetup(response.date_of_payment,this.company_setup.in_invoice_date_format)
    }
    if(response.actual_date != "" && response.actual_date != null && response.actual_date != undefined){
      response.actual_date = this.webService.formatDateAccordingToSetup(response.actual_date,this.company_setup.in_invoice_date_format)
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Payment Date',
        "value": response.date_of_payment,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Actual Payment Date',
        "value": response.actual_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": false, "input_type": 'text'
      },
       {
         "display": 'Bank Name',
         "value": response.bank_name,
         "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.page_url != 'part-payment-for-approval'?true:false, "input_type": 'text'
       },
       
      {
        "display": 'Bank Branch',
        "value": response.bank_branch,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Ship Location',
        "value": response.loc,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.loc!='', "input_type": 'text'
      }

    );

  }
  showInvoiceRetentionPayment(response) {
response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
    response.bank_name = response.bank_name + "(" + response.bank_accountno + ")"
    if(response.date_of_payment != "" && response.date_of_payment != null && response.date_of_payment != undefined){
      response.date_of_payment = this.webService.formatDateAccordingToSetup(response.date_of_payment,this.company_setup.in_invoice_date_format)
    }
    if(response.actual_date != "" && response.actual_date != null && response.actual_date != undefined){
      response.actual_date = this.webService.formatDateAccordingToSetup(response.actual_date,this.company_setup.in_invoice_date_format)
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Payment Date',
        "value": response.date_of_payment,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Actual Payment Date',
        "value": response.actual_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": false, "input_type": 'text'
      },
      {
        "display": 'Bank Name',
        "value": response.bank_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Bank Branch',
        "value": response.bank_branch,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }

    );

  }
  showSalesInvoice(response) {
    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"

    response.vendor_details = response.vendor_first_name + " " + response.vendor_last_name;
    response.bill_to_location = response.bill_location_nickname_9_digit + " (" + response.bill_location_code_9_digit + ")";
    response.ship_to_location = response.ship_location_nickname_9_digit + " (" + response.ship_location_code_9_digit + ")";
    response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = response.project_name + "(" + response.project_code + ")";
    response.send_customer_mail=response.send_customer_mail?response.send_customer_mail:'0';
    response.customer_address = response.customer_address ? response.customer_address : '';
    response.credit_period=response.credit_period?response.credit_period:'';
    response.total_credit_limit=response.total_credit_limit?response.total_credit_limit:'';
    response.balance_credit_limit=response.balance_credit_limit?response.balance_credit_limit:'';
    response.sales_invoice_custom_ship_to_location = response.sales_invoice_custom_ship_to_location ? response.sales_invoice_custom_ship_to_location:"0"
    response.sales_invoice_place_of_supply_name = response.sales_invoice_place_of_supply_name ? response.sales_invoice_place_of_supply_name:""
    response.agent_full_name = `${response.agent_first_name ? response.agent_first_name : ""} ${response.agent_last_name ? response.agent_last_name : ""} ${response.agent_code ? response.agent_code : ""}`;
    response.sales_person_full_name = `${response.sales_person_first_name ? response.sales_person_first_name : ""} ${response.sales_person_last_name ? response.sales_person_last_name : ""} ${response.sales_person_employee_code ? response.sales_person_employee_code : ""}`;
    response.name_of_the_person_email = response.name_of_the_person_email ? response.name_of_the_person_email:""
    response.name_of_the_person_phone_number = response.name_of_the_person_phone_number ? response.name_of_the_person_phone_number:""
    response.vendor_code = response.vendor_code ? response.vendor_code:""
    response.eid_number = response.eid_number ? response.eid_number:""
    response.customer_po_number = response.customer_po_number ? response.customer_po_number:""
    response.customer_po_date = response.customer_po_date ? response.customer_po_date:""
    response.bill_to_contact_name = response.bill_to_contact_name ? response.bill_to_contact_name:""
    response.bill_to_contact_number = response.bill_to_contact_number ? response.bill_to_contact_number:""
    response.ship_to_contact_name = response.ship_to_contact_name ? response.ship_to_contact_name:""
    response.ship_to_contact_number = response.ship_to_contact_number ? response.ship_to_contact_number:""
    response.payment_terms = response.payment_terms ? response.payment_terms:""
    response.transport_mode = response.transport_mode ? response.transport_mode:""
    response.vehicle_number = response.vehicle_number ? response.vehicle_number:""
    response.override_lut =  response.override_lut ?  response.override_lut : '0';
    if(response.date_added != "" && response.date_added != null && response.date_added != undefined){
      response.date_added = this.webService.formatDateAccordingToSetup(response.date_added,this.company_setup.in_invoice_date_format)
    }
    if(response.invoice_due_date != "" && response.invoice_due_date != null && response.invoice_due_date != undefined){
      response.invoice_due_date = this.webService.formatDateAccordingToSetup(response.invoice_due_date,this.company_setup.in_invoice_date_format)
    }
    if(response.customer_invoice_date != "" && response.customer_invoice_date != null && response.customer_invoice_date != undefined){
      response.customer_invoice_date = this.webService.formatDateAccordingToSetup(response.customer_invoice_date,this.company_setup.in_invoice_date_format)
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Invoice No',
        "value": response.cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Invoice Customer No',
        "value": response.invoice_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Invoice Date',

        //"value": response.date_added,
        "value": response.date_added,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Invoice Due Date',
        "value": response.invoice_due_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Customer Invoice Date',
        "value": response.customer_invoice_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Customer',
        // "value": response.vendor,
        "value": response.customer_address,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": "Custom Ship To Location",
        // "value": response.vendor,
        "value": response.sales_invoice_custom_ship_to_location == '1' ? true : false,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": true, "is_view": this.company_setup.enable_custom_ship_to_location_in_sales_invoice=='1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": "Place of Supply",
        // "value": response.vendor,
        "value": response.sales_invoice_place_of_supply_name,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": true, "is_view": (response.sales_invoice_custom_ship_to_location == '1' && this.company_setup.enable_custom_ship_to_location_in_sales_invoice=='1') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Buyer Ship Location',
        "value": response.customer_ship_location_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Buyer Bill Location',
        "value": response.customer_bill_location_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Seller Ship Location',
        "value": response.company_ship_location_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Seller Bill Location',
        "value": response.company_bill_location_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Customer Address',
        "value": response.customer_address,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.customer_address != '' && response.customer_address != '' && response.customer_address != null && response.customer_address != undefined ) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Send Mail To Customer',
        "value": response.send_customer_mail=='1'?true:false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.is_send_mail_to_customer_visible_in_sales_invoice=='1')?true:false, "input_type": 'checkbox'
      }
      ,
      {
        "display": 'is Supply Through E-Comm',
        "value": response.is_e_commerce=='1'?true:false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.is_supply_through_e_comm_visible_in_sales_invoice=='1')?true:false, "input_type": 'checkbox'
      }
      ,
      {
        "display": 'E-Comm GST',
        "value": response.e_commerce_gst,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(response.e_commerce_gst!=undefined&&response.e_commerce_gst!=null && response.e_commerce_gst!='' && this.company_setup.is_supply_through_e_comm_visible_in_sales_invoice=='1')?true:false, "input_type": 'text'
      },
      {
        "display": 'Project',
        "value": response.project_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.project_name != '' && response.project_name != '' && this.company_setup.is_project_selection_visible_in_sales_invoice=='1') ? true : false, "input_type": 'text'
      }
      ,
      {
        "display": 'Is DDC',
        "value": response.is_different_document_currency == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Conversion Rate',
        "value": response.conversion_rate,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Currency',
        "value": response.currency_name,
        // "value": response.currency_name + "(" + response.currency_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },

      {
        "display": 'Credit Period',
        "value": response.credit_period,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Total Credit Limit',
        "value": response.total_credit_limit,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Balance Credit Limit',
        "value": response.balance_credit_limit,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Agent Name',
        "value": response.agent_full_name,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.sales_invoice_sales_person_visible=='1' && response.is_imported)?true:false, "input_type": 'text'
      },
      {
        "display": 'Sales Person Name',
        "value": response.sales_person_full_name,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.sales_invoice_sales_person_visible=='1' && response.is_imported)?true:false, "input_type": 'text'
      },
      {
        "display": 'Name of the person',
        "value": response.name_of_the_person,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.sales_invoice_sales_name_of_the_person_visible=='1' && response.is_imported)?true:false, "input_type": 'text'
      },
      {
        "display": 'Person phone number',
        "value": response.name_of_the_person_phone_number,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.sales_invoice_sales_person_phone_number_visible=='1' && response.is_imported)?true:false, "input_type": 'text'
      },
      {
        "display": 'Person email id',
        "value": response.name_of_the_person_email,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.sales_invoice_sales_person_mail_visible=='1' && response.is_imported)?true:false, "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('vendor_code','Vendor Code'),
        "value": response.vendor_code,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('vendor_code',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('eid_number','EID Number'),
        "value": response.eid_number,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('eid_number',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('customer_po_number','Customer Po Number'),
        "value": response.customer_po_number,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('customer_po_number',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('customer_po_date','Customer Po Date'),
        "value": response.customer_po_date,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('customer_po_date',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('bill_to_contact_name','Bill to Contact Name'),
        "value": response.bill_to_contact_name,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('bill_to_contact_name',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('bill_to_contact_number','Bill to Contact Number'),
        "value": response.bill_to_contact_number,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('bill_to_contact_number',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('ship_to_contact_name','Ship to Contact Name'),
        "value": response.ship_to_contact_name,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('ship_to_contact_name',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('ship_to_contact_number','Ship to Contact Number'),
        "value": response.ship_to_contact_number,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('ship_to_contact_number',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('payment_terms','payment terms'),
        "value": response.payment_terms,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('payment_terms',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('transport_mode','payment terms'),
        "value": response.transport_mode,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('transport_mode',false), "input_type": 'text'
      },
      {
        "display": this.salesInvoicegetColumnName('vehicle_number','payment terms'),
        "value": response.vehicle_number,
        "div_size": 'col-sm-2', "is_editable": false, "is_disabled": false, "is_view": this.salesInvoice_is_column_visible('vehicle_number',false), "input_type": 'text'
      },
      {
        "display": 'Override LUT',
        "value": response.override_lut=='1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false, "is_editable": false, "is_disabled": true, "is_view": this.company_setup.overwrite_lut_logic_checkbox_visible_in_sales_invoice =='1', "input_type": 'checkbox'
      },

    );

  }
  showProformaInvoice(response) {

    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"

    response.vendor_details = response.vendor_first_name + " " + response.vendor_last_name;
    response.bill_to_location = response.bill_location_nickname_9_digit + " (" + response.bill_location_code_9_digit + ")";
    response.ship_to_location = response.ship_location_nickname_9_digit + " (" + response.ship_location_code_9_digit + ")";
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Invoice No',
        "value": response.cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Customer Invoice No',
        "value": response.invoice_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Invoice Date',
        "value": this.webService.formatDate(response.date_added, 'yy-mm-dd', '-'),
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Invoice Due Date',
        "value": response.invoice_due_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Customer Invoice Date',
        "value": response.vendor_invoice_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Customer Name',
        "value": response.vendor,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
    );

  }
  showStn(response) {

    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.user.first_name + " " + response.user.last_name + " (" + response.user.employee_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'STN NO',
        "value": response.stn_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Transfer Type',
        "value": response.transfertype,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }, {
      "display": 'BOQ',
      "value": response.is_boq,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq == 'YES' ? true : false,
    }, {
      "display": 'BOQ Name',
      "value": response.boq_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq == 'YES' ? true : false,
    },
      {
        "display": 'BOQ Quantity',
        "value": response.boq_quantity,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq == 'YES' ? true : false,
      },
      {
        "display": 'From Location',
        "value": response.fromlocation,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Dimension',
        "value": response.dimension_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": response.dimension_name != '' ? true : false, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'To Location',
        "value": response.tolocation,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Product Types',
        "value": response.type_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
    );

  }
  showPr(response) {  
    this.company_setup.is_sales_order_no_visible_in_pr = this.company_setup.is_sales_order_no_visible_in_pr ? this.company_setup.is_sales_order_no_visible_in_pr : '0';
    this.company_setup.is_pr_is_rented_visible = this.company_setup.is_pr_is_rented_visible ? this.company_setup.is_pr_is_rented_visible : '0'
    this.company_setup.is_pr_priority_visible = this.company_setup.is_pr_priority_visible ? this.company_setup.is_pr_priority_visible : '0'
    this.company_setup.is_pr_recoverable_type_visible = this.company_setup.is_pr_recoverable_type_visible ? this.company_setup.is_pr_recoverable_type_visible : '0'
    this.company_setup.is_boq_pr_visible = this.company_setup.is_boq_pr_visible ? this.company_setup.is_boq_pr_visible : '0'
    this.company_setup.is_pr_type_visible = this.company_setup.is_pr_type_visible ? this.company_setup.is_pr_type_visible : '0'
    this.company_setup.is_sales_order_no_visible_in_pr = this.company_setup.is_sales_order_no_visible_in_pr ? this.company_setup.is_sales_order_no_visible_in_pr : '0';
    this.company_setup.pr_customer_custom_name = this.company_setup.pr_customer_custom_name ? this.company_setup.pr_customer_custom_name : 'Customer';
    this.company_setup.is_communication_mail_id_visible_in_pr = this.company_setup.is_communication_mail_id_visible_in_pr ? this.company_setup.is_communication_mail_id_visible_in_pr : '0';
    this.company_setup.enable_ddc_in_pr = this.company_setup.enable_ddc_in_pr ? this.company_setup.enable_ddc_in_pr : '0';
    this.company_setup.is_show_vendor_at_pr_level = this.company_setup.is_show_vendor_at_pr_level ? this.company_setup.is_show_vendor_at_pr_level : '0';
    this.company_setup.is_vendor_editable_in_pr_approver = this.company_setup.is_vendor_editable_in_pr_approver ? this.company_setup.is_vendor_editable_in_pr_approver : '0';
    this.company_setup.enable_request_type_dropdown_in_pr = this.company_setup.enable_request_type_dropdown_in_pr ? this.company_setup.enable_request_type_dropdown_in_pr : '0';
    response.recoverable_type_name = response.recoverable_type_name ? response.recoverable_type_name : '';
    response.priority_name = response.priority_name ? response.priority_name : '';
    response.is_rented = response.is_rented ? response.is_rented : '';
    response.dimension_name = response.dimension_name ? response.dimension_name : ''
    response.order_type_name = response.order_type_name ? response.order_type_name : ''
    response.purpose = response.purpose ? response.purpose : ''
    response.justification = response.justification ? response.justification : ''
    response.project_po_no = response.project_po_no ? response.project_po_no : ''
    response.project_po_date = response.project_po_date ? response.project_po_date : ''
    response.field_1 = response.field_1 ? response.field_1 : ''
    response.field_2 = response.field_2 ? response.field_2 : ''
    response.is_different_document_currency = response.is_different_document_currency ? response.is_different_document_currency : '0'
    response.conversion_rate = response.conversion_rate ? response.conversion_rate : ''
    response.currency_name = response.currency_name ? response.currency_name : ''
    response.currency_code = response.currency_code ? response.currency_code : '',



    response.task_details=response.task_details?response.task_details:(response.task_detail?response.task_detail:'')
    response.task_available_budget=response.task_available_budget?response.task_available_budget:(response.task_available_budget?response.task_available_budget:'') 
    response.purchase_type_document_name = response.purchase_type_document_name ? response.purchase_type_document_name : ''
    response.purchase_organization_name = response.purchase_organization_name ? response.purchase_organization_name : ''
    response.purchase_group_name = response.purchase_group_name ? response.purchase_group_name : ''

    this.company_setup.show_custom_ship_location = this.company_setup.show_loc_dropdown == '1' ? false : true;  

    let salesOrderNoVisible:any ='';
    let salesOrderNo:any = '';
    if(this.company_setup.is_sales_order_no_visible_in_pr=='1'){
      salesOrderNoVisible = 'Sales Order No';
      salesOrderNo  = response.sales_order_no ? response.sales_order_no :'';
    }
    response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name + " (" + response.project_code + ")";
    }
    response.dept = '';
    response.lob = '';
    response.loc = '';
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep !='1'){
      response.lob = response.ship_lob_code!='' && response.ship_lob_code!=null ? response.ship_lob_name + " (" + response.ship_lob_code + ")" : response.ship_lob_name;
      response.loc = response.ship_primary_loc_code!='' && response.ship_primary_loc_code!=null ? response.ship_primary_loc_name + " (" + response.ship_primary_loc_code + ")" : response.ship_primary_loc_name;
      response.dept = response.ship_dept_code!='' && response.ship_dept_code!=null ? response.ship_dept_name + " (" + response.ship_dept_code + ")" : response.ship_dept_name;

    }else{
      response.lob = response.ship_lob_name ? response.ship_lob_name : '';
      response.loc = response.ship_primary_loc_name ? response.ship_primary_loc_name : '';
      response.dept = response.ship_dept_name ? response.ship_dept_name : '';
    }
    response.task_name = response.task_name ? response.task_name : '';
    response.task_code = response.task_code ? response.task_code : '';
    response.task_detail = '';
    if (response.task_name != '' && response.task_name != undefined) {
      response.task_detail = response.task_name + " (" + response.task_code + ")";
    }

    if(response.boq_description!=''&&response.boq_description!=undefined&&response.boq_description!=null)
    {
      response.boq_name=response.boq_name+"-"+response.boq_description;
    }
    if(response.boq_sales_order_no!=''&&response.boq_sales_order_no!=undefined&&response.boq_sales_order_no!=null)
    {
      response.boq_name=response.boq_name+"("+response.boq_sales_order_no+")";
    }
    if (response.productcode != '' && response.productcode != undefined && response.productcode != null) {
      response.boq_name = response.boq_name + "(" + response.productcode + ")";
    }
    response.customer_first_name = response.customer_first_name ? response.customer_first_name : '';
    response.customer_last_name = response.customer_last_name ? response.customer_last_name : '';

    response.customer_code = response.customer_code ? response.customer_code : '';
    // response.customer_detail = '';
    // if (response.customer_first_name != '' && response.customer_first_name != undefined) {
      response.customer_detail = response.customer_detail?response.customer_detail:(response.customer_address?response.customer_address:'');
    // }
//     let pr_no:any=response.pr_id;
//     if(response.current_version!='' && response.current_version!=undefined && response.current_version!=null)
//     {
//       pr_no=pr_no+" "+response.current_version;
//     }
//     response.is_draft=response.is_draft?response.is_draft:'0'
// if(response.is_draft=='1')
// {
// pr_no='';
// }
      if(response.pr_date != "" && response.pr_date != null && response.pr_date != undefined){
        response.pr_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(response.pr_date),this.company_setup.in_invoice_date_format)
      }
      
      if(response.project_po_date != "" && response.project_po_date != null && response.project_po_date != undefined){
        response.project_po_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(response.project_po_date),this.company_setup.in_invoice_date_format)
      }
      //Communication email response
      if(response.communication_email != '' && response.communication_email != null && response.communication_email != undefined && response.communication_email.length != 0){
        response.communication_email = response.communication_email.map(item => item.value).join(',');
      }
      response.vendor_address = response.vendor_address ? response.vendor_address : '';
      this.showAvailableBudget = (this.divDetails.showAvailableBudget && this.divDetails.showAvailableBudget == "0") ? false: true;
      this.showAmounts = (this.divDetails.showAmounts && this.divDetails.showAmounts == "0") ? false: true;
      

    // i.requested_by = i.user.first_name + " " + i.user.last_name + " (" + i.user.employee_code + ")"
    this.commonVariableList.divList.push({
      "display": 'Requested By',
      "value": response.requested_by,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
      {
        "display": 'PR NO',
      "value": response.pr_id,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'PR Date',
      "value": response.pr_date,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'PR Type',
      "value": response.pr_type == '1' ? 'Going For Consumption' : '' || response.pr_type == '2' ? 'Going For Purchase' : '',
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_pr_type_visible == '1'&& response.pr_type!='0' && response.pr_type!='' && response.pr_type!=undefined && response.pr_type!=null) ? true : false, "input_type": 'radio'
    },
    {
      "display": this.company_setup.custom_ship_location_name,
      "value": response.location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.show_custom_ship_location && this.company_setup.show_loc_dropdown=='0' && this.company_setup.show_lob_dropdown=='0', "input_type": 'text'
    }, {
      "display": this.company_setup.custom_name_for_lob,
      "value": response.lob,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_lob_dropdown == '1')? true : false, "input_type": 'text'
    },{
      "display":this.company_setup.custom_name_for_loc,
      "value": response.loc,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_loc_dropdown == '1')? true : false, "input_type": 'text'
    },{
      "display": this.company_setup.custom_name_for_dept,
      "value": response.dept,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_dept_dropdown == '1')? true : false, "input_type": 'text'
    },
    {
      "display": 'Dimension',
      "value": response.dimension_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.dimension_name != '' && this.company_setup.in_pr_dimension_visible == '1' ? true : false,
      "input_type": 'text'
    }, 
    {
      "display": 'Select Vendor Location',
      "value": response.vendor_address,
      "div_size": 'col-sm-2 div1',"is_html": false,"is_editable": false,"is_disabled": true,"is_view": response.vendor_address && this.company_setup.is_show_vendor_at_pr_level =='1' && (this.page_url != 'update-pr' || (this.page_url == 'update-pr' && this.company_setup.is_vendor_editable_in_pr_approver != '1')) ? true : false,"input_type": 'text'
    },
    {
      "display": 'Department',
      "value": response.department_name,
      "div_size": 'col-sm-3', "is_disabled": true, "is_view": response.department_name ? true : false,
      "input_type": 'text'
    }
      , {
        "display": 'Recoverable Type',
        "value": response.recoverable_type_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.recoverable_type_name == '' ? false : true
        , "input_type": 'text'
      }
      , {
        "display": 'Priority',
        "value": response.priority_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.priority_name == '') ? false : true
        , "input_type": 'text'
      }
      , {
        "display": 'Is Rented',
        "value": response.is_rented == '1' ? 'YES' : '' || response.is_rented == '0' ? 'No' : '' || response.is_rented == '' ? '' : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.is_rented == '') ? false : true
        , "input_type": 'text'
      },
      {
        "display": 'Is BOQ',
        "value": response.is_boq,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_pr_visible == '1', "input_type": 'checkbox'
      }, {
      "display": 'BOQ',
      "value": response.boq_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_pr_visible == '1', "input_type": 'text'
    }, {
      "display": 'BOQ Unit',
      "value": response.boq_quantity,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_pr_visible == '1', "input_type": 'text'
    },
    {
      "display": 'Total No Of Unit',
      "value": (response.total_boq_unit?response.total_boq_unit:''),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(response.total_boq_unit?response.total_boq_unit:'')!=''&& response.is_boq && this.company_setup.is_boq_pr_visible == '1', "input_type": 'text'
    },
      {
        "display": this.company_setup.rename_project ? this.company_setup.rename_project : 'Project',
        "value": response.project_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.project_detail != '') && (this.company_setup.is_budget_selection_at_item_level_in_product_table == '0') && (this.company_setup.is_project_visible_in_pr == '1' ) ? true : false, "input_type": 'text',
      },
      {
        "display": this.company_setup.rename_task ? this.company_setup.rename_task : 'Task',
        "value": response.task_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.task_detail != '') && (this.company_setup.is_budget_selection_at_item_level_in_product_table == '0') && (this.company_setup.is_task_visible_in_pr == '1' ) ? true : false, "input_type": 'text',
      },
      {
        "display":`Available Budget(${this.company_setup.currency_icon})`,
        "value": response.task_available_budget,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.task_available_budget!= ''&& response.task_detail!=''&&this.company_setup.task_available_budget == '1' && this.company_setup.is_budget_selection_at_item_level_in_product_table == '0' && this.showAvailableBudget) ? true : false, "input_type": 'text'
      }
      , {
        "display": this.company_setup.pr_customer_custom_name,
        "value": response.customer_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.customer_detail != '') ? true : false, "input_type": 'text'
      },
       {
        "display": salesOrderNoVisible,
        "value": salesOrderNo,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (salesOrderNo != '') ? true : false, "input_type": 'text'
      },
      {
        "display": this.getPrColumnName('purpose', 'Purpose'),
        "value": response.purpose,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_pr_column_visible('purpose', false) ? true : false, "input_type": 'text'
      },
      {
        "display": this.getPrColumnName('justification', 'Justification'),
        "value": response.justification,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_pr_column_visible('justification', false) ? true : false, "input_type": 'text'
      },
      {
        "display": this.getPrColumnName('project_po_no', 'Project Po No'),
        "value": response.project_po_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_pr_column_visible('project_po_no', false) ? true : false, "input_type": 'text'
      },
      {
        "display": this.getPrColumnName('project_po_date', 'Project Po Date'),
        "value": response.project_po_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_pr_column_visible('project_po_date', false) ? true : false, "input_type": 'text'
      },
      {
        "display": this.getPrColumnName('field_1', 'Field 1'),
        "value": response.field_1,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_pr_column_visible('field_1', false) ? true : false, "input_type": 'text'
      },
      {
        "display": this.getPrColumnName('field_2', 'Field 2'),
        "value": response.field_2,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_pr_column_visible('field_2', false) ? true : false, "input_type": 'text'
      },
      {
        "display": this.getPrColumnName('order_type', 'Order Type'),
        "value": response.order_type_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_pr_column_visible('order_type', false) ? true : false, "input_type": 'text'
      },
      {
        "display": 'Communication Mail Id',
        "value": response.communication_email,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_communication_mail_id_visible_in_pr=='1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Request Type',
        "value": response.request_type,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.enable_request_type_dropdown_in_pr=='1' ? true : false, "input_type": 'text'
      },
      {
        // "display": 'Is DDC',
        "display": this.company_setup.is_different_document_currency ?  this.company_setup.is_different_document_currency : 'IS DDC',"id": "is_different_document_currency",
        "value": response.is_different_document_currency=='1',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.enable_ddc_in_pr == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Conversion Rate',"id": "conversion_rate",
        "value": response.conversion_rate,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Currency',"id": "currency_name",
        "value": response.currency_name + " " + "(" + response.currency_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Purchase Document Type',
        "value": response.purchase_type_document_name ? response.purchase_type_document_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_purchase_document_types_visible == '1') && (response.purchase_type_document_name && response.purchase_type_document_name !== '') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Purchase Organization',
        "value": response.purchase_organization_name ? response.purchase_organization_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_purchase_organizations_visible == '1') && (response.purchase_organization_name && response.purchase_organization_name !== '') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Purchase Group',
        "value": response.purchase_group_name ? response.purchase_group_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_purchase_groups_visible == '1') && (response.purchase_group_name && response.purchase_group_name !== '') ? true : false, "input_type": 'text'
      },
    );





  }
  showIr(response) {

    this.irFields.applyIrFieldsTable(this.company_setup);
    this.company_setup.is_ir_is_rented_visible = this.company_setup.is_ir_is_rented_visible ? this.company_setup.is_ir_is_rented_visible : '0'
    this.company_setup.is_ir_priority_visible = this.company_setup.is_ir_priority_visible ? this.company_setup.is_ir_priority_visible : '0'
    this.company_setup.is_ir_recoverable_type_visible = this.company_setup.is_ir_recoverable_type_visible ? this.company_setup.is_ir_recoverable_type_visible : '0'
    this.company_setup.is_boq_ir_visible = this.company_setup.is_boq_ir_visible ? this.company_setup.is_boq_ir_visible : '0'
    this.company_setup.is_ir_type_visible = this.company_setup.is_ir_type_visible ? this.company_setup.is_ir_type_visible : '0'
    this.company_setup.enable_common_request_to_cost_center = this.company_setup.enable_common_request_to_cost_center ? this.company_setup.enable_common_request_to_cost_center : '0'

    response.recoverable_type_name = response.recoverable_type_name ? response.recoverable_type_name : '';
    response.priority_name = response.priority_name ? response.priority_name : '';
    response.is_rented = response.is_rented ? response.is_rented : '';
    response.dimension_name = response.dimension_name ? response.dimension_name : ''
    response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name + " (" + response.project_code + ")";
    }

    response.customer_first_name = response.customer_first_name ? response.customer_first_name : '';
    response.customer_last_name = response.customer_last_name ? response.customer_last_name : '';

    response.customer_code = response.customer_code ? response.customer_code : '';
    response.customer_detail = '';
    if (response.customer_first_name != '' && response.customer_first_name != undefined) {
      response.customer_detail = response.customer_first_name + " " + response.customer_last_name + " (" + response.customer_code + ")";
    }
    response.expected_production_start_date=response.expected_production_start_date? this.webService.formatDate(response.expected_production_start_date, 'yy-mm-dd', '-') :'';
    response.expected_production_end_date=response.expected_production_end_date? this.webService.formatDate(response.expected_production_end_date, 'yy-mm-dd', '-') :'';
    // i.requested_by = i.user.first_name + " " + i.user.last_name + " (" + i.user.employee_code + ")"
    this.commonVariableList.divList.push({
      "display": 'Requested By',
      "value": response.requested_by,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'IR Date',
      "value": response.ir_date,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'IR Type',
      "value": response.ir_type == '1' ? 'Going For Consumption' : '' || response.ir_type == '2' ? 'Going For Production' : '',
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_ir_type_visible == '1' ? true : false, "input_type": 'radio'
    }, {
      "display": 'Requested From Cost Centre',
      "value": response.location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'Requested To Cost Centre',
      "value": response.req_to_loc,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.enable_common_request_to_cost_center == '1' ? true : false, "input_type": 'text'
    }, {
      "display": 'Dimension',
      "value": response.dimension_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.dimension_name != '' && this.company_setup.in_ir_dimention_visible == "1") ? true : false,
      "input_type": 'text'
    }, {
      "display": 'Department',
      "value": response.department_name,
      "div_size": 'col-sm-3', "is_disabled": true, "is_view": response.department_name ? true : false,
      "input_type": 'text'
    }
      , {
        "display": 'Recoverable Type',
        "value": response.recoverable_type_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.recoverable_type_name == '' ? false : true
        , "input_type": 'text'
      }
      , {
        "display": 'Priority',
        "value": response.priority_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.priority_name == '') ? false : true
        , "input_type": 'text'
      }
      , {
        "display": 'Is Rented',
        "value": response.is_rented == '1' ? 'YES' : '' || response.is_rented == '0' ? 'No' : '' || response.is_rented == '' ? '' : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.is_rented == '') ? false : true
        , "input_type": 'text'
      },
      {
        "display": 'Is BOQ',
        "value": response.is_boq,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_ir_visible == '1' && response.boq_details !='', "input_type": 'checkbox'
      }, {
      "display": 'BOQ',
      "value": response.boq_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_ir_visible == '1' && response.boq_details !='', "input_type": 'text'
    }, {
      "display": 'BOQ Unit',
      "value": response.boq_quantity,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_ir_visible == '1' && response.boq_details !='', "input_type": 'text'
    },
    {
      "display": 'Total No Of Unit',
      "value": (response.total_boq_unit?response.total_boq_unit:''),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_ir_visible == '1' && response.boq_details !='', "input_type": 'text'
    },
      {
        "display": 'Project',
        "value": response.project_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.project_detail != '') ? true : false, "input_type": 'text'
      }
      , {
        "display": 'Customer',
        "value": response.customer_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.customer_detail != '') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Expected Production Start Date',
        "value": response.expected_production_start_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.expected_production_start_date != '' && this.company_setup.in_ir_expected_production_start_date_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Expected Production End Date',
        "value": response.expected_production_end_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.expected_production_end_date != '' &&  this.company_setup.in_ir_expected_production_end_date_visible == '1' ? true : false, "input_type": 'text'
      },
    );


  }
  showIRHistory(response) {

    this.irFields.applyIrFieldsTable(this.company_setup);
    this.company_setup.is_ir_is_rented_visible = this.company_setup.is_ir_is_rented_visible ? this.company_setup.is_ir_is_rented_visible : '0'
    this.company_setup.is_ir_priority_visible = this.company_setup.is_ir_priority_visible ? this.company_setup.is_ir_priority_visible : '0'
    this.company_setup.is_ir_recoverable_type_visible = this.company_setup.is_ir_recoverable_type_visible ? this.company_setup.is_ir_recoverable_type_visible : '0'
    this.company_setup.is_boq_ir_visible = this.company_setup.is_boq_ir_visible ? this.company_setup.is_boq_ir_visible : '0'
    this.company_setup.is_ir_type_visible = this.company_setup.is_ir_type_visible ? this.company_setup.is_ir_type_visible : '0'

    response.recoverable_type_name = response.recoverable_type_name ? response.recoverable_type_name : '';
    response.priority_name = response.priority_name ? response.priority_name : '';
    response.is_rented = response.is_rented ? response.is_rented : '';
    response.dimension_name = response.dimension_name ? response.dimension_name : ''
    response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name + " (" + response.project_code + ")";
    }

    response.customer_first_name = response.customer_first_name ? response.customer_first_name : '';
    response.customer_last_name = response.customer_last_name ? response.customer_last_name : '';

    response.customer_code = response.customer_code ? response.customer_code : '';
    response.customer_detail = '';
    if (response.customer_first_name != '' && response.customer_first_name != undefined) {
      response.customer_detail = response.customer_first_name + " " + response.customer_last_name + " (" + response.customer_code + ")";
    }

    // i.requested_by = i.user.first_name + " " + i.user.last_name + " (" + i.user.employee_code + ")"
    this.commonVariableList.divList.push({
      "display": this.irFields.getIrFieldDisplayName(this.company_setup, 'required_by', 'Required By'),
      "value": response.requested_by,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'IR NO',
      "value": response.ir_id,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'IR Date',
      "value": response.ir_date,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'IR Type',
      "value": response.ir_type == '1' ? 'Going For Consumption' : '' || response.ir_type == '2' ? 'Going For Production' : '',
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_ir_type_visible == '1' ? true : false, "input_type": 'radio'
    }, {
      "display": 'Ship Location',
      "value": response.location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'Dimension',
      "value": response.dimension_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.dimension_name != '' ? true : false,
      "input_type": 'text'
    }, {
      "display": 'Department',
      "value": response.department_name,
      "div_size": 'col-sm-3', "is_disabled": true, "is_view": response.department_name ? true : false,
      "input_type": 'text'
    }
      , {
        "display": 'Recoverable Type',
        "value": response.recoverable_type_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.recoverable_type_name == '' ? false : true
        , "input_type": 'text'
      }
      , {
        "display": 'Priority',
        "value": response.priority_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.priority_name == '') ? false : true
        , "input_type": 'text'
      }
      , {
        "display": 'Is Rented',
        "value": response.is_rented == '1' ? 'YES' : '' || response.is_rented == '0' ? 'No' : '' || response.is_rented == '' ? '' : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.is_rented == '') ? false : true
        , "input_type": 'text'
      },
      {
        "display": 'Is BOQ',
        "value": response.is_boq,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_pr_visible == '1', "input_type": 'checkbox'
      }, {
      "display": 'BOQ',
      "value": response.boq_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_pr_visible == '1', "input_type": 'text'
    }, {
      "display": 'BOQ Unit',
      "value": response.boq_quantity,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq && this.company_setup.is_boq_pr_visible == '1', "input_type": 'text'
    },
      {
        "display": 'Project',
        "value": response.project_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.project_detail != '') ? true : false, "input_type": 'text'
      }
      , {
        "display": 'Customer',
        "value": response.customer_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.customer_detail != '') ? true : false, "input_type": 'text'
      },
    );


  }
  showMpr(response) {
    response.requested_by_department_name = response.department_name ? response.department_name : '';
    response.requested_by = response.added_by_first_name + response.added_by_last_name + "(" + response.added_by_employee_code + ")";
    this.commonVariableList.divList.push({
      "display": 'Requested By',
      "value": response.requested_by,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'MPR NO',
      "value": response.cs_id,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'MPR Date',
      "value": response.mpr_date ? response.mpr_date : response.date_added,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'Ship Location',
      "value": response.location_nickname_9_digit + "(" + response.location_code_9_digit + ")",
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    );


  }
  showMp(response) {

    response.requested_by_department_name = response.user.department_name ? response.user.department_name : '';

    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.user.first_name + " " + response.user.last_name + " (" + response.user.employee_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'MP NO',
        "value": response.plan_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'MP Date',
        "value": response.mp_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      });

  }
  showLogistics(response) {

    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.user.first_name + " " + response.user.last_name + " (" + response.user.employee_code + ")",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Logistics Date',
        "value": response.logistic_date,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Delivery Status',
        "value": response.delivery_status,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Save Type',
        "value": response.is_final=='1'?'Send To Logistics':'Normal Save',
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      );

  }
  showSi(response) {
    response.requested_by_department_name = response.user.department_name ? response.user.department_name : '';

    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.user.first_name + " " + response.user.last_name + " (" + response.user.employee_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Stock NO',
        "value": response.stock_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Stock Date',
        "value": response.si_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      });

  }
  diff_json_data = {};
  old_json_data = {};
  show_difference : boolean = false;
  skip_diff : any = [];
  showPo(response) {
    // console.log("response ",response)
    // console.log("this.divDetails.old_json_data ",this.divDetails.old_json_data)
    this.diff_json_data = this.divDetails.diff_json_data ? this.divDetails.diff_json_data : {};
    this.show_difference = this.divDetails.show_difference && this.divDetails.show_difference=='1' ? true : false;
    let old_json_data = this.divDetails.old_json_data ? this.divDetails.old_json_data : {};
    
    // For invoice approval screen, ensure old_json_data is properly set
    if (this.divDetails.is_invoice_approval_screen && this.divDetails.invoice_data_reqsted && old_json_data) {
      // Map invoice_no to vendor_invoice_no if needed (for divList compatibility)
      if (old_json_data['invoice_no'] && !old_json_data['vendor_invoice_no']) {
        old_json_data['vendor_invoice_no'] = old_json_data['invoice_no'];
      }
      if (old_json_data['vendor_invoice_no'] && !old_json_data['invoice_no']) {
        old_json_data['invoice_no'] = old_json_data['vendor_invoice_no'];
      }
    }
    
    // Assign old_json_data to this.old_json_data for use in template
    this.old_json_data = old_json_data;
    
    if(this.show_difference){
      this.skip_diff = ["po_id", "modified_remarks", "po_date", "last_modified", "modify_by"];
      old_json_data.storage_location = old_json_data.storage_location ? old_json_data.storage_location : ((old_json_data.storage_location_code ? old_json_data.storage_location_code : '') + (old_json_data.storage_location_description ? (' - ' + old_json_data.storage_location_description) : ''));
      old_json_data.channel_type = old_json_data.channel_type_name ? old_json_data.channel_type_name : (old_json_data.channel_type ? old_json_data.channel_type : '');
      old_json_data.requested_by = old_json_data.requested_by_first_name + " " + old_json_data.requested_by_last_name + " " + "(" + old_json_data.requested_by_employeecode + ")"

      if(old_json_data.po_expiry_date != "" && old_json_data.po_expiry_date != null && old_json_data.po_expiry_date != undefined){
        old_json_data.po_expiry_date = this.webService.formatDateAccordingToSetup(old_json_data.po_expiry_date,this.company_setup.in_invoice_date_format)
      }
      if(old_json_data.po_date != "" && old_json_data.po_date != null && old_json_data.po_date != undefined){
        old_json_data.po_date = this.webService.formatDateAccordingToSetup(old_json_data.po_date,this.company_setup.in_invoice_date_format)
      }
      // Format invoice dates for old data to match new data format
      // Format date_added (Invoice Receipt Date)
      if(old_json_data.date_added != "" && old_json_data.date_added != null && old_json_data.date_added != undefined){
        old_json_data.date_added = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(old_json_data.date_added),this.company_setup.in_invoice_date_format)
      }
      // Format invoice_date (Invoice Receipt Date - mapped from date_added in some cases)
      if(old_json_data.invoice_date != "" && old_json_data.invoice_date != null && old_json_data.invoice_date != undefined){
        old_json_data.invoice_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(old_json_data.invoice_date),this.company_setup.in_invoice_date_format)
      } else if(old_json_data.date_added != "" && old_json_data.date_added != null && old_json_data.date_added != undefined){
        // Map date_added to invoice_date if invoice_date doesn't exist (for Invoice Receipt Date display)
        old_json_data.invoice_date = old_json_data.date_added;
      }
      // Format invoice_due_date (Invoice Due Date)
      if(old_json_data.invoice_due_date != "" && old_json_data.invoice_due_date != null && old_json_data.invoice_due_date != undefined){
        old_json_data.invoice_due_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(old_json_data.invoice_due_date),this.company_setup.in_invoice_date_format)
      }
      old_json_data.project_name = old_json_data.project_name ? old_json_data.project_name : '';
      old_json_data.project_code = old_json_data.project_code ? old_json_data.project_code : '';
      old_json_data.project_detail = '';
      if (old_json_data.project_name != '' && old_json_data.project_name != undefined) {
        old_json_data.project_detail = old_json_data.project_name + " (" + old_json_data.project_code + ")";
      }
      old_json_data.currency_name = old_json_data.currency_name + " " + "(" + old_json_data.currency_code + ")";
      old_json_data.bill_location_nickname_9_digit = (response.bill_location_nickname_9_digit?response.bill_location_nickname_9_digit:'') + " " + (response.bill_location_code_9_digit?("(" + response.bill_location_code_9_digit + ")"):'')

      old_json_data.vendor_code = old_json_data.vendor_code ? old_json_data.vendor_code : '';
      old_json_data.vendor_address=old_json_data.vendor_address?old_json_data.vendor_address:''
      if(old_json_data.vendor_address=='')
      {
        if(old_json_data.vendor_first_name!='' && old_json_data.vendor_first_name!=null && old_json_data.vendor_first_name!=undefined)
        {
        old_json_data.vendor_address= old_json_data.vendor_first_name + " " + old_json_data.vendor_last_name + " " + "(" + old_json_data.vendor_code + ")" + " " + "(City - " + old_json_data.vendor_city_name + ")" + " " + "(GST - " + old_json_data.vendor_gst_no + ")";
        }
      }
      old_json_data.requested_by_department_name = old_json_data.department_name ? old_json_data.department_name : '';
      old_json_data.dimension_type_name = old_json_data.dimension_type_name ? old_json_data.dimension_type_name : '';
      if (old_json_data.dimension_type_name != '') {
        old_json_data.dimension_type_name = " (Type -" + old_json_data.dimension_type_name + ")"
      }
      old_json_data.sales_order_no = old_json_data.sales_order_no ? old_json_data.sales_order_no : '';

      old_json_data.task_name = old_json_data.task_name ? old_json_data.task_name : '';
      old_json_data.task_code = old_json_data.task_code ? old_json_data.task_code : '';
      old_json_data.task_details = '';
      if (old_json_data.task_name != '' && old_json_data.task_name != undefined) {
        old_json_data.task_details = old_json_data.task_name + " (" + old_json_data.task_code + ")";
      }

      old_json_data.customer_first_name = old_json_data.customer_first_name ? old_json_data.customer_first_name : '';
      old_json_data.customer_last_name = old_json_data.customer_last_name ? old_json_data.customer_last_name : '';

      old_json_data.customer_code = old_json_data.customer_code ? old_json_data.customer_code : '';
      old_json_data.customer_detail = '';
      if (old_json_data.customer_first_name != '' && old_json_data.customer_first_name != undefined) {
        old_json_data.customer_detail = old_json_data.customer_first_name + " " + old_json_data.customer_last_name + " (" + old_json_data.customer_code + ")";
      }
      old_json_data.customer_address=old_json_data.customer_address?old_json_data.customer_address:'';
      old_json_data.is_custom_ship_to_location = old_json_data.is_custom_ship_to_location ? old_json_data.is_custom_ship_to_location : '0';
      old_json_data.custom_ship_to_location = old_json_data.custom_ship_to_location ? old_json_data.custom_ship_to_location : '0';
      if(old_json_data.boq_description!=''&&old_json_data.boq_description!=undefined&&old_json_data.boq_description!=null)
      {
        old_json_data.boq_name=old_json_data.boq_name+"-"+old_json_data.boq_description;
      }
      if(old_json_data.boq_sales_order_no!=''&&old_json_data.boq_sales_order_no!=undefined&&old_json_data.boq_sales_order_no!=null)
      {
        old_json_data.boq_name=old_json_data.boq_name+"("+old_json_data.boq_sales_order_no+")";
      }
      old_json_data.is_accrual = old_json_data.is_accrual=='1'?true:false;
      old_json_data.accrual_date = old_json_data.accrual_date ? old_json_data.accrual_date : '';
      old_json_data.task_name = old_json_data.task_name ? old_json_data.task_name : '';
      old_json_data.task_code = old_json_data.task_code ? old_json_data.task_code : '';
      //old_json_data.task_details = old_json_data.task_name ? `${old_json_data.task_name} (${old_json_data.task_code})` : '';
      old_json_data.vendor_contact_person_name = old_json_data.vendor_contact_person_name ? old_json_data.vendor_contact_person_name : '';
      old_json_data.vendor_contact_person_phone = old_json_data.vendor_contact_person_phone ? old_json_data.vendor_contact_person_phone : '';
      old_json_data.vendor_contact_person_email = old_json_data.vendor_contact_person_email ? old_json_data.vendor_contact_person_email : '';
      old_json_data.vendor_additional_field_1 = old_json_data.vendor_additional_field_1 ? old_json_data.vendor_additional_field_1 : '';
      old_json_data.vendor_additional_field_2 = old_json_data.vendor_additional_field_2 ? old_json_data.vendor_additional_field_2 : '';
      old_json_data.receiver_contact_person_name = old_json_data.receiver_contact_person_name ? old_json_data.receiver_contact_person_name : '';
      old_json_data.receiver_contact_person_phone = old_json_data.receiver_contact_person_phone ? old_json_data.receiver_contact_person_phone : '';
      old_json_data.receiver_contact_person_email = old_json_data.receiver_contact_person_email ? old_json_data.receiver_contact_person_email : '';
      old_json_data.receiver_additional_field_1 = old_json_data.receiver_additional_field_1 ? old_json_data.receiver_additional_field_1 : '';
      old_json_data.receiver_additional_field_2 = old_json_data.receiver_additional_field_2 ? old_json_data.receiver_additional_field_2 : '';
      old_json_data.payment_terms_name = old_json_data.payment_terms_name ? old_json_data.payment_terms_name : '';
      old_json_data.payment_terms_description = old_json_data.payment_terms_description ? old_json_data.payment_terms_description : '';
      old_json_data.manufacture_name  = old_json_data.manufacture_name  ? old_json_data.manufacture_name  : '';
      old_json_data.quote_date  = old_json_data.quote_date  ? old_json_data.quote_date  : '';
      old_json_data.purchase_on  = old_json_data.purchase_on  ? old_json_data.purchase_on  : '';
      old_json_data.inco_terms_name  = old_json_data.inco_terms_name  ? old_json_data.inco_terms_name  : '';
      old_json_data.additional_fields_1  = old_json_data.additional_fields_1  ? old_json_data.additional_fields_1  : '';
      old_json_data.additional_fields_2  = old_json_data.additional_fields_2  ? old_json_data.additional_fields_2  : '';
      old_json_data.additional_fields_3  = old_json_data.additional_fields_3  ? old_json_data.additional_fields_3  : '';
      old_json_data.additional_fields_4  = old_json_data.additional_fields_4  ? old_json_data.additional_fields_4  : '';
      old_json_data.additional_fields_5  = old_json_data.additional_fields_5  ? old_json_data.additional_fields_5  : '';
      old_json_data.incoterm_description  = old_json_data.incoterm_description  ? old_json_data.incoterm_description  : '';
      old_json_data.approval_matrix_id = old_json_data.approval_matrix_id ? old_json_data.approval_matrix_id : '';
      old_json_data.po_approval_matrix_name = old_json_data.po_approval_matrix_name ? old_json_data.po_approval_matrix_name : '';

      old_json_data.po_budget_amount = old_json_data.po_budget_amount ? old_json_data.po_budget_amount : "";
      old_json_data.po_consumed_budget = old_json_data.po_consumed_budget ? +old_json_data.po_consumed_budget : "";
      old_json_data.po_available_budget = old_json_data.po_available_budget ? +old_json_data.po_available_budget : "";
      if(old_json_data.po_budget_amount != "" && old_json_data.po_budget_amount != "Budget Not Set"){
        old_json_data.po_budget_amount = old_json_data.po_budget_amount ? +old_json_data.po_budget_amount : "";
        old_json_data.po_budget_amount = old_json_data.po_budget_amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
      }
      if(old_json_data.po_consumed_budget != ""){
        old_json_data.po_consumed_budget = old_json_data.po_consumed_budget.toLocaleString(undefined, { maximumFractionDigits: 2 });
      }
      if(old_json_data.po_available_budget != ""){
        old_json_data.po_available_budget = old_json_data.po_available_budget.toLocaleString(undefined, { maximumFractionDigits: 2 });
      }
      let po_no:any=old_json_data.po_id;
      if(old_json_data.current_version!='' && old_json_data.current_version!=undefined && old_json_data.current_version!=null)
      {
        po_no=po_no+" "+old_json_data.current_version;
      }
      if(old_json_data.communication_email != '' && old_json_data.communication_email != null && old_json_data.communication_email != undefined && old_json_data.communication_email.length != 0){
        old_json_data.communication_email = old_json_data.communication_email.map(item => item.value).join(',');
      }
      old_json_data.is_draft=old_json_data.is_draft?old_json_data.is_draft:'0' 
      if(this.company_setup.hide_numaric_number_in_lob_loc_dep !='1'){
        old_json_data.ship_lob_name = old_json_data.ship_lob_code!='' && old_json_data.ship_lob_code!=null ? old_json_data.ship_lob_name + " (" + old_json_data.ship_lob_code + ")" : old_json_data.ship_lob_name;
        old_json_data.ship_dept_name = old_json_data.ship_dept_code!='' && old_json_data.ship_dept_code!=null ? old_json_data.ship_dept_name + " (" + old_json_data.ship_dept_code + ")" : old_json_data.ship_dept_name;
        old_json_data.ship_primary_loc_name = old_json_data.ship_primary_loc_code!='' && old_json_data.ship_primary_loc_code!=null ? old_json_data.ship_primary_loc_name + " (" + old_json_data.ship_primary_loc_code + ")" : old_json_data.ship_primary_loc_name;
      }else{
        old_json_data.ship_lob_name = old_json_data.ship_lob_name ? old_json_data.ship_lob_name : ''
        old_json_data.ship_dept_name = old_json_data.ship_dept_name ? old_json_data.ship_dept_name : ''
        old_json_data.ship_primary_loc_name = old_json_data.ship_primary_loc_name ? old_json_data.ship_primary_loc_name : ''
      }
    } 
    old_json_data.dimension_type_name ? old_json_data.dimension_type_name : '',
    old_json_data.dimension_name ? old_json_data.dimension_name : ''
    old_json_data.dimension_name = old_json_data.dimension_name + old_json_data.dimension_type_name,
    
    this.old_json_data = old_json_data;
    // Also update divDetails.old_json_data to ensure template can access it
    this.divDetails.old_json_data = old_json_data;
    response.vendor_code = response.vendor_code ? response.vendor_code : '';
    response.vendor_address=response.vendor_address?response.vendor_address:''
    if(response.vendor_address=='')
    {
      if(response.vendor_first_name!='' && response.vendor_first_name!=null && response.vendor_first_name!=undefined)
      {
      response.vendor_address= response.vendor_first_name + " " + response.vendor_last_name + " " + "(" + response.vendor_code + ")" + " " + "(City - " + response.vendor_city_name + ")" + " " + "(GST - " + response.vendor_gst_no + ")";
      }
    }
    response.requested_by_department_name = response.department_name ? response.department_name : '';
    response.dimension_type_name = response.dimension_type_name ? response.dimension_type_name : '';
    if (response.dimension_type_name != '') {
      response.dimension_type_name = " (Type -" + response.dimension_type_name + ")"
    }
    response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name + " (" + response.project_code + ")";
    }
    response.sales_order_no = response.sales_order_no ? response.sales_order_no : '';

    response.task_name = response.task_name ? response.task_name : '';
    response.task_code = response.task_code ? response.task_code : '';
    response.task_details = '';
    if (response.task_name != '' && response.task_name != undefined) {
      response.task_details = response.task_name + " (" + response.task_code + ")";
    }

    response.customer_first_name = response.customer_first_name ? response.customer_first_name : '';
    response.customer_last_name = response.customer_last_name ? response.customer_last_name : '';

    response.customer_code = response.customer_code ? response.customer_code : '';
    response.customer_detail = '';
    if (response.customer_first_name != '' && response.customer_first_name != undefined) {
      response.customer_detail = response.customer_first_name + " " + response.customer_last_name + " (" + response.customer_code + ")";
    }
    response.customer_address=response.customer_address?response.customer_address:'';
    response.is_custom_ship_to_location = response.is_custom_ship_to_location ? response.is_custom_ship_to_location : '0';
    response.custom_ship_to_location = response.custom_ship_to_location ? response.custom_ship_to_location : '0';
    response.productcode = response.productcode ? response.productcode : "";
    if(response.boq_description!=''&&response.boq_description!=undefined&&response.boq_description!=null)
    {
      response.boq_name=response.boq_name+"-"+response.boq_description;
    }
    if(response.boq_sales_order_no!=''&&response.boq_sales_order_no!=undefined&&response.boq_sales_order_no!=null)
    {
      response.boq_name=response.boq_name+"("+response.boq_sales_order_no+")";
    }
    response.is_accrual = response.is_accrual=='1'?true:false;
    response.accrual_date = response.accrual_date ? response.accrual_date : '';
    response.task_name = response.task_name ? response.task_name : '';
    response.task_code = response.task_code ? response.task_code : '';
    //response.task_details = response.task_name ? `${response.task_name} (${response.task_code})` : '';
    response.vendor_contact_person_name = response.vendor_contact_person_name ? response.vendor_contact_person_name : '';
    response.vendor_contact_person_phone = response.vendor_contact_person_phone ? response.vendor_contact_person_phone : '';
    response.vendor_contact_person_email = response.vendor_contact_person_email ? response.vendor_contact_person_email : '';
    response.vendor_additional_field_1 = response.vendor_additional_field_1 ? response.vendor_additional_field_1 : '';
    response.vendor_additional_field_2 = response.vendor_additional_field_2 ? response.vendor_additional_field_2 : '';
    response.receiver_contact_person_name = response.receiver_contact_person_name ? response.receiver_contact_person_name : '';
    response.receiver_contact_person_phone = response.receiver_contact_person_phone ? response.receiver_contact_person_phone : '';
    response.receiver_contact_person_email = response.receiver_contact_person_email ? response.receiver_contact_person_email : '';
    response.receiver_additional_field_1 = response.receiver_additional_field_1 ? response.receiver_additional_field_1 : '';
    response.receiver_additional_field_2 = response.receiver_additional_field_2 ? response.receiver_additional_field_2 : '';
    response.payment_terms_name = response.payment_terms_name ? response.payment_terms_name : '';
    response.payment_terms_description = response.payment_terms_description ? response.payment_terms_description : '';
    response.manufacture_name  = response.manufacture_name  ? response.manufacture_name  : '';
    response.quote_date  = response.quote_date  ? response.quote_date  : '';
    response.purchase_on  = response.purchase_on  ? response.purchase_on  : '';
    response.inco_terms_name  = response.inco_terms_name  ? response.inco_terms_name  : '';
    response.additional_fields_1  = response.additional_fields_1  ? response.additional_fields_1  : '';
    response.additional_fields_2  = response.additional_fields_2  ? response.additional_fields_2  : '';
    response.additional_fields_3  = response.additional_fields_3  ? response.additional_fields_3  : '';
    response.additional_fields_4  = response.additional_fields_4  ? response.additional_fields_4  : '';
    response.additional_fields_5  = response.additional_fields_5  ? response.additional_fields_5  : '';
    response.incoterm_description  = response.incoterm_description  ? response.incoterm_description  : '';
    response.po_expiry_date = response.po_expiry_date ? response.po_expiry_date : "";

    response.po_budget_amount = response.po_budget_amount ? response.po_budget_amount : "";
    response.po_consumed_budget = response.po_consumed_budget ? +response.po_consumed_budget : "";
    response.po_available_budget = response.po_available_budget ? +response.po_available_budget : "";
    response.automatic_advance_request = response.automatic_advance_request ? response.automatic_advance_request : false;
    response.subject = response.subject ? response.subject : '';
    response.reference = response.reference ? response.reference : '';
    response.po_note = response.po_note ? response.po_note : '';
    response.advanceamount = response.advanceamount ? response.advanceamount : "0";
    response.po_series_order_type = response.po_series_order_type ? response.po_series_order_type : '';
    response.is_blanket_po = response.is_blanket_po == '1' ? true : false;
    response.max_po_value = response.max_po_value ? response.max_po_value : '';
    response.storage_location = response.storage_location ? response.storage_location : '';
    response.channel_type = response.channel_type ? response.channel_type : '';
    response.approval_matrix_id = response.approval_matrix_id ? response.approval_matrix_id : '';
    response.po_approval_matrix_name = response.po_approval_matrix_name ? response.po_approval_matrix_name : '';
    response.channel_type_name = response.channel_type_name ? response.channel_type_name : '';
    let po_series_order_type = this.po_type_list.find(item => item.key == response.po_series_order_type);
    if(response.po_budget_amount != "" && response.po_budget_amount != "Budget Not Set"){
      response.po_budget_amount = response.po_budget_amount ? +response.po_budget_amount : "";
      response.po_budget_amount = response.po_budget_amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
    if(response.po_consumed_budget != ""){
      response.po_consumed_budget = response.po_consumed_budget.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
    if(response.po_available_budget != ""){
      response.po_available_budget = response.po_available_budget.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
    let po_no:any=response.po_id;
    if(response.current_version!='' && response.current_version!=undefined && response.current_version!=null)
    {
      po_no=po_no+" "+response.current_version;
    }
    if(response.po_date != "" && response.po_date != null && response.po_date != undefined){
      response.po_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(response.po_date),this.company_setup.in_invoice_date_format)
    }
    if(response.po_expiry_date != "" && response.po_expiry_date != null && response.po_expiry_date != undefined){
      response.po_expiry_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(response.po_expiry_date),this.company_setup.in_invoice_date_format)
    }
    if(response.communication_email != '' && response.communication_email != null && response.communication_email != undefined && response.communication_email.length != 0){
      response.communication_email = response.communication_email.map(item => item.value).join(',');
    }
    response.is_draft=response.is_draft?response.is_draft:'0'
    response.ship_lob_name = response.ship_lob_name ? response.ship_lob_name : "";
    response.ship_primary_loc_name = response.ship_primary_loc_name ? response.ship_primary_loc_name : "";
    response.ship_dept_name = response.ship_dept_name ? response.ship_dept_name : ""; 
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep !='1'){
      response.ship_lob_name = response.ship_lob_code!='' && response.ship_lob_code!=null ? response.ship_lob_name + " (" + response.ship_lob_code + ")" : response.ship_lob_name;
      response.ship_dept_name = response.ship_dept_code!='' && response.ship_dept_code!=null ? response.ship_dept_name + " (" + response.ship_dept_code + ")" : response.ship_dept_name;
      response.ship_primary_loc_name = response.ship_primary_loc_code!='' && response.ship_primary_loc_code!=null ? response.ship_primary_loc_name + " (" + response.ship_primary_loc_code + ")" : response.ship_primary_loc_name;
    }else{
      response.ship_lob_name = response.ship_lob_name ? response.ship_lob_name : ''
      response.ship_dept_name = response.ship_dept_name ? response.ship_dept_name : ''
      response.ship_primary_loc_name = response.ship_primary_loc_name ? response.ship_primary_loc_name : ''
    }
if(response.is_draft=='1')
{
po_no='';
}
    let last_modified:any=response.last_modified;
    if(this.page_url=='po-approval' && response.msme=='1' && response.payment_terms>45) {
      this.userInfo='info blink-1'
      this.user_message = "Vendor is MSME and you are mentioning ‘payment terms’ more than 45 days which may attract Interest and Tax Disallowance"; 
    }

    this.commonVariableList.divList.push(
      {
        "display": 'Requested By', "id": "requested_by",
        "value": response.requested_by_first_name + " " + response.requested_by_last_name + " " + "(" + response.requested_by_employee_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'PO NO',"id": "po_id",
        "value": po_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(po_no!='' && po_no!=undefined && po_no!=null)?true:false, "input_type": 'text'
      },
      {
        "display": 'PO Date',"id": "po_date",
        "value": response.po_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'PO TYPE',
        "value": response.po_series_order_type ? (po_series_order_type.custom_name ? po_series_order_type.custom_name : '') : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.enable_po_type_order_in_po && this.company_setup.enable_po_type_order_in_po == '1' && response.po_series_order_type && response.po_series_order_type != '') ? true : false, "input_type": 'text'
      },
      {
        "display": 'PR Number',
        "value": response.pr_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(response.pr_no == '' || response.pr_no == null) ? false : true, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_po_expiry_date,"id": "po_expiry_date",
        "value": response.po_expiry_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":this.company_setup.po_expiry_date_visible=='1'? true:false, "input_type": 'text'
      },
      {
        "display": 'Last Modified Date',"id": "last_modified",
        "value": response.last_modified,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.page_url == 'po-approval' && (response.last_modified!='' && response.last_modified!=undefined && response.last_modified!=null)?true:false, "input_type": 'text'
      },
      {
        "display": 'Modify By', "id": "modify_by",
        "value": response.requested_by_first_name + " " + response.requested_by_last_name + " " + "(" + response.requested_by_employee_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.page_url == 'po-approval' && response.is_modified == "1" &&
        ( response.requested_by_first_name != '' && response.requested_by_first_name != undefined && response.requested_by_first_name != null ) ? true : false, "input_type": 'text',
      },
      {
        "display": 'Custom Ship Location',"id": "custom_ship_to_location",
        "value": response.custom_ship_to_location,
        "div_size": 'col-sm-2 div1', "is_html":true,"is_editable": false, "is_disabled": true, "is_view": response.is_custom_ship_to_location=='1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_lob,"id": "ship_lob_name",
        "value": response.ship_lob_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_lob_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_loc,"id": "ship_primary_loc_name",
        "value": response.ship_primary_loc_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_loc_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_dept,"id": "ship_dept_name",
        "value": response.ship_dept_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_dept_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
      "display": 'Select Vendor Location',"id": "vendor_address",
      // "value": response.vendor_first_name + " " + response.vendor_last_name + " " + "(" + response.vendor_code + ")" + " " + "(City - " + response.vendor_city_name + ")" + " " + "(GST - " + response.vendor_gst_no + ")",
      "value": response.vendor_address ? response.vendor_address : '',
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": 'Dimension',"id": "dimension_name",
      "value": response.dimension_name + response.dimension_type_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.dimension_name == '' || response.dimension_name == null) ? false : true, "input_type": 'text'
    },
      {
        "display": this.company_setup.custom_bill_location_name,"id": "bill_location_nickname_9_digit",
        "value": (response.bill_location_nickname_9_digit?response.bill_location_nickname_9_digit:'') + " " + (response.bill_location_code_9_digit?("(" + response.bill_location_code_9_digit + ")"):''),
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":this.company_setup.is_bill_loc_hidden_in_inv!='1'?true:false, "input_type": 'text'
      }, {
      "display": 'Is CWIP',"id": "is_cwip",
      "value": response.is_cwip == '1' ? true : false,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_cwip == '1' ? true : false, "input_type": 'checkbox'
    }, {
      "display": 'High Sea Sales',"id": "high_sea_level",
      "value": response.high_sea_level == '1' ? true : false,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.high_sea_level == '1' ? true : false, "input_type": 'checkbox'
    },
      {
        "display": 'Is Rented',"id": "is_rented",
        "value": response.is_rented == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_rented == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        // "display": 'Is DDC',
        "display": this.company_setup.is_different_document_currency ?  this.company_setup.is_different_document_currency : 'IS DDC',"id": "is_different_document_currency",
        "value": response.is_different_document_currency == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": "Catalogue Based PO",
        "value": (response.catalogue_id && response.catalogue_id != '') ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.catalogue_id && response.catalogue_id != '') ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Conversion Rate',"id": "conversion_rate",
        "value": response.conversion_rate,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Currency',"id": "currency_name",
        "value": response.currency_name + " " + "(" + response.currency_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Exclude GST',"id": "exclude_gst",
        "value": response.exclude_gst == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.exclude_gst == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'No GST for SEZ',"id": "override_gst",
        "value": response.override_gst == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.override_gst == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Send Vendor Mail',"id": "send_vendor_mail",
        "value": response.send_vendor_mail == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.send_vendor_mail == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Is BOQ',"id": "is_boq",
        "value": response.is_boq,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq, "input_type": 'checkbox'
      }, {
      "display": 'BOQ',"id": "boq_name",
      "value": response.boq_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq, "input_type": 'text'
    }, {
      "display": 'BOQ Unit',"id": "boq_quantity",
      "value": response.boq_quantity,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_boq, "input_type": 'text'
    },
      {
        "display": this.company_setup.rename_project ? this.company_setup.rename_project : 'Project',"id": "project_detail",
        "value": response.project_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.project_detail != '') && this.company_setup.is_budget_selection_at_item_level_in_product_table == '0' ? true : false, "input_type": 'text'     
      },
      {
        "display": this.company_setup.rename_task ? this.company_setup.rename_task : 'Task',"id": "task_details",
        "value": response.task_details ? response.task_details : "",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_task_visible_in_po == "1" && response.task_name != "") && this.company_setup.is_budget_selection_at_item_level_in_product_table == '0'? true : false, "input_type": 'text'
      },
      {
        "display": `Budget Amount (${this.company_setup.currency_icon})`,"id": "po_budget_amount",
        "value": `${this.company_setup.currency_icon}:${response.po_budget_amount}`,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.task_budget_visible_in_po == "1" && response.task_name != "" && response.po_budget_amount != "") ? true : false, "input_type": 'text'
      },
      {
        "display": `Consumed Budget (${this.company_setup.currency_icon})`,"id": "po_consumed_budget",
        "value": `${this.company_setup.currency_icon}:${response.po_consumed_budget}`,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.task_consumed_budget_visible_in_po    == "1" && response.po_consumed_budget != "" && response.task_name != "") ? true : false, "input_type": 'text'
      },
      {
        "display": `Available Budget (${this.company_setup.currency_icon})`,"id": "po_available_budget",
        "value": `${this.company_setup.currency_icon}:${response.po_available_budget}`,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.task_balance_budget_visible_in_po == "1" && response.po_available_budget != "" && response.task_name != "") ? true : false, "input_type": 'text'
      },
      {
        "display": 'So No',"id": "sales_order_no",
        "value": response.sales_order_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.sales_order_no != '') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Is Accrual',"id": "is_accrual",
        "value": response.is_accrual,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_accrual, "input_type": 'checkbox'
      },
      {
        "display": 'Accrual Date',"id": "accrual_date",
        "value": response.accrual_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_accrual, "input_type": 'text'
      }
      , {
        "display": 'Customer',"id": "customer_address",
        "value": response.customer_address,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.customer_address != '') ? true : false, "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('vendor_contact_person_name','Vendor Contact Person Name')],"id": "vendor_contact_person_name",
        "value": response.vendor_contact_person_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('vendor_contact_person_name',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('vendor_contact_person_phone','Vendor Contact Person Phone Number')],"id": "vendor_contact_person_phone",
        "value": response.vendor_contact_person_phone,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('vendor_contact_person_phone',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('vendor_contact_person_email','Vendor Contact Person E-Mail ID')],"id": "vendor_contact_person_email",
        "value": response.vendor_contact_person_email,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('vendor_contact_person_email',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('vendor_additional_field_1','Vendor Additional field1')],"id": "vendor_additional_field_1",
        "value": response.vendor_additional_field_1,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('vendor_additional_field_1',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('vendor_additional_field_2','Vendor Additional field2')],"id": "vendor_additional_field_2",
        "value": response.vendor_additional_field_2,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('vendor_additional_field_2',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('receiver_contact_person_name','Receiver Contact Person Name')],"id": "receiver_contact_person_name",
        "value": response.receiver_contact_person_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('receiver_contact_person_name',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('receiver_contact_person_phone','Receiver Contact Person Phone Number')],"id": "receiver_contact_person_phone",
        "value": response.receiver_contact_person_phone,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('receiver_contact_person_phone',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('receiver_contact_person_email','Receiver Contact Person E-Mail ID')],"id": "receiver_contact_person_email",
        "value": response.receiver_contact_person_email,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('receiver_contact_person_email',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('receiver_additional_field_1','Receiver Additional field1')],"id": "receiver_additional_field_1",
        "value": response.receiver_additional_field_1,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('receiver_additional_field_1',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('receiver_additional_field_2','Receiver Additional field 2')],"id": "receiver_additional_field_2",
        "value": response.receiver_additional_field_2,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('receiver_additional_field_2',false), "input_type": 'text'
      },
      {
        "display":this.company_setup.custom_name_for_contract_based_po,"id": "contractual_po",
        "value": response.contractual_po == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_contract_based_po_visible_in_po == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": [this.poAdditionalGetColumnName('payment_terms','Payment Terms')],"id": "payment_terms_name",
        "value": response.payment_terms_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('payment_terms',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('payment_description','description')],"id": "payment_terms_description",
        "value": response.payment_terms_description,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('payment_description',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('manufacturer','Manufacturer')],"id": "manufacture_name",
        "value": response.manufacture_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('manufacturer',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('quote_date','Quote Date')],"id": "quote_date",
        "value": response.quote_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('quote_date',false) && response.quote_date != '', "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('purchase_on','Purchase On')],"id": "purchase_on",
        "value": response.purchase_on,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('purchase_on',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('inco_terms_id','IncoTerms')],"id": "inco_terms_name",
        "value": response.inco_terms_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('inco_terms_id',false), "input_type": 'text'
      },
      {
        "display": "incoterm description","id": "incoterm_description",
        "value": response.incoterm_description,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('inco_terms_id',false)  && response.incoterm_description != '', "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('additional_fields_1','Field 1')],"id": "additional_fields_1",
        "value": response.additional_fields_1,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('additional_fields_1',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('additional_fields_2','Field 2')],"id": "additional_fields_2",
        "value": response.additional_fields_2,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('additional_fields_2',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('additional_fields_3','Field 3')],"id": "additional_fields_3",
        "value": response.additional_fields_3,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('additional_fields_3',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('additional_fields_4','Field 4')],"id": "additional_fields_4",
        "value": response.additional_fields_4,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('additional_fields_4',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('additional_fields_5','Field 5')],"id": "additional_fields_5",
        "value": response.additional_fields_5,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('additional_fields_5',false), "input_type": 'text'
      },
      {
        "display": 'Communication Mail Id',"id": "communication_email",
        "value": response.communication_email,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.communication_mail_id_visible_raise_po_direct_po =='1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Reason For Modification',"id": "modified_remarks",
        "value": response.modified_remarks,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.modified_remarks != '' && response.modified_remarks != undefined  ? true : false, "input_type": 'text'
      },
      {
        "display":"Automatic Advance Request",
        "value": response.automatic_advance_request == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.automatic_add_advance_payment_in_po == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": "Advance Amount",
        "value": response.advanceamount, "id": "advanceamount",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.automatic_add_advance_payment_in_po == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.subject.custom_name ? this.company_setup.subject.custom_name  : 'Subject',
        "value": response.subject ? response.subject : '', "id": "subject",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.subject.is_visible_in_po ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.reference.custom_name ? this.company_setup.reference.custom_name  : 'Reference',
        "value": response.reference ? response.reference : '', "id": "reference",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.reference.is_visible_in_po ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.po_note.custom_name ? this.company_setup.po_note.custom_name  : 'Po Note',
        "value": response.po_note ? response.po_note : '', "id": "po_note",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.po_note.is_visible_in_po ? true : false, "input_type": 'text'
      },
      {
        "display": 'Allocable Cost',
        "value": response.is_allocable_cost == '1' || response.is_allocable_cost == 1 || response.is_allocable_cost == true ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.enable_allocable_cost_direct_po == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Blanket PO',
        "value": response.is_blanket_po=='1'?true:false,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Max PO Value',
        "value": response.max_po_value,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Purchase Document Type', "id": "purchase_type_document_name",
        "value": response.purchase_type_document_name ? response.purchase_type_document_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_purchase_document_types_visible_in_po == '1') && (response.purchase_type_document_name && response.purchase_type_document_name !== '') ? true : false, "input_type": 'text'
      },
      
      {
        "display": 'Purchase Organization', "id": "purchase_organization_name",
        "value": response.purchase_organization_name ? response.purchase_organization_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_purchase_organizations_visible_in_po == '1') && (response.purchase_organization_name && response.purchase_organization_name !== '') ? true : false, "input_type": 'text'
      },
      
      {
        "display": 'Purchase Group', "id": "purchase_group_name",
        "value": response.purchase_group_name ? response.purchase_group_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_purchase_groups_visible_in_po == '1') && (response.purchase_group_name && response.purchase_group_name !== '') ? true : false, "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('storage_location','Storage Location')],"id": "storage_location",
        "value": response.storage_location ? response.storage_location : ((response.storage_location_code ? response.storage_location_code : '') + (response.storage_location_description ? (' - ' + response.storage_location_description) : '')),
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('storage_location',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('channel','Channel')],"id": "channel_type",
        "value": response.channel_type_name ? response.channel_type_name : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('channel',false), "input_type": 'text'
      },
      {
        "display": [this.poAdditionalGetColumnName('approval_matrix', 'Approval Matrix')], "id": "po_approval_matrix_name",
        "value": response.po_approval_matrix_name ? response.po_approval_matrix_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": this.poAdditionalIs_column_visible('approval_matrix', false), "input_type": 'text'
      },
      // {
      //   "display": 'PO TYPE',
      //   "value": response.po_series_order_type ? (po_series_order_type.custom_name ? po_series_order_type.custom_name : '') : '',
      //   "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.enable_po_type_order_in_po && this.company_setup.enable_po_type_order_in_po == '1' && response.po_series_order_type && response.po_series_order_type != '') ? true : false, "input_type": 'text'
      // },
    );
    // console.log("skip_diff", this.skip_diff)
  }
  showIrn(response) {

    response.vendor_details = response.vendor_first_name + " " + response.vendor_last_name;
    // response.bill_to_location = response.bill_location_nickname_9_digit + " (" + response.bill_location_code_9_digit + ")";
    // response.ship_to_location = response.ship_location_nickname_9_digit + " (" + response.ship_location_code_9_digit + ")";
    response.bill_to_location = response.bill_to_location ? response.bill_to_location : '';
    response.ship_to_location = response.ship_to_location ? response.ship_to_location : '';
    response.requested_by_department_name = response.department_name ? response.department_name : '';
    response.is_custom_ship_to_location=response.is_custom_ship_to_location?response.is_custom_ship_to_location:'0';
    response.custom_ship_to_location=response.custom_ship_to_location?response.custom_ship_to_location:'';
    response.is_blanket_po = response.is_blanket_po == '1' ? true : false;
    response.max_po_value = response.max_po_value ? response.max_po_value : '';
    response.balance_po_value = response.balance_po_value ? response.balance_po_value : '';
    response.is_direct = response.is_direct ? response.is_direct : '';
    response.po_total_price = response.po_total_price ? response.po_total_price : '';
    response.po_unit_price = response.po_unit_price ? response.po_unit_price : '';
    response.gate_entry_source = response.gate_entry_source ? response.gate_entry_source : '';
    response.gate_entry_type = response.gate_entry_type ? response.gate_entry_type : '';
    response.mode_of_transport = response.mode_of_transport ? response.mode_of_transport : '';
    response.transporter_name = response.transporter_name ? response.transporter_name : '';
    response.transport_ref_no = response.transport_ref_no ? response.transport_ref_no : '';
    response.transporter_mobile_no = response.transporter_mobile_no ? response.transporter_mobile_no : '';
    response.contact_person_name = response.contact_person_name ? response.contact_person_name : '';
    response.contact_number = response.contact_number ? response.contact_number : '';
    response.delivery_challan_date = response.delivery_challan_date ? response.delivery_challan_date : '';
    response.invoice_dc_value = response.invoice_dc_value ? response.invoice_dc_value : '';
    response.unit_of_measure = response.unit_of_measure ? response.unit_of_measure : '';
    response.total_quantity = response.total_quantity ? response.total_quantity : '';
    response.visual_check_status = response.visual_check_status ? response.visual_check_status : '';
    response.forwarded_to_receiving_department = response.forwarded_to_receiving_department ? response.forwarded_to_receiving_department : '';
    response.received_by = response.received_by ? response.received_by : '';
    response.received_by_employee_code = response.received_by_employee_code ? response.received_by_employee_code : '';
    response.received_by_first_name = response.received_by_first_name ? response.received_by_first_name : '';
    response.received_by_last_name = response.received_by_last_name ? response.received_by_last_name : '';
    response.security_guard_employee_type = response.security_guard_employee_type ? response.security_guard_employee_type : '';
    response.name_of_receiver_id = response.name_of_receiver_id ? response.name_of_receiver_id : '';
    response.gate_entry_point_name = response.gate_entry_point_name ? response.gate_entry_point_name : '';
    response.other_1 = response.other_1 ? response.other_1 : '';
    response.other_2 = response.other_2 ? response.other_2 : '';
    response.other_3 = response.other_3 ? response.other_3 : '';
    response.other_4 = response.other_4 ? response.other_4 : '';
    response.other_date_1 = response.other_date_1 ? response.other_date_1 : '';
    response.other_date_2 = response.other_date_2 ? response.other_date_2 : '';
    
if(response.is_custom_ship_to_location=='1')
{
response.ship_to_location=response.custom_ship_to_location
}
response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name + " (" + response.project_code + ")";
    }
    response.task_name = response.task_name ? response.task_name : '';
    response.task_code = response.task_code ? response.task_code : '';
    response.task_detail = '';
    if (response.task_name != '' && response.task_name != undefined) {
      response.task_detail = response.task_name + " (" + response.task_code + ")";
    }
    if(response.boe_date != "" && response.boe_date != null && response.boe_date != undefined){
      response.boe_date = this.webService.formatDateAccordingToSetup(response.boe_date,this.company_setup.in_invoice_date_format)
    }
    if(response.irn_invoice_date != "" && response.irn_invoice_date != null && response.irn_invoice_date != undefined){
      response.irn_invoice_date = this.webService.formatDateAccordingToSetup(response.irn_invoice_date,this.company_setup.in_invoice_date_format)
    }
    if(response.grn_date != "" && response.grn_date != null && response.grn_date != undefined){
      response.grn_date = this.webService.formatDateAccordingToSetup(response.grn_date,this.company_setup.in_invoice_date_format)
    }
    if(response.po_date != "" && response.po_date != null && response.po_date != undefined){
      response.po_date = this.webService.formatDateAccordingToSetup(response.po_date,this.company_setup.in_invoice_date_format)
    }
    if(response.irn_date != "" && response.irn_date != null && response.irn_date != undefined){
      response.irn_date = this.webService.formatDateAccordingToSetup(response.irn_date,this.company_setup.in_invoice_date_format)
    }
    if(response.other_date_1 != "" && response.other_date_1 != null && response.other_date_1 != undefined){
      response.other_date_1 = this.webService.formatDateAccordingToSetup(response.other_date_1, this.company_setup.in_invoice_date_format)
    }
    if(response.other_date_2 != "" && response.other_date_2 != null && response.other_date_2 != undefined){
      response.other_date_2 = this.webService.formatDateAccordingToSetup(response.other_date_2, this.company_setup.in_invoice_date_format)
    }

    response.dept = '';
    response.lob = '';
    response.loc = '';
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep !='1'){
      response.lob = response.ship_lob_code!='' && response.ship_lob_code!=null ? response.ship_lob_name + " (" + response.ship_lob_code + ")" : response.ship_lob_name;
      response.loc = response.ship_primary_loc_code!='' && response.ship_primary_loc_code!=null ? response.ship_primary_loc_name + " (" + response.ship_primary_loc_code + ")" : response.ship_primary_loc_name;
      response.dept = response.ship_dept_code!='' && response.ship_dept_code!=null ? response.ship_dept_name + " (" + response.ship_dept_code + ")" : response.ship_dept_name;

    }else{
      response.lob = response.ship_lob_name ? response.ship_lob_name : '';
      response.loc = response.ship_primary_loc_name ? response.ship_primary_loc_name : '';
      response.dept = response.ship_dept_name ? response.ship_dept_name : '';
    }
    
    let showOnlyIrnAdditionalFields = this.divDetails.id == 'irn_additional_fields_only';
    
    if (!showOnlyIrnAdditionalFields) {
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by_first_name + " " + response.requested_by_last_name + " (" + response.requested_by_employee_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.irn_requested_by_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'PO NO',
        "value": response.po_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'PO Date',
        "value": response.po_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": this.company_setup.irn_no_custom_name,
        "value": response.cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'BOE No',
        "value": response.boe_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.irn_boe_no_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'BOE Date',
        "value": response.boe_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.irn_boe_date_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Annexure No',
        "value": response.annexure_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.irn_annexure_no_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Invoice Date',
        "value": response.irn_invoice_date ? response.irn_invoice_date : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_irn_invoicedate_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.irn_to_grn + ' ' + 'Invoice No',
        "value": response.irn_invoice_no ? response.irn_invoice_no : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_irn_invoiceno_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Remarks',
        "value": response.irn_remarks ? response.irn_remarks : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_irn_remarks_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.irn_date_custom_name,
        "value": response.irn_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Challan No',
        "value": response.challan_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_irn_challan_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_bill_location_name,
        "value": response.bill_to_location,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_bill_loc_hidden_in_inv!='1'?true:false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_ship_location_name,
        "value": response.ship_to_location,
        "div_size": 'col-sm-2 div1', "is_html":response.is_custom_ship_to_location=='1'?true:false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.show_loc_dropdown=='0' ? true : false, "input_type": 'text'
      },
      {
        "display":this.company_setup.custom_name_for_lob ,
        "value": response.lob,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_lob_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_loc,
        "value": response.loc,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_loc_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_dept,
        "value": response.dept,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_dept_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.rename_project,
        "value": response.project_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_project_visible_in_irn == '1' && this.company_setup.is_budget_selection_at_item_level_in_product_table != '1' ? true : false, "input_type": 'text'
      }
,
      {
        "display": 'Is Correct GST Invoice Received',
        "value": response.is_correct_gst_invoice_received=='1'?true:false,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_correct_gst_invoice_received_visible_in_irn == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": this.company_setup.rename_task,
        "value": response.task_detail,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_task_visible_in_irn == '1' && this.company_setup.is_budget_selection_at_item_level_in_product_table != '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Blanket PO',
        "value": response.is_blanket_po=='1'?true:false,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false,  "input_type": 'checkbox'
      },
      {
        "display": 'Max PO Value',
        "value": response.max_po_value,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false,  "input_type": 'text'
      },
      {
        "display": 'Balance PO Value',
        "value": response.balance_po_value,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false, "input_type": 'text'
      },
    );
    }
    
    this.commonVariableList.divList.push(
      {
        "display": this.getIrnFieldCustomName('gate_entry_source', 'Gate Entry Source'),
        "value": response.gate_entry_source,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('gate_entry_source'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('gate_entry_type', 'Gate Entry Type'),
        "value": response.gate_entry_type,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('gate_entry_type'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('mode_of_transport', 'Mode of Transport'),
        "value": response.mode_of_transport,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('mode_of_transport'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('transporter_name', 'Transporter Name'),
        "value": response.transporter_name,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('transporter_name'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('transport_ref_no', 'Transport Ref No'),
        "value": response.transport_ref_no,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('transport_ref_no'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('transporter_mobile_no', 'Transporter Mobile No'),
        "value": response.transporter_mobile_no,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('transporter_mobile_no'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('contact_person_name', 'Contact Person Name'),
        "value": response.contact_person_name,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('contact_person_name'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('contact_number', 'Contact Number'),
        "value": response.contact_number,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('contact_number'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('delivery_challan_date', 'Delivery Challan Date'),
        "value": response.delivery_challan_date,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('delivery_challan_date'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('invoice_dc_value', 'Invoice / DC Value'),
        "value": response.invoice_dc_value,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('invoice_dc_value'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('material_category', 'Material Category'),
        "value": response.material_category,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('material_category'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('unit_of_measure', 'Unit of Measure'),
        "value": response.unit_of_measure,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('unit_of_measure'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('total_quantity', 'Total Quantity'),
        "value": response.total_quantity,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('total_quantity'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('visual_check_status', 'Visual Check Status'),
        "value": response.visual_check_status == '1' || response.visual_check_status == 1 ? 'Approve' : (response.visual_check_status == '2' || response.visual_check_status == 2 ? 'Reject' : response.visual_check_status),
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('visual_check_status'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('forwarded_to_receiving_department', 'Forwarded to Receiving Department'),
        "value": response.forwarded_to_receiving_department,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('forwarded_to_receiving_department'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('forwarded_to_person', 'Forwarded to PERSON'),
        "value": response.forwarded_to_person,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('forwarded_to_person'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('remarks', 'Remarks'),
        "value": response.irn_additional_remarks,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('remarks'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('security_guard_employee', 'Security Guard/ Employee'),
        "value": response.security_guard_employee_type,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('security_guard_employee'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('name_of_receiver', 'Name of Receiver'),
        "value": response.name_of_receiver_id,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('name_of_receiver'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('gate_entry_point_name', 'Gate / Entry Point Name'),
        "value": response.gate_entry_point_name,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('gate_entry_point_name'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_1', 'Other 1'),
        "value": response.other_1,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_1'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_2', 'Other 2'),
        "value": response.other_2,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_2'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_3', 'Other 3'),
        "value": response.other_3,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_3'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_4', 'Other 4'),
        "value": response.other_4,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_4'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_date_1', 'Other date 1'),
        "value": response.other_date_1,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_date_1'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_date_2', 'Other date 2'),
        "value": response.other_date_2,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_date_2'), "input_type": 'text'
      }
      );


  }
  showGrn(response) {

    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
    response.irn_cs_id = response.irn_cs_id ? response.irn_cs_id : ''
    response.grn_date = response.grn_date ? response.grn_date : ''

    response.vendor_details = response.vendor_first_name + " " + response.vendor_last_name;
    response.bill_to_location = response.bill_location_nickname_9_digit + " (" + response.bill_location_code_9_digit + ")";
    response.ship_to_location = response.ship_location_nickname_9_digit + " (" + response.ship_location_code_9_digit + ")";
    response.send_mail_to_vendor = response.send_mail_to_vendor ? response.send_mail_to_vendor : '0';
    response.send_mail_to_vendor = response.send_mail_to_vendor == '1' ? 'YES' : 'NO'
    response.requested_by_department_name = response.department_name ? response.department_name : '';

    response.is_custom_ship_to_location=response.is_custom_ship_to_location?response.is_custom_ship_to_location:'0';
    response.custom_ship_to_location=response.custom_ship_to_location?response.custom_ship_to_location:'';
    response.is_blanket_po = response.is_blanket_po == '1' ? true : false;
    response.max_po_value = response.max_po_value ? response.max_po_value : '';
    response.balance_po_value = response.balance_po_value ? response.balance_po_value : '';
    response.po_total_price = response.po_total_price ? response.po_total_price : '';
    response.po_unit_price = response.po_unit_price ? response.po_unit_price : '';
    response.gate_entry_source = response.gate_entry_source ? response.gate_entry_source : '';
    response.gate_entry_type = response.gate_entry_type ? response.gate_entry_type : '';
    response.mode_of_transport = response.mode_of_transport ? response.mode_of_transport : '';
    response.transporter_name = response.transporter_name ? response.transporter_name : '';
    response.transport_ref_no = response.transport_ref_no ? response.transport_ref_no : '';
    response.transporter_mobile_no = response.transporter_mobile_no ? response.transporter_mobile_no : '';
    response.contact_person_name = response.contact_person_name ? response.contact_person_name : '';
    response.contact_number = response.contact_number ? response.contact_number : '';
    response.delivery_challan_date = response.delivery_challan_date ? response.delivery_challan_date : '';
    response.invoice_dc_value = response.invoice_dc_value ? response.invoice_dc_value : '';
    response.unit_of_measure = response.unit_of_measure ? response.unit_of_measure : '';
    response.total_quantity = response.total_quantity ? response.total_quantity : '';
    response.visual_check_status = response.visual_check_status ? response.visual_check_status : '';
    response.forwarded_to_receiving_department = response.forwarded_to_receiving_department ? response.forwarded_to_receiving_department : '';
    response.forwarded_to_person = response.forwarded_to_person ? response.forwarded_to_person : '';
    response.irn_additional_remarks = response.irn_additional_remarks ? response.irn_additional_remarks : '';
    response.security_guard_employee_type = response.security_guard_employee_type ? response.security_guard_employee_type : '';
    response.name_of_receiver_id = response.name_of_receiver_id ? response.name_of_receiver_id : '';
    response.gate_entry_point_name = response.gate_entry_point_name ? response.gate_entry_point_name : '';
    response.other_1 = response.other_1 ? response.other_1 : '';
    response.other_2 = response.other_2 ? response.other_2 : '';
    response.other_3 = response.other_3 ? response.other_3 : '';
    response.other_4 = response.other_4 ? response.other_4 : '';
    response.other_date_1 = response.other_date_1 ? response.other_date_1 : '';
    response.other_date_2 = response.other_date_2 ? response.other_date_2 : '';
if(response.is_custom_ship_to_location=='1')
{
response.ship_to_location=response.custom_ship_to_location
}

response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name + " (" + response.project_code + ")";
    }
    response.task_name = response.task_name ? response.task_name : '';
    response.task_code = response.task_code ? response.task_code : '';
    response.task_detail = '';
    if (response.task_name != '' && response.task_name != undefined) {
      response.task_detail = response.task_name + " (" + response.task_code + ")";
    }
    if(response.boe_date != "" && response.boe_date != null && response.boe_date != undefined){
      response.boe_date = this.webService.formatDateAccordingToSetup(response.boe_date,this.company_setup.in_invoice_date_format)
    }
    if(response.irn_invoice_date != "" && response.irn_invoice_date != null && response.irn_invoice_date != undefined){
      response.irn_invoice_date = this.webService.formatDateAccordingToSetup(response.irn_invoice_date,this.company_setup.in_invoice_date_format)
    }
    if(response.grn_date != "" && response.grn_date != null && response.grn_date != undefined){
      response.grn_date = this.webService.formatDateAccordingToSetup(response.grn_date,this.company_setup.in_invoice_date_format)
    }
    if(response.other_date_1 != "" && response.other_date_1 != null && response.other_date_1 != undefined){
      response.other_date_1 = this.webService.formatDateAccordingToSetup(response.other_date_1, this.company_setup.in_invoice_date_format)
    }
    if(response.other_date_2 != "" && response.other_date_2 != null && response.other_date_2 != undefined){
      response.other_date_2 = this.webService.formatDateAccordingToSetup(response.other_date_2, this.company_setup.in_invoice_date_format)
    }
    response.dept = '';
    response.lob = '';
    response.loc = '';
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep !='1'){
      response.lob = response.ship_lob_code!='' && response.ship_lob_code!=null ? response.ship_lob_name + " (" + response.ship_lob_code + ")" : response.ship_lob_name;
      response.loc = response.ship_primary_loc_code!='' && response.ship_primary_loc_code!=null ? response.ship_primary_loc_name + " (" + response.ship_primary_loc_code + ")" : response.ship_primary_loc_name;
      response.dept = response.ship_dept_code!='' && response.ship_dept_code!=null ? response.ship_dept_name + " (" + response.ship_dept_code + ")" : response.ship_dept_name;

    }else{
      response.lob = response.ship_lob_name ? response.ship_lob_name : '';
      response.loc = response.ship_primary_loc_name ? response.ship_primary_loc_name : '';
      response.dept = response.ship_dept_name ? response.ship_dept_name : '';
    }

    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.grn_requested_by_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'BOE No',
        "value": response.boe_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.irn_boe_no_visible == '1' ? true : false, "input_type": 'text'
      }
      , {
        "display": 'BOE Date',
        "value": response.boe_date ? response.boe_date :'',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.irn_boe_date_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Annexure No',
        "value": response.annexure_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.irn_annexure_no_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Remarks',
        "value": response.grn_remarks ? response.grn_remarks : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_grn_remarks_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.irn_no_custom_name,
        "value": response.irn_cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": this.irn_inv_date,
        "value": response.irn_invoice_date ? response.irn_invoice_date : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_irn_invoicedate_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.irn_inv_no,
        "value": response.irn_invoice_no ? response.irn_invoice_no : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_irn_invoiceno_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.irn_remarks,
        "value": response.irn_remarks ? response.irn_remarks : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_irn_remarks_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.grn_no_custom_name,
        "value": response.cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": this.company_setup.grn_date_custom_name,
        "value": response.grn_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Send Mail To Vendor',
        "value": response.send_mail_to_vendor == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.send_mail_to_vendor == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": this.company_setup.custom_bill_location_name,
        "id": "bill_to_location",
        "value": response.bill_to_location,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_bill_loc_hidden_in_inv!='1'?true:false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_ship_location_name,
        "value": response.ship_to_location,
        "div_size": 'col-sm-2 div1', "is_html":response.is_custom_ship_to_location=='1'?true:false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.show_loc_dropdown != '1' ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_lob,
        "value": response.lob,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_lob_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_loc,
        "value": response.loc,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_loc_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_dept,
        "value": response.dept,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_dept_dropdown == '1')? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.rename_project ? this.company_setup.rename_project : 'Project',
        "value": response.project_detail,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_project_visible_in_grn == '1' && this.company_setup.is_budget_selection_at_item_level_in_product_table != '1' ? true : false, "input_type": 'text'
      }
    ,
      {
        "display": 'Is Correct GST Invoice Received',
        "value": response.is_correct_gst_invoice_received=='1'?true:false,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_correct_gst_invoice_received_visible_in_grn == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": this.company_setup.rename_task ? this.company_setup.rename_task : 'Task',
        "value": response.task_detail,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_task_visible_in_grn == '1' && this.company_setup.is_budget_selection_at_item_level_in_product_table != '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Blanket PO',
        "value": response.is_blanket_po=='1'?true:false,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Max PO Value',
        "value": response.max_po_value,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Balance PO Value',
        "value": response.balance_po_value,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.show_blanket_po_option_in_direct_po == '1' && response.is_blanket_po == '1') ? true : false, "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('gate_entry_source', 'Gate Entry Source'),
        "value": response.gate_entry_source,
        "div_size": 'col-sm-3', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('gate_entry_source'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('gate_entry_type', 'Gate Entry Type'),
        "value": response.gate_entry_type,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('gate_entry_type'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('mode_of_transport', 'Mode of Transport'),
        "value": response.mode_of_transport,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('mode_of_transport'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('transporter_name', 'Transporter Name'),
        "value": response.transporter_name,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('transporter_name'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('transport_ref_no', 'Transport Ref No'),
        "value": response.transport_ref_no,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('transport_ref_no'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('transporter_mobile_no', 'Transporter Mobile No'),
        "value": response.transporter_mobile_no,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('transporter_mobile_no'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('contact_person_name', 'Contact Person Name'),
        "value": response.contact_person_name,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('contact_person_name'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('contact_number', 'Contact Number'),
        "value": response.contact_number,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('contact_number'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('delivery_challan_date', 'Delivery Challan Date'),
        "value": response.delivery_challan_date,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('delivery_challan_date'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('invoice_dc_value', 'Invoice / DC Value'),
        "value": response.invoice_dc_value,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('invoice_dc_value'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('material_category', 'Material Category'),
        "value": response.material_category,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('material_category'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('unit_of_measure', 'Unit of Measure'),
        "value": response.unit_of_measure,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('unit_of_measure'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('total_quantity', 'Total Quantity'),
        "value": response.total_quantity,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('total_quantity'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('visual_check_status', 'Visual Check Status'),
        "value": response.visual_check_status == '1' || response.visual_check_status == 1 ? 'Approve' : (response.visual_check_status == '2' || response.visual_check_status == 2 ? 'Reject' : response.visual_check_status),
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('visual_check_status'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('forwarded_to_receiving_department', 'Forwarded to Receiving Department'),
        "value": response.forwarded_to_receiving_department,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('forwarded_to_receiving_department'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('forwarded_to_person', 'Forwarded to PERSON'),
        "value": response.forwarded_to_person,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('forwarded_to_person'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('remarks', 'Remarks'),
        "value": response.irn_additional_remarks,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('remarks'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('security_guard_employee', 'Security Guard/ Employee'),
        "value": response.security_guard_employee_type,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('security_guard_employee'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('name_of_receiver', 'Name of Receiver'),
        "value": response.name_of_receiver_id,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('name_of_receiver'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('gate_entry_point_name', 'Gate / Entry Point Name'),
        "value": response.gate_entry_point_name,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('gate_entry_point_name'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_1', 'Other 1'),
        "value": response.other_1,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_1'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_2', 'Other 2'),
        "value": response.other_2,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_2'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_3', 'Other 3'),
        "value": response.other_3,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_3'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_4', 'Other 4'),
        "value": response.other_4,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_4'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_date_1', 'Other date 1'),
        "value": response.other_date_1,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_date_1'), "input_type": 'text'
      },
      {
        "display": this.getIrnFieldCustomName('other_date_2', 'Other date 2'),
        "value": response.other_date_2,
        "div_size": 'col-sm-3 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.isIrnFieldEnabled('other_date_2'), "input_type": 'text'
      }
    );

  }

  showAndroidInvoice(response)
  {
    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.added_by_employee_code + ")"
    response.vendor_code = response.vendor_code ? response.vendor_code : ''
    response.vendor_details = response.vendor_first_name + " " + response.vendor_last_name;
    response.ship_to_location = response.ship_location_nickname_9_digit + " (" + response.ship_location_code_9_digit + ")";


    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'

      },
      {
        "display": 'Invoice No',
        "value": response.invoice_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }

      ,
      {
        "display": 'Invoice Date',
        "value": response.invoice_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
      ,
      {
        "display": 'Vendor',
        "value": response.vendor_first_name + " " + response.vendor_last_name + "(" + response.vendor_code + ")" ,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }


    );

  }
  showInvoice(response) {
    // Handle old_json_data for diff display
    this.diff_json_data = this.divDetails.diff_json_data ? this.divDetails.diff_json_data : {};
    this.show_difference = this.divDetails.show_difference && this.divDetails.show_difference=='1' ? true : false;
    let old_json_data = this.divDetails.old_json_data ? this.divDetails.old_json_data : {};
    
    // For invoice approval screen, ensure old_json_data is properly set
    if (this.divDetails.is_invoice_approval_screen && this.divDetails.invoice_data_reqsted && old_json_data) {
      // Map invoice_no to vendor_invoice_no if needed (for divList compatibility)
      if (old_json_data['invoice_no'] && !old_json_data['vendor_invoice_no']) {
        old_json_data['vendor_invoice_no'] = old_json_data['invoice_no'];
      }
      if (old_json_data['vendor_invoice_no'] && !old_json_data['invoice_no']) {
        old_json_data['invoice_no'] = old_json_data['vendor_invoice_no'];
      }
      
      // Invoice Receipt Date row uses id "invoice_date" but displays date_added
      const hasReceiptDateDiff = this.divDetails.invoice_receipt_date_changed === true;
      if (hasReceiptDateDiff && old_json_data.invoice_date != "" && old_json_data.invoice_date != null && old_json_data.invoice_date != undefined) {
        old_json_data.invoice_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(old_json_data.invoice_date), this.company_setup.in_invoice_date_format);
      }
      if (old_json_data.date_added != "" && old_json_data.date_added != null && old_json_data.date_added != undefined) {
        old_json_data.date_added = this.webService.formatDateAccordingToSetup(old_json_data.date_added, this.company_setup.in_invoice_date_format);
        if (!hasReceiptDateDiff) {
          old_json_data.invoice_date = old_json_data.date_added;
        }
      } else if (!hasReceiptDateDiff) {
        old_json_data.invoice_date = '';
      }
      // Format invoice_due_date (Invoice Due Date)
      if(old_json_data.invoice_due_date != "" && old_json_data.invoice_due_date != null && old_json_data.invoice_due_date != undefined){
        old_json_data.invoice_due_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(old_json_data.invoice_due_date),this.company_setup.in_invoice_date_format)
      }
      old_json_data.invoice_approval_matrix_name = old_json_data.invoice_approval_matrix_name ? old_json_data.invoice_approval_matrix_name : '';
    }
    
    // Assign old_json_data to this.old_json_data for use in template
    this.old_json_data = old_json_data;
    
    response.is_multi_grn_invoice=response.is_multi_grn_invoice=='1'?true:false;
    response.requested_by_inv = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"

    response.vendor_code = response.vendor_code ? response.vendor_code : ''
    response.vendor_details = response.vendor_first_name + " " + response.vendor_last_name;
    response.bill_to_location = response.bill_location_nickname_9_digit + " (" + response.bill_location_code_9_digit + ")";
    response.ship_to_location = response.ship_location_nickname_9_digit + " (" + response.ship_location_code_9_digit + ")";
    response.common_ship_location = response.common_ship_location?response.common_ship_location:'';

    response.requested_by_department_name = response.department_name ? response.department_name : '';
    response.customer_first_name = response.customer_first_name ? response.customer_first_name : ''
    response.customer_last_name = response.customer_last_name ? response.customer_last_name : ''
    response.customer_code = response.customer_code ? response.customer_code : '';

    response.is_vendor_invoice=response.is_vendor_invoice?response.is_vendor_invoice:'0';
    response.is_payment_made_disable = response.is_payment_made_disable ? response.is_payment_made_disable : '0';
    response.is_debit_value = response.is_debit_value ? response.is_debit_value : '0';
    if(response.is_vendor_invoice=='1')
    {
      response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.vendor_code + ")"
    }

    if (response.customer_first_name != '' && response.customer_first_name != undefined) {
      response.customer = response.customer_first_name + " " + response.customer_last_name + " (" + response.customer_code + ")"

    }
    else {
      response.customer = response.customer_first_name + " " + response.customer_last_name

    }
    response.is_custom_ship_to_location=response.is_custom_ship_to_location?response.is_custom_ship_to_location:'0';
    response.custom_ship_to_location=response.custom_ship_to_location?response.custom_ship_to_location:'';
if(response.is_custom_ship_to_location=='1')
{
response.ship_to_location=response.custom_ship_to_location
}
// //console.log(response);

response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name + " (" + response.project_code + ")";
    }
    response.task_name = response.task_name ? response.task_name : '';
    response.task_code = response.task_code ? response.task_code : '';
    response.task_details = response.task_name ? `${response.task_name} (${response.task_code})` : '';


    response.month_name = response.month_name ? response.month_name : ""
    response.invoice_allocate_to_employee = response.invoice_allocate_to_employee  ?response.invoice_allocate_to_employee : "0"
    // //console.log(this.company_setup.is_department_allocation_visible)
    response.boq_name = response.boq_name ? response.boq_name : "";
    response.boq_code = response.boq_code ? response.boq_code : "";
    //response.boq_full_name = response.boq_name ? `${response.boq_name} (${response.boq_code})` : "";

    //console.log(this.company_setup.is_department_allocation_visible)
    response.inv_msg_fo_vendor_out_ind=response.inv_msg_fo_vendor_out_ind?response.inv_msg_fo_vendor_out_ind:this.company_setup.inv_msg_fo_vendor_out_ind;
    response.service_start_date = response.service_start_date ? response.service_start_date : "";
    response.service_end_date = response.service_end_date ? response.service_end_date  : "";
    response.po_no = response.po_no ? response.po_no : "";
    response.po_date = response.po_date ? response.po_date : "";
    response.task_details=response.task_details?response.task_details:(response.task_detail?response.task_detail:'')
  

    response.pan_na=response.pan_na?response.pan_na:(response.pan_not_available?response.pan_not_available:'0')
    response.total_amount_difference=response.total_amount_difference?response.total_amount_difference:'0'
    if(this.page_url=='invoice-approval')
    {
      if(parseFloat(this.webService.convertNaN(response.total_amount_difference))>0 && this.company_setup.is_popup_visible_debit_note_approval_time == '1')
      {
        this.commonVariableList.meta_list.push({
          key:'debit_msg',value:this.company_setup.in_invoice_message_when_debit_note_is_there,"class":'h1_cls',"tag_name":"h3"
          ,is_visible:true
        })
      }
    }
    if(response.pan_na=='1' && this.page_url=='invoice-approval')
    {
      this.commonVariableList.meta_list.push({

        key:'pan_na',value:this.company_setup.pan_na_msg,"class":'h1_cls',"tag_name":"h3"
        ,is_visible:true
      })
    }
    if(response.is_different_document_currency=='1')
    {
      this.commonVariableList.meta_list.push({

        key:'inv_msg_fo_vendor_out_ind',value:response.inv_msg_fo_vendor_out_ind,"class":'h1_cls',"tag_name":"h3"
        ,is_visible:true
      })
      this.commonVariableList.meta_list=this.commonVariableList.meta_list.filter((v)=>{return v.is_visible})
    }

    if(this.company_setup.is_tds_edit_msg_visible_for_approver=='1')
    {
      // console.log(this.divDetails);
      // console.log(this.page_url);

      if(this.page_url=='invoice-approval')
      {
          // console.log(this.divDetails.data.invoice_items);
      // console.log(this.page_url);
      // console.log(this.divDetails.data.invoice_items.some((v)=>{return v.is_tds_rate_edited=='1'}));
      let title=this.divDetails.data.invoice_items.some((v)=>{return v.is_tds_rate_edited=='1'})?this.company_setup.tds_edit_msg_visible_for_approver:''
      this.commonVariableList.meta_list.push({
        key:'head_title',value:title,"class":'h1_cls',"tag_name":"h3"
        ,is_visible:true
      })
      }
    }
    if(this.page_url=='invoice-approval') {
      if(response.msme=='1') {
        let currentDate = new Date(response.invoice_due_date);
        let dateSent = new Date();
        if(this.company_setup.invoice_receipt_due_date=="vendor_invoice_date") {
          dateSent = new Date(response.vendor_invoice_date);
        } else {
          dateSent = new Date(this.webService.formatDate(response.date_added,'yy-mm-dd','-'));
        }
        let dateDiff = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) ) /(1000 * 60 * 60 * 24));
        dateDiff = Math.abs(dateDiff)

        if(dateDiff>45) {
          this.userInfo='info blink-1'
          this.user_message = "Vendor is MSME and you are mentioning ‘payment terms’ more than 45 days which may attract Interest and Tax Disallowance."; 
        }
      }
    }
    response.invoice_budget_amount = response.invoice_budget_amount ? response.invoice_budget_amount : "";
    response.invoice_consumed_budget = response.invoice_consumed_budget ? +response.invoice_consumed_budget : "";
    response.invoice_available_budget = response.invoice_available_budget ? +response.invoice_available_budget : "";
    if(response.invoice_budget_amount != "" && response.invoice_budget_amount != "Budget Not Set"){
      response.invoice_budget_amount = response.invoice_budget_amount ? +response.invoice_budget_amount : "";
      response.invoice_budget_amount = response.invoice_budget_amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
    if(response.invoice_consumed_budget != ""){
      response.invoice_consumed_budget = response.invoice_consumed_budget.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
    if(response.invoice_available_budget != ""){
      response.invoice_available_budget = response.invoice_available_budget.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }
    response.to_from_loc_period = response.to_from_loc_period ? response.to_from_loc_period : "";
    response.miscellaneous = response.miscellaneous ? response.miscellaneous : "";
    response.transportaion = response.transportaion ? response.transportaion : "";
    response.revenue_lob = response.revenue_lob ? response.revenue_lob : "";
    response.mode_of_transport = response.mode_of_transport ? response.mode_of_transport : "";
    response.cif_value = response.cif_value ? response.cif_value : "";
    response.custom_duty = response.custom_duty ? response.custom_duty : "";
    response.shipping_bill_of_export_no = response.shipping_bill_of_export_no ? response.shipping_bill_of_export_no : "";
    response.erp_id = response.erp_id ? response.erp_id : "";
    response.note = response.note ? response.note : "";
    response.channel_type = response.channel_type ? response.channel_type : '';
    response.channel_type_name = response.channel_type_name ? response.channel_type_name : '';
    let invoiceAdditionalCols: any[] = this.company_setup.additional_field_invoice_column_list ? this.company_setup.additional_field_invoice_column_list : [];
    let tempInvoiceAdditional = invoiceAdditionalCols.filter((v: any) => { return v.id == 'all_invoice_field_column' });
    if (tempInvoiceAdditional.length > 0) {
      invoiceAdditionalCols = tempInvoiceAdditional[0].columns ? tempInvoiceAdditional[0].columns : [];
    }

    response.lob_id = response.lob_id ? response.lob_id : '';
    response.lob_cs_id = response.lob_cs_id ? response.lob_cs_id : '';
    response.lob_nick_name = response.lob_nick_name ? response.lob_nick_name : ''
    this.company_setup.hide_numaric_number_in_lob_loc_dep = this.company_setup.hide_numaric_number_in_lob_loc_dep ? this.company_setup.hide_numaric_number_in_lob_loc_dep : '0';
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep !='1'){
      response.lob_nick_name = response.lob_cs_id!='' && response.lob_cs_id!=null ? response.lob_nick_name + " (" + response.lob_cs_id + ")" : response.lob_nick_name;
    }else{
      response.lob_nick_name = response.lob_nick_name ? response.lob_nick_name : ''
    }
   
    response.primary_loc_id = response.primary_loc_id ? response.primary_loc_id : '';
    response.pl_cs_id = response.pl_cs_id ? response.pl_cs_id : '';
    response.pl_nick_name = response.pl_nick_name ? response.pl_nick_name : '';
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep  !='1'){
    response.pl_nick_name = response.pl_cs_id!='' && response.pl_cs_id!=null ? response.pl_nick_name + " (" + response.pl_cs_id + ")" : response.pl_nick_name;
    }else{
      response.pl_nick_name = response.pl_nick_name ? response.pl_nick_name : '';
    }
    response.dept_id = response.dept_id ? response.dept_id : '';
    response.dept_cs_id = response.dept_cs_id ? response.dept_cs_id : '';
    response.dept_nick_name = response.dept_nick_name ? response.dept_nick_name : '';
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep  !='1'){
    response.dept_nick_name = response.dept_cs_id!='' && response.dept_cs_id!=null ? response.dept_nick_name + " (" + response.dept_cs_id + ")" : response.dept_nick_name;
    }else{
      response.dept_nick_name = response.dept_nick_name ? response.dept_nick_name : '';
    }
    let date_added = "";
    if(response.date_added != "" && response.date_added != null && response.date_added != undefined){
      date_added = this.webService.formatDateAccordingToSetup(response.date_added,this.company_setup.in_invoice_date_format)
    }
    let vendor_invoice_date = "";
    if(response.vendor_invoice_date != "" && response.vendor_invoice_date != null && response.vendor_invoice_date != undefined){
      // vendor_invoice_date = this.webService.formatDateAccordingToSetup(response.vendor_invoice_date,this.company_setup.in_invoice_date_format) 
      vendor_invoice_date = this.webService.formatDateAccordingToSetup(this.webService.getLocalDate(response.vendor_invoice_date),this.company_setup.in_invoice_date_format)

    }
    let po_date = "";
    if(response.po_date != "" && response.po_date != null && response.po_date != undefined){
      po_date = this.webService.formatDateAccordingToSetup(response.po_date,this.company_setup.in_invoice_date_format)
    }
    let grn_date = "";
    if(response.grn_date != "" && response.grn_date != null && response.grn_date != undefined){
      grn_date = this.webService.formatDateAccordingToSetup(response.grn_date,this.company_setup.in_invoice_date_format)
    }
    let service_start_date = "";
    if(response.service_start_date != "" && response.service_start_date != null && response.service_start_date != undefined){
      service_start_date = this.webService.formatDateAccordingToSetup(response.service_start_date,this.company_setup.in_invoice_date_format)
    }
    let service_end_date = "";
    if(response.service_end_date != "" && response.service_end_date != null && response.service_end_date != undefined){
      service_end_date = this.webService.formatDateAccordingToSetup(response.service_end_date,this.company_setup.in_invoice_date_format)
    }
    let journalDate = response.journal_date ? response.journal_date : "";
    if(response.journal_date != "" && response.journal_date != null && response.journal_date != undefined){
      journalDate = this.webService.formatDateAccordingToSetup(response.journal_date,this.company_setup.in_invoice_date_format)
    }
    let invoice_due_date = "";
    if(response.invoice_due_date != "" && response.invoice_due_date != null && response.invoice_due_date != undefined){
      invoice_due_date = this.webService.formatDateAccordingToSetup(response.invoice_due_date,this.company_setup.in_invoice_date_format)
    }
    let accural_entry_date = "";
    if(response.accural_entry_date != "" && response.accural_entry_date != null && response.accural_entry_date != undefined){
      accural_entry_date = this.webService.formatDateAccordingToSetup(response.accural_entry_date,this.company_setup.in_invoice_date_format)
    }
    let erp_date = "";
    if(response.erp_date != "" && response.erp_date != null && response.erp_date != undefined){
      erp_date = this.webService.formatDateAccordingToSetup(response.erp_date,this.company_setup.in_invoice_date_format)
    }
    response.credit_note_date = response.credit_note_date ? response.credit_note_date : "";
    response.credit_note_irn_no = response.credit_note_irn_no ? response.credit_note_irn_no : "";
    response.credit_note_no = response.credit_note_no ? response.credit_note_no : "";
    response.irn_no = response.irn_no ? response.irn_no : "";
    response.eway_bill_number = response.eway_bill_number ? response.eway_bill_number : "";
    response.purchase_type_document_name = response.purchase_type_document_name ? response.purchase_type_document_name : "";
    response.purchase_organization_name = response.purchase_organization_name ? response.purchase_organization_name : "";
    response.purchase_group_name = response.purchase_group_name ? response.purchase_group_name : "";
    response.invoice_approval_matrix_name = response.invoice_approval_matrix_name ? response.invoice_approval_matrix_name : "";
    response.voucher_type_name = response.voucher_type_name ? response.voucher_type_name : "";
    response.is_company_invoice = response.is_company_invoice ? response.is_company_invoice : '1';
    response.is_amount_mismatch = response.is_amount_mismatch ? response.is_amount_mismatch : '0';
    if(response.is_company_invoice == '0') {
      this.user_message = "This invoice does not seems to be your Company Invoice"; 
    }
    let show_multi_inv = response.show_multi_inv ? response.show_multi_inv : '0';

    this.company_setup.show_lob_dropdown = this.company_setup.show_lob_dropdown ? this.company_setup.show_lob_dropdown : '0';
    this.company_setup.show_loc_dropdown = this.company_setup.show_loc_dropdown ? this.company_setup.show_loc_dropdown : '0';
    this.company_setup.show_dept_dropdown = this.company_setup.show_dept_dropdown ? this.company_setup.show_dept_dropdown : '0';
    this.company_setup.show_voucher_type_in_inv = this.company_setup.show_voucher_type_in_inv ? this.company_setup.show_voucher_type_in_inv : "0";
    this.company_setup.enable_import_multi_invoice = this.company_setup.enable_import_multi_invoice ? this.company_setup.enable_import_multi_invoice : '0';
    // this.company_setup.show_lob_dropdown = response.is_direct == '1' ? this.company_setup.show_lob_dropdown : '0';
    // this.company_setup.show_loc_dropdown = response.is_direct == '1' ? this.company_setup.show_loc_dropdown : '0';
    // this.company_setup.show_dept_dropdown = response.is_direct == '1' ? this.company_setup.show_dept_dropdown : '0';

    this.company_setup.allow_ship_loc_change_update_inv = this.company_setup.allow_ship_loc_change_update_inv ? this.company_setup.allow_ship_loc_change_update_inv : '0';
    this.company_setup.irn_number_editable = this.company_setup.irn_number_editable ? this.company_setup.irn_number_editable : '0';
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by_inv,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'

      },
      {
        "display": this.company_setup.in_invoice_irn_no_custom_name ? this.company_setup.in_invoice_irn_no_custom_name : '',
        "value": response.irn_cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_multi_grn_invoice?false:(response.is_direct == '1' ? false : true), "input_type": 'text'
      },
      {
        "display": this.company_setup.in_invoice_grn_no_custom_name ? this.company_setup.in_invoice_grn_no_custom_name : '',
        "value": response.grn_cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_multi_grn_invoice?false:(response.is_direct == '1' ? false : true), "input_type": 'text'
      },
      {
        "display": this.company_setup.grn_date_custom_name,
        "value": grn_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_multi_grn_invoice?false:(response.is_direct == '1' ? false : true), "input_type": 'text'
      },
      {
        "display": 'System No',
        "value": response.cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": show_multi_inv=="1" ? false : true, "input_type": 'text'
      }, {
      "display": 'Invoice Type',
      "value": response.is_direct == '1' ? 'Direct Invoice' : 'GRN Invoice',
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "display": 'Import Multiple Invoices',
      "value": show_multi_inv == '1' ? true : false,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, 
      "is_view": (response.is_direct == '1' && this.company_setup.enable_import_multi_invoice == '1') ? true : false,"input_type": 'checkbox'
    },

    {
      "display": this.company_setup.custom_ship_location_name,
      "value": response.common_ship_location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(response.common_ship_location!=''&& response.common_ship_location!=undefined && response.common_ship_location!=null && (this.page_url != 'update-invoice' || (this.page_url == 'update-invoice' && this.company_setup.allow_ship_loc_change_update_inv == '1')) && this.company_setup.show_loc_dropdown=='0')?true:false, "input_type": 'text'
    }, 
    {
      "display": this.company_setup.custom_name_for_lob,
      "value": response.lob_nick_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":this.company_setup.show_lob_dropdown=='1' && (this.page_url != 'update-invoice' || (this.page_url == 'update-invoice' && this.company_setup.allow_ship_loc_change_update_inv!='1'))?true:false, "input_type": 'text'
    },
    {
      "display": this.company_setup.custom_name_for_loc,
      "value": response.pl_nick_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":this.company_setup.show_loc_dropdown=='1' && (this.page_url != 'update-invoice' || (this.page_url == 'update-invoice' && this.company_setup.allow_ship_loc_change_update_inv!='1'))?true:false, "input_type": 'text'
    },
    {
      "display": this.company_setup.custom_name_for_dept,
      "value": response.dept_nick_name,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":this.company_setup.show_dept_dropdown=='1' && (this.page_url != 'update-invoice' || (this.page_url == 'update-invoice' && this.company_setup.allow_ship_loc_change_update_inv!='1'))?true:false, "input_type": 'text'
    },   
    {
      "display": this.company_setup.show_msme_tag_in_vendor_detail == '1' && response.msme == '1' ? 'Vendor'+' '+'(MSME Vendor)' : this.company_setup.show_non_msme_tag_in_vendor_detail == '1' && response.msme == '0' ?  'Vendor'+' '+'(Non MSME Vendor)':'Vendor',
      // "value": response.vendor_first_name + " " + response.vendor_last_name + "(" + response.vendor_code + ")" + "( City-" + response.vendor_city_name + ")" + "( GST -" + response.vendor_gst_no + ")",
      "id": "vendor_address",
      "value": response.vendor_address ? response.vendor_address : response.vendor_first_name + " " + response.vendor_last_name + "(" + response.vendor_code + ")" + "( City-" + response.vendor_city_name + ")" + "( GST -" + response.vendor_gst_no + ")",
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.allow_vendor_loc_change_update_inv == "1" && this.page_url == 'update-invoice') ? false : true, "input_type": 'text'
    },

    {
      "display": this.company_setup.custom_bill_location_name,
      "value": response.bill_to_location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.is_bill_loc_hidden_in_inv!='1')?true:false, "input_type": 'text'
    },
    {
      "display": this.company_setup.invoice_receipt_date_name,
      "id": "invoice_date",
      "value": date_added,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "display": 'Invoice Due Date',
      "id": "invoice_due_date",
      "value": invoice_due_date,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": show_multi_inv=="1" ? false : true, "input_type": 'text'
    },
    {
      "display": 'Journal Date',
      "value": journalDate,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.pass_inv_entry_on=='journal_date'?true:false, "input_type": 'text'
    },
    {
      "display": 'Accural Entry Date',
      "value": accural_entry_date,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.is_accural_entry_date_visible=='1'?true:false, "input_type": 'text'
    },
    {
      "display": 'E-Invoice IRN No',
      "value": response.e_invoice_irn_no,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_einvoice_irn_visible=='1' && this.page_url!='update-invoice')?true:false, "input_type": 'text'
    },
      {
        "display": 'Vendor Invoice No',
        "value": response.invoice_no,
        "id": "vendor_invoice_no",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": show_multi_inv=="1" ? false : true, "input_type": 'text'
      }
      ,
      {
        "display": 'Vendor Invoice Date',
        "value": vendor_invoice_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": show_multi_inv=="1" ? false : true, "input_type": 'text'
      }
      ,
      {
        "display": 'Hold Payment',
        "value": response.hold_payment == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.in_invoice_hold_payment_visible == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        // "display": 'Is DDC',
        "display": this.company_setup.is_different_document_currency ?  this.company_setup.is_different_document_currency : 'IS DDC',
        "value": response.is_different_document_currency == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Conversion Rate',
        "value": response.conversion_rate,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Currency',
        "value": response.currency_name + "(" + response.currency_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Is Already Payment Made',
        "value": response.is_payment_made == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_payment_made == '1' ? (response.is_payment_made_disable == '1' ? false : true) : false, "input_type": 'checkbox'
      },
  //     {
  //       "display": 'Bank',
  //       "value":( response.company_bank_name!=null &&  response.company_bank_name !=undefined &&  response.company_bank_name!='')?(response.company_bank_name + "(" + response.company_bank_accountno + ")"):'',
  //       "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(response.is_payment_made == '1' && response.company_bank_name!=null) ? true : false, "input_type": 'text'
  //  }
  //     ,
      {
        "display": 'Customer',
        "value": response.customer,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.customer_first_name != '' && response.customer_first_name != undefined ? true : false, "input_type": 'text'
      }
      ,
      {
        "display": ' Have You Not Received GST Compliant Invoice?',
        "value": response.gst_compliant_invoice_recieved == '1' ? true : false,
        "div_size": 'col-sm-4', "is_disabled": true, "is_view": response.gst_compliant_invoice_recieved == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'IS CWIP',
        "value": response.is_cwip == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_cwip == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'No GST for SEZ',
        "value": response.override_gst == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.override_gst == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'GRN/SRN done',
        "value": response.grn_done == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.grn_done_visible_in_invoice == '1' && response.is_direct == '1') ? true : false, "input_type": 'checkbox',
      },
       {
        "display": 'Allocated To Customer',
        "value": response.is_customer_allocation_visible == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.is_customer_allocation_visible == '1'&& this.company_setup.is_customer_allocation_visible) ? true : false, "input_type": 'checkbox'
      }
      , {
        "display": 'Allocated To Cost Centre',
        "value": response.is_department_allocation_visible == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.is_department_allocation_visible == '1'&&this.company_setup.is_department_allocation_visible  && this.page_url!='update-invoice') ? true : false, "input_type": 'checkbox'
      }
      ,
      {
        "display": `${this.company_setup.rename_project}`,
        "value": response.project_detail,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_project_visible_in_invoice == '1'&& this.page_url!='update-invoice' && this.company_setup.is_budget_selection_at_item_level_in_product_table!='1' && show_multi_inv != "1") ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.rename_task,
        "value": response.task_details,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_task_visible_in_invoice == '1' && response.task_details != '' && this.page_url!='update-invoice' && this.company_setup.is_budget_selection_at_item_level_in_product_table!='1' && show_multi_inv != "1") ? true : false, "input_type": 'text'
      },
      {
        "display": `Budget Amount (${this.company_setup.currency_icon})`,
        "value": `${this.company_setup.currency_icon}:${response.invoice_budget_amount}`,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_task_visible_in_invoice == '1' && response.task_details != '' && this.page_url!='update-invoice' && response.invoice_budget_amount != '' && this.company_setup.task_budget_visible_in_invoice == "1" && show_multi_inv != "1") ? true : false, "input_type": 'text'
      },
      {
        "display": `Consumed Budget (${this.company_setup.currency_icon})`,
        "value": `${this.company_setup.currency_icon}:${response.invoice_consumed_budget}`,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_task_visible_in_invoice == '1' && response.task_details != '' && this.page_url!='update-invoice' && response.invoice_consumed_budget != '' && this.company_setup.task_consumed_budget_visible_in_invoice == '1' && show_multi_inv != "1") ? true : false, "input_type": 'text'
      },
      {
        "display": `Available Budget (${this.company_setup.currency_icon})`,
        "value": `${this.company_setup.currency_icon}:${response.invoice_available_budget}`,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.is_task_visible_in_invoice == '1' && response.task_details != '' && this.page_url!='update-invoice' && response.invoice_available_budget != '' && this.company_setup.task_balance_budget_visible_in_invoice == '1' && show_multi_inv != "1") ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.in_invoice_custom_name_of_month_drop_down ? this.company_setup.in_invoice_custom_name_of_month_drop_down : "Month",
        "value": response.month_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_month_drop_down_visible == '1') ? true : false, "input_type": 'text',"custom_key":"month_name"
      },
      {
        "display": 'Allocate To Employee',
        "value": response.invoice_allocate_to_employee == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.invoice_allocate_to_employee == '1'&& this.company_setup.invoice_allocate_to_employee_visible) ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Boq Name',
        "value": response.boq_full_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_direct_invoice_one_time_boq_visible == '1' && response.boq_full_name != '') ? true : false, "input_type": 'text'
      },
      {
        "display": [this.webService.getColumnName(invoiceAdditionalCols, 'channel_type', 'Channel')],
        "id": "channel_type",
        "value": response.channel_type_name ? response.channel_type_name : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true,"is_view": this.webService.is_column_visible(invoiceAdditionalCols, 'channel_type', false) && this.page_url != 'update-invoice', "input_type": 'text'
      },
      {
        "display": 'Service Start Date',
        "value": service_start_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.service_start_end_date_visible_in_inv == '1' && response.service_start_date != '') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Service End Date',
        "value": service_end_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.service_start_end_date_visible_in_inv == '1' && response.service_end_date != '') ? true : false, "input_type": 'text'
      },
      {
        "display": 'PO NO',
        "value": response.po_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.page_url != 'update-invoice' ? true : false, "input_type": 'text'
      },
      {
        "display": 'PO Date',
        "value": po_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'ERP Status',
        "value": response.erp_status ? response.erp_status : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.zoho_api_enable == '1' && this.company_setup.invoice_erp_status_is_visible == '1') ? true : false, "input_type": 'text'
      },
      {
        "display": 'ERP Code',
        "value": response.erp_code ? response.erp_code : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.zoho_api_enable == '1' && this.company_setup.invoice_erp_code_is_visible == '1') ? true : false, "input_type": 'text'
      },
      {
        "display": this.company_setup.in_invoice_custom_name_for_period ? this.company_setup.in_invoice_custom_name_for_period : "Period","value": response.to_from_loc_period,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_period_is_visible == '1' && this.page_url!='update-invoice' && show_multi_inv != "1") ? true : false, "input_type": 'text',"custom_key":"to_from_loc_period"
      },
      {
        "display": "Miscellaneous","value": response.miscellaneous,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_miscellaneous_is_visible == '1' && this.page_url!='update-invoice' && show_multi_inv != "1") ? true : false, "input_type": 'text',"custom_key":"miscellaneous"
      },
      {
        "display": "Transportation","value": response.transportaion,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_transportation_is_visible == '1' && this.page_url!='update-invoice' && show_multi_inv != "1") ? true : false, "input_type": 'text',"custom_key":"transportaion"
      },
      {
        "display": "Revenue LOB","value": response.revenue_lob,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_revenue_lob_is_visible == '1' && this.page_url!='update-invoice') ? true : false, "input_type": 'text',"custom_key":"revenue_lob"
      },
      {
        "display": "Mode of Transport","value": response.mode_of_transport,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_mode_of_transport_is_visible == '1' && this.page_url!='update-invoice' && show_multi_inv != "1") ? true : false, "input_type": 'text',"custom_key":"mode_of_transport"
      },
      {
        "display": "CIF Value","value": response.cif_value,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_cif_value_is_visible == '1' && show_multi_inv != "1") ? true : false, "input_type": 'text',"custom_key":"cif_value"
      },
      {
        "display": "Custom Duty","value": response.custom_duty,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_custom_duty_is_visible == '1' && this.page_url!='update-invoice' && show_multi_inv != "1") ? true : false, "input_type": 'text',"custom_key":"custom_duty"
      },
      {
        "display": "Shipping Bill / Bill of Export No","value": response.shipping_bill_of_export_no,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_shipping_bill_and_bill_of_export_no_is_visible == '1' && this.page_url!='update-invoice' && show_multi_inv != "1") ? true : false, "input_type": 'text',"custom_key":"shipping_bill_of_export_no"
      },
      {
        "display": this.company_setup.custom_name_for_inv_erp_id ? this.company_setup.custom_name_for_inv_erp_id : "ERP ID","value": response.erp_id ? response.erp_id : '',"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": ((this.company_setup.in_invoice_erp_id_is_visible == '1'  || (this.company_setup.erp_id_visible_mandatory_for_last_approval == '1' && response.check_last_approval =='1')) && this.page_url!='update-invoice') ? true : false, "input_type": 'text',"custom_key":"erp_id"
      },
      {
        "display": "Note","value": response.note,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.in_invoice_note_is_visible == '1' && this.page_url!='update-invoice') ? true : false, "input_type": 'text',"custom_key":"note"
      },
      {
        "display": 'Agreement Based Invoice',
        "value": (response.vendor_agreement == true || response.vendor_agreement == '1') ? true : false,
        "div_size": 'col-sm-2 div1  ', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.is_agreement_based_invoice=='1' && this.page_url!='update-invoice')  ? true : false, "input_type": 'checkbox'
      },

      {
        "display": "Selected Aggrement",
        "value": response.vendor_agreement_id ? 
        (response.is_expired == '0' ? response.vendor_agreement_detail + '(active)' : response.vendor_agreement_detail + '(expired)') : '',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.is_agreement_based_invoice=='1' && this.page_url!='update-invoice')  ? true : false, "input_type": 'text',
      },

      {
        "display": "Voucher Type",
        "value": response.voucher_type_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.show_voucher_type_in_inv == '1' && this.page_url != 'update-invoice') ? true : false, "input_type": 'text',
      },

      {
        "display": this.company_setup.custom_name_for_inv_erp_date ? this.company_setup.custom_name_for_inv_erp_date : "ERP Date",
        "value": erp_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":((this.company_setup.invoice_erp_date_is_visible=='1' || (this.company_setup.erp_date_visible_mandatory_for_last_approval == '1' && response.check_last_approval =='1'))  && this.page_url!='update-invoice') ? true : false, "input_type": 'text',
      },
      {
        "display": "Credit Note IRN No","value": response.credit_note_irn_no,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, 
        "is_view": (response.is_debit_value == '1' && this.isVisibled('credit_note_irn_no')) ? true : false, 
        "input_type": 'text',"custom_key":"credit_note_irn_no"
      },
      {
        "display": "Credit Note No","value": response.credit_note_no,"div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, 
        "is_view": ( response.is_debit_value == '1' && this.isVisibled('credit_note_no')) ? true : false, 
        "input_type": 'text',"custom_key":"credit_note_no"
      },
      {
        "display": 'Credit Note Date',
        "value": response.credit_note_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, 
        "is_view": (response.is_debit_value == '1' && this.isVisibled('credit_note_date')) ? true : false, 
        "input_type": 'text'
      },
      {
        "display": 'IRN number',
        "value": response.irn_no,
        "id": "irn_no",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, 
        "is_view": (this.company_setup.is_irn_number_visible_for_invoice == '1' && ((this.company_setup.irn_number_editable == '1' && this.page_url != 'update-invoice') || (this.company_setup.irn_number_editable != '1' && show_multi_inv != "1"))) ? true : false, 
        "input_type": 'text'
      },
      {
        "display": 'E-Way bill number',
        "value": response.eway_bill_number,
        "id": "eway_bill_number",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, 
        "is_view": (show_multi_inv != "1" && this.company_setup.is_eway_bill_visible_for_invoice == '1') ? true : false, 
        "input_type": 'text'
      },
      {
        "display": 'Purchase Document Type',
        "value": response.purchase_type_document_name,
        "id": "purchase_type_document_name",
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true,
        "is_view":  this.company_setup.is_purchase_document_types_visible_in_invoice == '1' && this.page_url != 'update-invoice' ? true : false,
        "input_type": 'text'
      },
      {
        "display": 'Purchase Organization',
        "value": response.purchase_organization_name,
        "id": "purchase_organization_name",
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true,
        "is_view": this.company_setup.is_purchase_organizations_visible_in_invoice == '1' && this.page_url != 'update-invoice' ? true : false,
        "input_type": 'text'
      },
      {
        "display": 'Purchase Group',
        "value": response.purchase_group_name,
        "id": "purchase_group_name",
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true,
        "is_view": this.company_setup.is_purchase_groups_visible_in_invoice == '1' && this.page_url != 'update-invoice' ? true : false,
        "input_type": 'text'
      },
      {
        "display": this.webService.getColumnName(this.company_setup.invoice_extra_columns, 'approval_matrix', 'Approval Matrix'),
        "id": "invoice_approval_matrix_name",
        "value": response.invoice_approval_matrix_name ? response.invoice_approval_matrix_name : '',
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true,
        "is_view": this.webService.is_column_visible(this.company_setup.invoice_extra_columns, 'approval_matrix', false) && this.page_url != 'update-invoice' ? true : false,
        "input_type": 'text'
      }
    );
    if(this.commonVariableList.divList && this.page_url =='update-invoice'){
      for(let x of this.commonVariableList.divList){
        x.custom_key = x.custom_key ? x.custom_key : "";
        if(x.display == 'GRN/SRN done' && this.company_setup.grn_done_visible_in_invoice == '1') {
          x.is_view = false;
        }
        if(x.display == 'Vendor Invoice Date' && this.company_setup.in_update_invoice_ven_inv_date_editable == '1') {
          x.is_view = false;
        }  
        if(x.custom_key == 'month_name' && this.company_setup.in_update_invoice_month_editable == '1') {
          x.is_view = false;
        }
        if(x.display == 'Service Start Date' && this.company_setup.in_update_invoice_service_start_and_end_date_editable == '1') {
          x.is_view = false;
        }
        if(x.display == 'Service End Date' && this.company_setup.in_update_invoice_service_start_and_end_date_editable == '1') {
          x.is_view = false;
        }
        if(x.display == 'Invoice Due Date' && this.company_setup.in_update_invoice_due_date_editable == '1') {
          x.is_view = false;
        }
        if(x.display == 'Project' && this.company_setup.in_update_invoice_project_editable == '1') {
          x.is_view = false;
        }
        if(x.display == 'Vendor Invoice No' && this.company_setup.in_update_invoice_vendor_inv_number_editable == '1') {
          x.is_view = false;
        }
        if(x.display == 'Bank' && this.company_setup.invoice_is_payment_made_editable == '1') {
          x.is_view = false;
        }
      }
    }
    this.commonVariableList.divList= this.commonVariableList.divList.filter((v)=>{return v.is_view});
    this.commonVariableList.meta_list=this.commonVariableList.meta_list.filter((v)=>{return v.value!='' && v.value!=undefined && v.value!=null})
  }
  showRecurringInvoice(response) {
    if(this.page_url=='auto-generated-inv')
    {
      this.headClass='info blink-1'
      this.head_title=`"Note:- Price in the product table and in summary table is excluding tax, actual tax details can be seen on the "Create Actual Invoice" Page."`
    }
  response.project_name = response.project_name ? response.project_name : '';
    response.project_code = response.project_code ? response.project_code : '';
    response.project_detail = '';
    if (response.project_name != '' && response.project_name != undefined) {
      response.project_detail = response.project_name
    }
    response.task_name = response.task_name ? response.task_name : '';
    response.task_code = response.task_code ? response.task_code : '';
    response.task_details = response.task_name;
    response.invoice_allocate_to_employee = response.invoice_allocate_to_employee  ?response.invoice_allocate_to_employee : "0"
    // //console.log(this.company_setup.is_department_allocation_visible)
    response.boq_name = response.boq_name ? response.boq_name : "";
    response.boq_code = response.boq_code ? response.boq_code : "";
    response.task_details=response.task_details?response.task_details:(response.task_detail?response.task_detail:'')
    if(response.is_different_document_currency=='1')
    {
      this.commonVariableList.meta_list.push({
        key:'inv_msg_fo_vendor_out_ind',value:response.inv_msg_fo_vendor_out_ind,"class":'h1_cls',"tag_name":"h3"
        ,is_visible:true
      })
      this.commonVariableList.meta_list=this.commonVariableList.meta_list.filter((v)=>{return v.is_visible})
    }

    if(this.company_setup.is_tds_edit_msg_visible_for_approver=='1')
    {
      // console.log(this.divDetails);
      // console.log(this.page_url);

      if(this.page_url=='recurring-inv-for-approval')
      {
          // console.log(this.divDetails.data.invoice_items);
      // console.log(this.page_url);
      // console.log(this.divDetails.data.invoice_items.some((v)=>{return v.is_tds_rate_edited=='1'}));
      this.head_title=this.divDetails.data.invoice_items.some((v)=>{return v.is_tds_rate_edited=='1'})?this.company_setup.tds_edit_msg_visible_for_approver:''
      }
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'

      },
      {
        "display": 'RCT No',
        "value": response.invoice_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },

      {
        "display": 'RCT Description',
        "value": response.template_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
    {
      "display": "Ship Location",
      "value": response.ship_to_location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(response.ship_to_location!=''&& response.ship_to_location!=undefined&&response.ship_to_location!=null)?true:false, "input_type": 'text'
 }
    ,
    {
      "display": 'Vendor',
      "value": response.vendor_address ? response.vendor_address :"",
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,

    {
      "display": "Bill Location",
      "value": response.bill_to_location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.is_bill_loc_hidden_in_inv!='1')?true:false, "input_type": 'text'
 },
    {
      "display": "Invoice Frequency",
      "value": response.invoice_frequency.toUpperCase(),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "display": "RCT Creation Date",
      "value": this.webService.formatDateAccordingToSetup(response.invoice_date, this.company_setup.in_invoice_date_format),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "display": "Invoice Start Date",
      "value": this.webService.formatDateAccordingToSetup(response.invoice_start_date, this.company_setup.in_invoice_date_format),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "display": "Invoice End Date",
      "value": this.webService.formatDateAccordingToSetup(response.invoice_end_date, this.company_setup.in_invoice_date_format),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
      {
        "display": 'Is DDC',
        "value": response.is_different_document_currency == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Conversion Rate',
        "value": response.conversion_rate,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Currency',
        "value": response.currency_name + "(" + response.currency_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Is Invoice Amount Editable',
        "value": response.invoice_amount_editable == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
      },
      {
        "display": 'No GST for SEZ',
        "value": response.override_gst == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.override_gst == '1' ? true : false, "input_type": 'checkbox'
      }
      , {
        "display": 'Allocated To Customer',
        "value": response.is_customer_allocation_visible == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.is_customer_allocation_visible == '1'&& this.company_setup.is_customer_allocation_visible) ? true : false, "input_type": 'checkbox'
      }
      , {
        "display": 'Allocated To Cost Centre',
        "value": response.is_department_allocation_visible == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.is_department_allocation_visible == '1'&&this.company_setup.is_department_allocation_visible  && this.page_url!='update-invoice') ? true : false, "input_type": 'checkbox'
      }
      ,
      {
        "display": 'Project',
        "value": response.project_name,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.RIT_is_project_visible_in_invoice == '1' && (response.project_name!="")&& this.page_url!='update-recurring-invoice') ? true : false, "input_type": 'text'
      },
      {
        "display": 'Task',
        "value": response.task_name,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (this.company_setup.RIT_is_task_visible_in_invoice == '1' && response.task_name != '' && this.page_url!='update-recurring-invoice') ? true : false, "input_type": 'text'
      },
      {
        "display": "Create Invoice In Advance(Days)",
        "value": response.invoice_in_advance,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text',"custom_key":"month_name"
      },
      {
        "display": 'Allocate To Employee',
        "value": response.invoice_allocate_to_employee == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": (response.invoice_allocate_to_employee == '1'&& this.company_setup.invoice_allocate_to_employee_visible) ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Boq Name',
        "value": response.boq_full_name,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":false, "input_type": 'text'
      },
      {
        "display": 'Contract Renewal Reminder Date',
        "value": this.webService.formatDateAccordingToSetup(response.contract_renewal_reminder_date, this.company_setup.in_invoice_date_format),
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Contract Reminder Emails',
        "value": response.reminder_emails ? response.reminder_emails: "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Value Increase Limited To (%)',
        "value": response.total_amount_increase_limit ? response.total_amount_increase_limit: "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.value_increase_limited_to == '1') && (response.invoice_amount_editable == '1') ? true : false, "input_type": 'text'
      }
    );
    if(this.commonVariableList.divList && this.page_url =='update-recurring-invoice'){
      for(let x of this.commonVariableList.divList){
        x.custom_key = x.custom_key ? x.custom_key : "";
        if(x.display == 'Project' && this.company_setup.in_update_invoice_project_editable == '1') {
          x.is_view = false;
        }
        if(x.display == 'Vendor Invoice No' && this.company_setup.in_update_invoice_vendor_inv_number_editable == '1') {
          x.is_view = false;
        }
      }
    }
    this.commonVariableList.divList= this.commonVariableList.divList.filter((v)=>{return v.is_view});

  }
  showSalesOrderData(response) {

    response.send_mail_customer = response.send_mail_customer == '1' ? true : false;
    response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.added_by_employee_code + ")"
    response.vendor_details = response.vendor_first_name + " " + response.vendor_last_name;
    response.bill_to_location = response.bill_location_nickname_9_digit + " (" + response.bill_location_code_9_digit + ")";
    response.ship_to_location = `${response.ship_to_location_state_name ? response.ship_to_location_state_name : ''} , ${response.ship_to_location_city_name ? response.ship_to_location_city_name : ''} , ${response.ship_to_location_pincode ? response.ship_to_location_pincode : ''}`;
    response.customer_details = response.customer_first_name + " " + response.customer_last_name + "(" + response.customer_code + ")"
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.requested_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Source of Sales Order',
        "value": response.source_of_sales_order,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Required by Date',
        "value": this.webService.formatDate(response.required_by_date, 'yy-mm-dd', '-'),
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.sales_required_by_date == '1', "input_type": 'text'
      },
      {
        "display": 'Sales Order Date',
        "value": this.webService.formatDate(response.sales_order_date, 'yy-mm-dd', '-'),
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Customer Name',
        "value": response.customer_details,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }, {
      "display": 'Bill To Location',
      "value": response.bill_to_location,
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
      {
        "display": 'Ship To Location',
        "value": response.ship_to_location,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Sales Order Number',
        "value": response.sales_order_no,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Sales Order Auto Closuer Date',
        "value": response.sales_order_auto_closuer_date,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.sales_auto_closer_date_visible == '1', "input_type": 'text'
      },
      {
        "display": 'Credit period',
        "value": response.credit_period,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Total Credit Limit',
        "value": response.credit_limit,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Balance Credit Limit',
        "value": response.credit_limit,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Name Of The person',
        "value": response.name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.sales_name_of_the_person_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Person Phone Number',
        "value": response.phone,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.sales_person_phone_number_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Person Email Id',
        "value": response.email,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.sales_person_mail_visible == '1' ? true : false, "input_type": 'text'
      },
      {
        "display": 'Send Mail To Customer',
        "value": response.send_mail_customer,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.send_mail_customer, "input_type": 'checkbox'
      }

    );

  }

  showMyadvanceData(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Added By',
        "value": response.added_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Added For',
        "value": response.added_for,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Project',
        "value": response.project_details,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
    )
  }
  showEmployeeAdvancePaymentData(response) {
    this.commonVariableList.divList.push(
      {
        "display": 'Added By',
        "value": response.added_by,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      }
    )
  }
  showDCNote(response) {
    response.vendor_code = response.vendor_code ? response.vendor_code : '';
    response.vendor_address=response.vendor_address?response.vendor_address:''
    response.vendor_city_name=response.vendor_city_name?response.vendor_city_name:'';
    if(response.vendor_address=='')
    {
      response.vendor_address= response.vendor_first_name + " " + response.vendor_last_name + " " + "(" + response.vendor_code + ")" + " " + "(City - " + response.vendor_city_name + ")" + " " + "(GST - " + response.vc_gst_no + ")";
    }
    response.customer_first_name = response.customer_first_name ? response.customer_first_name : '';
    response.customer_last_name = response.customer_last_name ? response.customer_last_name : '';

    response.customer_code = response.customer_code ? response.customer_code : '';
    response.customer_detail = '';
    if (response.customer_first_name != '' && response.customer_first_name != undefined) {
      response.customer_detail = response.customer_first_name + " " + response.customer_last_name + " (" + response.customer_code + ")";
    }
    response.vendor_location=response.vendor_location?response.vendor_location:'NA';
    response.customer_location=response.customer_location?response.customer_location:'NA';
    response.dept_nick_name = '';
    response.lob_nick_name = '';
    response.pl_nick_name = '';
    if(this.company_setup.hide_numaric_number_in_lob_loc_dep !='1'){
      response.lob_nick_name = response.ship_lob_code!='' && response.ship_lob_code!=null ? response.ship_lob_name + " (" + response.ship_lob_code + ")" : response.ship_lob_name;
      response.pl_nick_name = response.ship_primary_loc_code!='' && response.ship_primary_loc_code!=null ? response.ship_primary_loc_name + " (" + response.ship_primary_loc_code + ")" : response.ship_primary_loc_name;
      response.dept_nick_name = response.ship_dept_code!='' && response.ship_dept_code!=null ? response.ship_dept_name + " (" + response.ship_dept_code + ")" : response.ship_dept_name;

    }else{
      response.lob_nick_name = response.ship_lob_name ? response.ship_lob_name : '';
      response.pl_nick_name = response.ship_primary_loc_name ? response.ship_primary_loc_name : '';
      response.dept_nick_name = response.ship_dept_name ? response.ship_dept_name : '';
    }
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.added_by_first_name + " " + response.added_by_last_name + " " + "(" + response.added_by_employee_code + ")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Cost Center',
        "value": response.location_nickname_9_digit + "(" + response.location_code_9_digit+")",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.show_loc_dropdown=='1' ? false : true, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_lob,
        "value": response.lob_nick_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.show_lob_dropdown=='1')?true:false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_loc,
        "value": response.pl_nick_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.show_loc_dropdown=='1')?true:false, "input_type": 'text'
      },
      {
        "display": this.company_setup.custom_name_for_dept,
        "value": response.dept_nick_name,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":(this.company_setup.show_dept_dropdown=='1')?true:false, "input_type": 'text'
      },
      {
        "display": 'D/C Note No',
        "value": response.cs_id,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Note Type',
        "value":response.note_type=='1'?'Debit Note':'Credit Note',
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'radio'
      }, {
      "display": response.note_type=='1'?'Vendor':'Customer',
      "value": response.note_type=='1'?(response.vendor_address):(response.customer_detail),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "display": response.note_type=='1'?'Vendor Location ':'Customer :Location ',
      "value": response.note_type=='1'?(response.vendor_location):(response.customer_location),
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
      {
        "display": 'Is Invoice',
        "value": response.is_invoice == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_invoice == '1' ? true : false, "input_type": 'checkbox'
      },
      {
        "display": 'Select Paid Invoices',
        "value": response.post_payment_dc == '1' ? true : false,
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true,
        "is_view": (response.note_type == '1' && this.company_setup.allow_post_payment_debit_note_in_dc_note == '1') ? true : false,
        "input_type": 'checkbox'
      },
      {
        "display": 'Invoice No',
        "value": response.note_type=='1'?(response.invoice_no):(response.sales_invoice_no),
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":true, "input_type": 'text'
      },
      {
        "display": 'Je Date',
        "value": response.je_date,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":this.company_setup.is_je_date_visible_in_add_dc=='1', "input_type": 'text'
      },
      {
        "display": 'Conversion Rate',
        "value": response.conversion_rate,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": response.is_different_document_currency == '1' ? true : false,"input_type": 'text'
      },
      {
        "display": 'Vendor Credit Note No',
        "value": response.vendor_credit_note,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.company_setup.enable_vendor_credit_note_no_dc_page == '1' && this.page_url != 'update-debit-credit-note' ? true : false, "input_type": 'text'
      },
    );

  }
  showVendorCreditNote(response) {
    response.vendor_code = response.vendor_code ? response.vendor_code : '';
    response.vendor_address=response.vendor_address?response.vendor_address:''
    response.vendor_city_name=response.vendor_city_name?response.vendor_city_name:'';
    if(response.vendor_address=='')
    {
      response.vendor_address= response.vendor_first_name + " " + response.vendor_last_name + " " + "(" + response.vendor_code + ")" + " " + "(City - " + response.vendor_city_name + ")" + " " + "(GST - " + response.vc_gst_no + ")";
    }
    response.vendor_location=response.vendor_location?response.vendor_location:'NA';
    this.commonVariableList.divList.push(
      {
        "display": 'Requested By',
        "value": response.added_by_first_name + " " + response.added_by_last_name + " " + "(" + response.added_by_vendor_code + ")",
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Cost Center',
        "value": response.location_nickname_9_digit + "(" + response.location_code_9_digit + ")",
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": this.company_setup.show_loc_dropdown == '1' ? false : true, "input_type": 'text'
      },
      {
        "display": 'Credit Note No',
        "value": response.vendor_credit_note,
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Vendor Location',
        "value": response.vendor_address,
        "div_size": 'col-sm-2 div1', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
      {
        "display": 'Invoice No',
        "value":response.invoice_no,
        "div_size": 'col-sm-2', "is_html": false, "is_editable": false, "is_disabled": true, "is_view": true, "input_type": 'text'
      },
    );

  }
  remarks : any = "";
  remarksHeading : any = "";
  showRfqData(response) {
    response.rfq_responsible_person = response.rfq_responsible_person ? response.rfq_responsible_person : [];
    response.currency_name = response.currency_name ? `${response.currency_name} (${response.currency_code})` : "";
    response.rfq_vendor_details = response.rfq_vendor_details ? response.rfq_vendor_details : [];
    response.email_to_send_quotation_pdf = response.email_to_send_quotation_pdf ? response.email_to_send_quotation_pdf : [];
    response.pr_list = response.pr_list ? response.pr_list : [];
    response.product_selection_type = response.product_selection_type ? response.product_selection_type : "products";
    // let vendrNameArray = response.rfq_vendor_details.length > 0 ? response.rfq_vendor_details.map((d)=> )
    // console.log(response)
    response.statusName = "";
    switch(response.status) {
      case '1':
        response.statusName = 'Active';
        break;
      case '2':
        response.statusName = 'Closed';
        break;
      case '3':
        response.statusName = 'Opened';
        break;
      case '4':
        response.statusName = 'Awarded';
        break;
      default:
        response.statusName = '';
    
    }

    response.vendorList = [];
    for (let x of response.rfq_vendor_details) {
      response.vendorList.push(x.vendor_name + ' (' + x.vendor_code + ')');
    }
    this.commonVariableList.divList.push(
      {
        "display": this.getColumnNameQuotationManagement('rfq_number','RFQ Number'),
        "value": response.rfq_number ? response.rfq_number:  "",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view": this.is_QuotationManagement_column_visible('rfq_number',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('rfq_name','RFQ Name'),
        "value": response.rfq_name ? response.rfq_name : "",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('rfq_name',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('rfq_description','RFQ Description'),
        "value": response.rfq_description ? response.rfq_description : "",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('rfq_description',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('rfq_start_date','RFQ Start Date'),
        "value":response.rfq_start_date ? response.rfq_start_date : "",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('rfq_start_date',false), "input_type": 'text'
      }, 
      {
      "display": this.getColumnNameQuotationManagement('rfq_end_date','RFQ End Date'),
      "value": response.rfq_end_date ? response.rfq_end_date : "",
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('rfq_end_date',false), "input_type": 'text'
      },
      {
      "display": this.getColumnNameQuotationManagement('bid_open_date','Bid Open Date'),
      "value": response.bid_open_date ? response.bid_open_date : "",
      "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('bid_open_date',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('bid_close_date','Bid Close Date'),
        "value": response.bid_close_date  ? response.bid_close_date : "",
        "div_size": 'col-sm-2 div1', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('bid_close_date',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('responsible_person_name','Responsible Person Name'),
        "value": response.rfq_responsible_person.length > 0 ? response.rfq_responsible_person[0].name : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view":this.is_QuotationManagement_column_visible('responsible_person_name',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('responsible_person_email','Responsible Person Email') ,
        "value": response.rfq_responsible_person.length > 0 ? response.rfq_responsible_person[0].email : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('responsible_person_email',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('responsible_person_mobile','Responsible Person Mobile'),
        "value": response.rfq_responsible_person.length > 0 ? response.rfq_responsible_person[0].phone : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('responsible_person_mobile',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('send_quotation_link','Send Quotation link'),
        "value": response.send_rfq_quotation_link == '1' ? 'Yes' : 'No',
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" : this.linkType=="rfqResponseReport" ? true : false, "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('send_rfq_to_vendor','Send RFQ To Vendor'),
        "value": response.send_rfq_vendor == '1' ? 'Yes' :  'No',
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('send_rfq_to_vendor',false) , "input_type": 'text'
      },
      {
        "display": 'Status' ,
        "value": response.statusName,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" : true, "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('remarks','Remarks'),
        "value": response.remarks ? response.remarks : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('remarks',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('is_auction','Is Auction'),
        "value": response.auction_value == '1' ? 'Yes' : '',
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('is_auction',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('ship_to_location','Ship To Location'),
        "value": response.ship_location_name ? response.ship_location_name : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('ship_to_location',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('bill_to_location','Bill To Location'),
        "value": response.bill_location_name ? response.bill_location_name : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('bill_to_location',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('rfi','RFI'),
        "value": response.rfi_name ? response.rfi_name : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('rfi',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('incoterm','Incoterm'),
        "value": response.incoterms_name ? response.incoterms_name : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('incoterm',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('incoterm_description','Incoterm Description'),
        "value": response.incoterm_description ? response.incoterm_description : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('incoterm_description',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('delivery_location','Delivery Location'),
        "value": response.delivery_location ? response.delivery_location : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('delivery_location',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('paymentterm','Payment term') ,
        "value": response.payment_term_name ? response.payment_term_name : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('paymentterm',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('paymentterm_description','Payment term Description'),
        "value": response.payment_term_description ? response.payment_term_description : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('paymentterm_description',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('currency','Currency') ,
        "value": response.currency_name ? response.currency_name : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :response.currency_code && response.currency_code!='' && response.currency_code!=null ? true : false, "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('conversion_rate','Conversion rate') ,
        "value": response.conversion_rate ? response.conversion_rate : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :response.currency_code && response.currency_code!='' && response.currency_code!=null  && response.currency_code!=undefined && response.conversion_rate>0 && this.linkType=="rfqResponseReport" ? true : false, "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('vendor','Vendor List'),
        "value": response.vendorList,
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('vendor',false), "input_type": 'list'
      },
      {
        "display": this.getColumnNameQuotationManagement('emp_who_can_open_bid','Employee Who can Bid'),
        "value": response.rfq_employee_details.length > 0 ? response.rfq_employee_details.map((d)=> `${d.employee_name} (${d.employee_code})`).join(', ') : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('emp_who_can_open_bid',false), "input_type": 'text'
      },
      {
        "display": this.getColumnNameQuotationManagement('email_to_send_quotation_pdf','Email to send Quotation PDF'),
        "value": response.email_to_send_quotation_pdf.length > 0 ? response.email_to_send_quotation_pdf.map((d)=> `${d.display}`).join(', ') : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" :this.is_QuotationManagement_column_visible('emp_who_can_open_bid',false) && this.linkType!="rfqResponseReport" ? true : false, "input_type": 'text'
      },
      {
        "display": "PR List",
        "value": response.pr_list.length > 0 ? response.pr_list.map((d)=> `${d.item_text}`).join(', ') : "",
        "div_size": 'col-sm-2', "is_html":false,"is_editable": false, "is_disabled": true, "is_view" : response.product_selection_type == 'pr' && this.linkType!="rfqResponseReport" ? true : false, "input_type": 'text'
      },
      );

      if(this.linkType=="rfqResponseReport") {
        this.remarks = response.rfq_details;
        this.remarksHeading = this.getColumnNameQuotationManagement('rfq_details','RFQ Details');
      }
    }

    getColumnNameQuotationManagement(key, default_data) {
      if (key == '' || key == undefined) {
        return default_data ? default_data : '-';
      }
      if (this.company_setup.quotation_management_master_column_list.length == undefined || this.company_setup.quotation_management_master_column_list.length <= 0) {
        return default_data ? default_data : '-';

      }
      let temp: any = [];
      temp = this.company_setup.quotation_management_master_column_list.filter((v) => { return v.key == key });
      if (temp.length == undefined || temp.length <= 0) {
        return default_data ? default_data : '-';
      }
      return temp[0].custom_name ? temp[0].custom_name : '-'
    }

    is_QuotationManagement_column_visible(key, default_data) {
      if (key == '' || key == undefined) {
        return default_data ? default_data : false;
      }
      if (this.company_setup.quotation_management_master_column_list.length == undefined || this.company_setup.quotation_management_master_column_list.length <= 0) {
        return default_data ? default_data : false;

      }

      let temp: any = [];
      temp = this.company_setup.quotation_management_master_column_list.filter((v) => { return v.key == key });
      if (temp.length == undefined || temp.length <= 0) {
        return default_data ? default_data : false;
      }
      return temp[0].is_visible ? temp[0].is_visible : false
    }
  
  adhoc_getColumnName(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.po_adhoc_advance_payment.length == undefined || this.company_setup.po_adhoc_advance_payment.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = this.company_setup.po_adhoc_advance_payment.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  adhoc_is_column_visible(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }

    if (this.company_setup.po_adhoc_advance_payment.length == undefined || this.company_setup.po_adhoc_advance_payment.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = this.company_setup.po_adhoc_advance_payment.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }

  getPrColumnName(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];

    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });

    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  is_pr_column_visible(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }
    // if (!this.companySelectionDisabled) {
    //   return true;
    // }
    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : false;

    }

    let temp: any = [];
    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }
  is_pr_column_mandatory(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }

    if (this.company_setup.select_pr_list.length == undefined || this.company_setup.select_pr_list.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = this.company_setup.select_pr_list[0].columns.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_mandatory ? temp[0].is_mandatory : false
  }

  poAdditionalGetColumnName(key, default_data) {
    this.company_setup.po_additional_fields_column_list = this.company_setup.po_additional_fields_column_list ? this.company_setup.po_additional_fields_column_list : []
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.po_additional_fields_column_list.length == undefined || this.company_setup.po_additional_fields_column_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = this.company_setup.po_additional_fields_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  poAdditionalIs_column_visible(key, default_data) {
    this.company_setup.po_additional_fields_column_list = this.company_setup.po_additional_fields_column_list ? this.company_setup.po_additional_fields_column_list : []
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }
    if (this.company_setup.po_additional_fields_column_list.length == undefined || this.company_setup.po_additional_fields_column_list.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = this.company_setup.po_additional_fields_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }
  isPoDetailsVisible:boolean = false;
  showPoDetails(poNumber) {
    this.commonVariableList.modalDetails = { "data": { "po_no": poNumber }, "id": "poreport", "name": 'PO Details', "Desscription": 'PO', "is_view": true };
    this.isPoDetailsVisible = true;
  }

  viewRow(elem:any) {
    // console.log(elem)
  }
  salesInvoicegetColumnName(key, default_data) {
    this.company_setup.sales_invoice_column_list = this.company_setup.sales_invoice_column_list ? this.company_setup.sales_invoice_column_list : []
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.sales_invoice_column_list.length == undefined || this.company_setup.sales_invoice_column_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = this.company_setup.sales_invoice_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  salesInvoice_is_column_visible(key, default_data) {
    this.company_setup.sales_invoice_column_list = this.company_setup.sales_invoice_column_list ? this.company_setup.sales_invoice_column_list : []
    if (key == '' || key == undefined) {
      return default_data ? default_data : false;
    }
    if (this.company_setup.sales_invoice_column_list.length == undefined || this.company_setup.sales_invoice_column_list.length <= 0) {
      return default_data ? default_data : false;

    }
    let temp: any = [];
    temp = this.company_setup.sales_invoice_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : false;
    }
    return temp[0].is_visible ? temp[0].is_visible : false
  }
// Replace your current isVisibled method with this more robust version:
isVisibled(key: string): boolean {
  // First check if vendor_invoice_column_list exists and has the field
  if (this.company_setup.vendor_invoice_column_list && this.company_setup.vendor_invoice_column_list.length > 0) {
    return this.company_setup.vendor_invoice_column_list.some((v) => { return v.id == key && v.isVisible });
  }
}

// Helper method to check if display value contains "po note"
isPoNoteField(display: any): boolean {
  if (!display) {
    return false;
  }
  const displayStr = String(display).toLowerCase();
  return displayStr.includes('po note') || displayStr.includes('po_note');
}

  /** IRN additional field visible only when company setup has it with enable on (single source of truth — no HTML fallback flags). */
  isIrnFieldEnabled(key: string): boolean {
    this.company_setup.irn_additional_fields_configuration = this.company_setup.irn_additional_fields_configuration ? this.company_setup.irn_additional_fields_configuration : [];
    if (key == '' || key == undefined) {
      return false;
    }

    const cfg = this.company_setup.irn_additional_fields_configuration;
    if (cfg.length == undefined || cfg.length <= 0) {
      return false;
    }

    const temp = cfg.filter((v: any) => v.id == key);
    if (temp.length == undefined || temp.length <= 0) {
      return false;
    }
    const e = temp[0].enable;
    return e === true || e === 1 || e === '1' || e === 'true';
  }

  // Get Custom Name for IRN Additional Field
  getIrnFieldCustomName(key: string, default_name: string): string {
    this.company_setup.irn_additional_fields_configuration = this.company_setup.irn_additional_fields_configuration ? this.company_setup.irn_additional_fields_configuration : [];
    if (key == '' || key == undefined) {
      return default_name;
    }

    if (this.company_setup.irn_additional_fields_configuration.length == undefined || this.company_setup.irn_additional_fields_configuration.length <= 0) {
      return default_name;
    }

    let temp: any = [];
    temp = this.company_setup.irn_additional_fields_configuration.filter((v: any) => { return v.id == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_name;
    }
    return temp[0].custom_name && temp[0].custom_name != '' ? temp[0].custom_name : default_name;
  }

  gpFieldVisible(key: string): boolean {
    this.company_setup.gate_pass_additional_fields_configuration = this.company_setup.gate_pass_additional_fields_configuration ? this.company_setup.gate_pass_additional_fields_configuration : [];
    if (key == 'vendor') {
      key = 'vendor_selection';
    }
    if (key == 'product') {
      key = 'product_selection';
    }
    if (key == 'upload') {
      key = 'upload_document';
    }
    if (key == 'ship_to_location') {
      key = 'ship_location';
    }
    if (key == 'challan_no') {
      key = 'challan_number';
    }
    const cfg = this.company_setup.gate_pass_additional_fields_configuration;
    if (!cfg.length) {
      return true;
    }
    const temp = cfg.filter((v: any) => v.id == key);
    if (!temp.length) {
      return false;
    }
    if (temp[0].is_disabled === true || temp[0].is_disabled === '1' || temp[0].is_disabled === 1 || temp[0].is_disabled === 'true') {
      return false;
    }
    const e = temp[0].enable;
    return e === true || e === '1' || e === 1 || e === 'true';
  }

  getGpFieldCustomName(key: string, defaultName: string): string {
    if (key == 'vendor') {
      key = 'vendor_selection';
    }
    if (key == 'ship_to_location') {
      key = 'ship_location';
    }
    if (key == 'challan_no') {
      key = 'challan_number';
    }
    const cfg = this.company_setup.gate_pass_additional_fields_configuration ? this.company_setup.gate_pass_additional_fields_configuration : [];
    if (!cfg.length) {
      return defaultName;
    }
    const temp = cfg.filter((v: any) => v.id == key);
    if (!temp.length) {
      return defaultName;
    }
    return temp[0].custom_name && temp[0].custom_name != '' ? temp[0].custom_name : defaultName;
  }

  gpUseShipLocationMode(): boolean {
    return this.gpFieldVisible('ship_location');
  }

  gpUseLobLocDeptMode(): boolean {
    return !this.gpUseShipLocationMode() && (this.gpFieldVisible('lob') || this.gpFieldVisible('location') || this.gpFieldVisible('department'));
  }

  gpDivItem(display: string, value: any, isView: boolean) {
    return {
      display: display,
      value: value != null && value !== undefined ? value : '',
      div_size: 'col-sm-2 div1',
      is_html: false,
      is_editable: false,
      is_disabled: true,
      is_view: isView,
      input_type: 'text'
    };
  }

  gpFormatDate(value: any): string {
    if (value == null || value === '') {
      return '';
    }
    return this.webService.formatDateAccordingToSetup(value, this.company_setup.in_invoice_date_format);
  }

  gpVisualCheckLabel(value: any): string {
    const v = value != null ? value.toString() : '';
    if (v === '1') {
      return 'Approve';
    }
    if (v === '2') {
      return 'Reject';
    }
    if (v === '3') {
      return 'Hold';
    }
    return v;
  }

  gpSecurityGuardLabel(value: any): string {
    const v = value != null ? value.toString() : '';
    if (v === '0') {
      return 'Security Guard';
    }
    if (v === '1') {
      return 'Employee';
    }
    return v;
  }

  gpLobLocDeptLabel(name: string, code: string): string {
    if (!name) {
      return '';
    }
    if (this.company_setup.hide_numaric_number_in_lob_loc_dep != '1' && code) {
      return name + ' (' + code + ')';
    }
    return name;
  }

  showGatePass(response) {
    response = response ? response : {};
    this.company_setup.gate_pass_additional_fields_configuration = this.company_setup.gate_pass_additional_fields_configuration ? this.company_setup.gate_pass_additional_fields_configuration : [];
    this.company_setup.custom_ship_location_name = this.getGpFieldCustomName('ship_location', this.company_setup.custom_ship_location_name || 'Ship Location');
    response.requested_by = response.requested_by_name ? response.requested_by_name : (response.requested_by ? response.requested_by : '');
    response.gate_pass_number = response.gate_pass_number ? response.gate_pass_number : (response.gate_pass_no ? response.gate_pass_no : '');
    response.gate_pass_date = this.gpFormatDate(response.gate_pass_date);
    response.challan_date = this.gpFormatDate(response.challan_date);
    response.invoice_date = this.gpFormatDate(response.invoice_date);
    response.other_date_1 = this.gpFormatDate(response.other_date_1);
    response.other_date_2 = this.gpFormatDate(response.other_date_2);
    response.challan_number = response.challan_no ? response.challan_no : (response.challan_number ? response.challan_number : '');
    response.ship_to_location = response.ship_to_location_name ? response.ship_to_location_name : (response.ship_to_location ? response.ship_to_location : '');
    response.vendor_display = response.fully_vendor_address ? response.fully_vendor_address : (response.vendor_name ? response.vendor_name : '');
    response.lob_detail = this.gpLobLocDeptLabel(response.lob_name, response.lob_code);
    response.loc_detail = this.gpLobLocDeptLabel(response.location_name || response.loc_name, response.location_code || response.loc_code);
    response.dept_detail = response.department_name
      ? response.department_name
      : this.gpLobLocDeptLabel(response.dept_name || response.ship_dept_name, response.dept_code || response.ship_dept_code);
    response.visual_check_status_name = this.gpVisualCheckLabel(response.visual_check_status);
    response.security_guard_employee_name = this.gpSecurityGuardLabel(response.security_guard_employee_type);
    response.material_category_display = response.material_category ? response.material_category : '';
    response.name_of_receiver = response.name_of_receiver ? response.name_of_receiver : (response.name_of_receiver_id ? response.name_of_receiver_id : '');
    const gpDecimal = this.company_setup.allowed_digits_after_decimal || '2';
    if (response.invoice_dc_value != null && response.invoice_dc_value !== '') {
      response.invoice_dc_value = this.webService.convertNaN(response.invoice_dc_value, gpDecimal);
    }
    if (response.total_quantity != null && response.total_quantity !== '') {
      response.total_quantity = this.webService.convertNaN(response.total_quantity, gpDecimal);
    }

    const items: any[] = [
      this.gpDivItem('Gate Pass No', response.gate_pass_number, true),
      this.gpDivItem('Gate Pass Date', response.gate_pass_date, true),
      this.gpDivItem('Requested By', response.requested_by, true),
      this.gpDivItem('Department', response.employee_department_name || response.requested_by_department_name || '', true),
      this.gpDivItem(this.getGpFieldCustomName('ship_location', this.company_setup.custom_ship_location_name || 'Ship Location'), response.ship_to_location, this.gpUseShipLocationMode()),
      this.gpDivItem(this.company_setup.custom_name_for_lob || 'LOB', response.lob_detail, this.gpUseLobLocDeptMode() && this.gpFieldVisible('lob')),
      this.gpDivItem(this.company_setup.custom_name_for_loc || 'Location', response.loc_detail, this.gpUseLobLocDeptMode() && this.gpFieldVisible('location')),
      this.gpDivItem(this.company_setup.custom_name_for_dept || 'Department', response.dept_detail, this.gpUseLobLocDeptMode() && this.gpFieldVisible('department')),
      this.gpDivItem(this.getGpFieldCustomName('vendor_selection', 'Vendor Selection'), response.vendor_display, this.gpFieldVisible('vendor_selection')),
      this.gpDivItem(this.getGpFieldCustomName('challan_number', 'Challan Number'), response.challan_number, this.gpFieldVisible('challan_number')),
      this.gpDivItem(this.getGpFieldCustomName('challan_date', 'Challan Date'), response.challan_date, this.gpFieldVisible('challan_date')),
      this.gpDivItem(this.getGpFieldCustomName('invoice_number', 'Invoice Number'), response.invoice_number, this.gpFieldVisible('invoice_number')),
      this.gpDivItem(this.getGpFieldCustomName('invoice_date', 'Invoice Date'), response.invoice_date, this.gpFieldVisible('invoice_date')),
      this.gpDivItem(this.getGpFieldCustomName('gate_entry_type', 'Gate Entry Type'), response.gate_entry_type, this.gpFieldVisible('gate_entry_type')),
      this.gpDivItem(this.getGpFieldCustomName('mode_of_transport', 'Mode of Transport'), response.mode_of_transport, this.gpFieldVisible('mode_of_transport')),
      this.gpDivItem(this.getGpFieldCustomName('transporter_name', 'Transporter Name'), response.transporter_name, this.gpFieldVisible('transporter_name')),
      this.gpDivItem(this.getGpFieldCustomName('transport_ref_no', 'Transport Ref No'), response.transport_ref_no, this.gpFieldVisible('transport_ref_no')),
      this.gpDivItem(this.getGpFieldCustomName('transporter_mobile_no', 'Transporter Mobile No'), response.transporter_mobile_no, this.gpFieldVisible('transporter_mobile_no')),
      this.gpDivItem(this.getGpFieldCustomName('contact_person_name', 'Contact Person Name'), response.contact_person_name, this.gpFieldVisible('contact_person_name')),
      this.gpDivItem(this.getGpFieldCustomName('contact_number', 'Contact Number'), response.contact_number, this.gpFieldVisible('contact_number')),
      this.gpDivItem(this.getGpFieldCustomName('invoice_dc_value', 'Invoice / DC Value'), response.invoice_dc_value, this.gpFieldVisible('invoice_dc_value')),
      this.gpDivItem(this.getGpFieldCustomName('material_category', 'Material Category'), response.material_category_display, this.gpFieldVisible('material_category')),
      this.gpDivItem(this.getGpFieldCustomName('unit_of_measure', 'Unit of Measure'), response.unit_of_measure, this.gpFieldVisible('unit_of_measure')),
      this.gpDivItem(this.getGpFieldCustomName('total_quantity', 'Total Quantity'), response.total_quantity, this.gpFieldVisible('total_quantity')),
      this.gpDivItem(this.getGpFieldCustomName('visual_check_status', 'Visual Check Status'), response.visual_check_status_name, this.gpFieldVisible('visual_check_status')),
      this.gpDivItem(this.getGpFieldCustomName('forwarded_to_receiving_department', 'Forwarded To Receiving Department'), response.forwarded_to_receiving_department, this.gpFieldVisible('forwarded_to_receiving_department')),
      this.gpDivItem(this.getGpFieldCustomName('forwarded_to_person', 'Forwarded To Person'), response.forwarded_to_person, this.gpFieldVisible('forwarded_to_person')),
      this.gpDivItem(this.getGpFieldCustomName('remarks', 'Remarks'), response.remarks, this.gpFieldVisible('remarks')),
      this.gpDivItem(this.getGpFieldCustomName('security_guard_employee', 'Security Guard / Employee'), response.security_guard_employee_name, this.gpFieldVisible('security_guard_employee')),
      this.gpDivItem(this.getGpFieldCustomName('name_of_receiver', 'Name of Receiver'), response.name_of_receiver, this.gpFieldVisible('name_of_receiver')),
      this.gpDivItem(this.getGpFieldCustomName('gate_entry_point_name', 'Gate Entry Point Name'), response.gate_entry_point_name, this.gpFieldVisible('gate_entry_point_name')),
      this.gpDivItem(this.getGpFieldCustomName('other_1', 'Other 1'), response.other_1, this.gpFieldVisible('other_1')),
      this.gpDivItem(this.getGpFieldCustomName('other_2', 'Other 2'), response.other_2, this.gpFieldVisible('other_2')),
      this.gpDivItem(this.getGpFieldCustomName('other_3', 'Other 3'), response.other_3, this.gpFieldVisible('other_3')),
      this.gpDivItem(this.getGpFieldCustomName('other_4', 'Other 4'), response.other_4, this.gpFieldVisible('other_4')),
      this.gpDivItem(this.getGpFieldCustomName('other_date_1', 'Other Date 1'), response.other_date_1, this.gpFieldVisible('other_date_1')),
      this.gpDivItem(this.getGpFieldCustomName('other_date_2', 'Other Date 2'), response.other_date_2, this.gpFieldVisible('other_date_2'))
    ];
    this.commonVariableList.divList.push.apply(this.commonVariableList.divList, items);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2618691350/src/src/app/generic-ui-components/generic-beforediv-list/generic-beforediv-list.component.ts